import { CompressedCategoryData } from './data.interfaces';
export const categories: CompressedCategoryData[] = [
  {
    id: 'people',
    name: 'Smileys & People',
    emojis: [
      {
        name: 'Grinning Face',
        unified: '1F600',
        text: ':D',
        keywords: ['face', 'smile', 'happy', 'joy', ':D', 'grin'],
        shortName: 'grinning'
      },
      {
        name: 'Smiling Face with Open Mouth',
        unified: '1F603',
        text: ':)',
        emoticons: ['=)', '=-)'],
        keywords: ['face', 'happy', 'joy', 'haha', ':D', ':)', 'smile', 'funny'],
        shortName: 'smiley'
      },
      {
        name: 'Smiling Face with Open Mouth and Smiling Eyes',
        unified: '1F604',
        text: ':)',
        emoticons: ['C:', 'c:', ':D', ':-D'],
        keywords: ['face', 'happy', 'joy', 'funny', 'haha', 'laugh', 'like', ':D', ':)'],
        shortName: 'smile'
      },
      {
        name: 'Grinning Face with Smiling Eyes',
        unified: '1F601',
        keywords: ['face', 'happy', 'smile', 'joy', 'kawaii'],
        shortName: 'grin'
      },
      {
        name: 'Smiling Face with Open Mouth and Tightly-Closed Eyes',
        unified: '1F606',
        emoticons: [':>', ':->'],
        keywords: ['happy', 'joy', 'lol', 'satisfied', 'haha', 'face', 'glad', 'XD', 'laugh'],
        shortNames: ['laughing', 'satisfied'],
        shortName: 'laughing'
      },
      {
        name: 'Smiling Face with Open Mouth and Cold Sweat',
        unified: '1F605',
        keywords: ['face', 'hot', 'happy', 'laugh', 'sweat', 'smile', 'relief'],
        shortName: 'sweat_smile'
      },
      {
        name: 'Rolling on the Floor Laughing',
        unified: '1F923',
        shortName: 'rolling_on_the_floor_laughing'
      },
      {
        name: 'Face with Tears of Joy',
        unified: '1F602',
        keywords: ['face', 'cry', 'tears', 'weep', 'happy', 'happytears', 'haha'],
        shortName: 'joy'
      },
      {
        name: 'Slightly Smiling Face',
        unified: '1F642',
        emoticons: [':)', '(:', ':-)'],
        keywords: ['face', 'smile'],
        shortName: 'slightly_smiling_face'
      },
      {
        name: 'Upside-Down Face',
        unified: '1F643',
        keywords: ['face', 'flipped', 'silly', 'smile'],
        shortName: 'upside_down_face'
      },
      {
        name: 'Winking Face',
        unified: '1F609',
        text: ';)',
        emoticons: [';)', ';-)'],
        keywords: ['face', 'happy', 'mischievous', 'secret', ';)', 'smile', 'eye'],
        shortName: 'wink'
      },
      {
        name: 'Smiling Face with Smiling Eyes',
        unified: '1F60A',
        text: ':)',
        keywords: ['face', 'smile', 'happy', 'flushed', 'crush', 'embarrassed', 'shy', 'joy'],
        shortName: 'blush'
      },
      {
        name: 'Smiling Face with Halo',
        unified: '1F607',
        keywords: ['face', 'angel', 'heaven', 'halo'],
        shortName: 'innocent'
      },
      {
        name: 'Smiling Face with Smiling Eyes and Three Hearts',
        unified: '1F970',
        shortName: 'smiling_face_with_3_hearts'
      },
      {
        name: 'Smiling Face with Heart-Shaped Eyes',
        unified: '1F60D',
        keywords: ['face', 'love', 'like', 'affection', 'valentines', 'infatuation', 'crush', 'heart'],
        shortName: 'heart_eyes'
      },
      {
        name: 'Grinning Face with Star Eyes',
        unified: '1F929',
        shortNames: ['star-struck', 'grinning_face_with_star_eyes'],
        shortName: 'star-struck'
      },
      {
        name: 'Face Throwing a Kiss',
        unified: '1F618',
        emoticons: [':*', ':-*'],
        keywords: ['face', 'love', 'like', 'affection', 'valentines', 'infatuation', 'kiss'],
        shortName: 'kissing_heart'
      },
      {
        name: 'Kissing Face',
        unified: '1F617',
        keywords: ['love', 'like', 'face', '3', 'valentines', 'infatuation', 'kiss'],
        shortName: 'kissing'
      },
      {
        name: 'Kissing Face with Closed Eyes',
        unified: '1F61A',
        keywords: ['face', 'love', 'like', 'affection', 'valentines', 'infatuation', 'kiss'],
        shortName: 'kissing_closed_eyes'
      },
      {
        name: 'Kissing Face with Smiling Eyes',
        unified: '1F619',
        keywords: ['face', 'affection', 'valentines', 'infatuation', 'kiss'],
        shortName: 'kissing_smiling_eyes'
      },
      {
        name: 'Face Savouring Delicious Food',
        unified: '1F60B',
        keywords: ['happy', 'joy', 'tongue', 'smile', 'face', 'silly', 'yummy', 'nom', 'delicious', 'savouring'],
        shortName: 'yum'
      },
      {
        name: 'Face with Stuck-out Tongue',
        unified: '1F61B',
        text: ':p',
        emoticons: [':p', ':-p', ':P', ':-P', ':b', ':-b'],
        keywords: ['face', 'prank', 'childish', 'playful', 'mischievous', 'smile', 'tongue'],
        shortName: 'stuck_out_tongue'
      },
      {
        name: 'Face with Stuck-out Tongue and Winking Eye',
        unified: '1F61C',
        text: ';p',
        emoticons: [';p', ';-p', ';b', ';-b', ';P', ';-P'],
        keywords: ['face', 'prank', 'childish', 'playful', 'mischievous', 'smile', 'wink', 'tongue'],
        shortName: 'stuck_out_tongue_winking_eye'
      },
      {
        name: 'Grinning Face with One Large and One Small Eye',
        unified: '1F92A',
        shortNames: ['zany_face', 'grinning_face_with_one_large_and_one_small_eye'],
        shortName: 'zany_face'
      },
      {
        name: 'Face with Stuck-out Tongue and Tightly-Closed Eyes',
        unified: '1F61D',
        keywords: ['face', 'prank', 'playful', 'mischievous', 'smile', 'tongue'],
        shortName: 'stuck_out_tongue_closed_eyes'
      },
      {
        name: 'Money-Mouth Face',
        unified: '1F911',
        keywords: ['face', 'rich', 'dollar', 'money'],
        shortName: 'money_mouth_face'
      },
      {
        name: 'Hugging Face',
        unified: '1F917',
        shortName: 'hugging_face'
      },
      {
        name: 'Smiling Face with Smiling Eyes and Hand Covering Mouth',
        unified: '1F92D',
        shortNames: ['face_with_hand_over_mouth', 'smiling_face_with_smiling_eyes_and_hand_covering_mouth'],
        shortName: 'face_with_hand_over_mouth'
      },
      {
        name: 'Face with Finger Covering Closed Lips',
        unified: '1F92B',
        shortNames: ['shushing_face', 'face_with_finger_covering_closed_lips'],
        shortName: 'shushing_face'
      },
      {
        name: 'Thinking Face',
        unified: '1F914',
        shortName: 'thinking_face'
      },
      {
        name: 'Zipper-Mouth Face',
        unified: '1F910',
        keywords: ['face', 'sealed', 'zipper', 'secret'],
        shortName: 'zipper_mouth_face'
      },
      {
        name: 'Face with One Eyebrow Raised',
        unified: '1F928',
        shortNames: ['face_with_raised_eyebrow', 'face_with_one_eyebrow_raised'],
        shortName: 'face_with_raised_eyebrow'
      },
      {
        name: 'Neutral Face',
        unified: '1F610',
        emoticons: [':|', ':-|'],
        keywords: ['indifference', 'meh', ':|', 'neutral'],
        shortName: 'neutral_face'
      },
      {
        name: 'Expressionless Face',
        unified: '1F611',
        keywords: ['face', 'indifferent', '-_-', 'meh', 'deadpan'],
        shortName: 'expressionless'
      },
      {
        name: 'Face Without Mouth',
        unified: '1F636',
        keywords: ['face', 'hellokitty'],
        shortName: 'no_mouth'
      },
      {
        name: 'Smirking Face',
        unified: '1F60F',
        keywords: ['face', 'smile', 'mean', 'prank', 'smug', 'sarcasm'],
        shortName: 'smirk'
      },
      {
        name: 'Unamused Face',
        unified: '1F612',
        text: ':(',
        keywords: [
          'indifference',
          'bored',
          'straight face',
          'serious',
          'sarcasm',
          'unimpressed',
          'skeptical',
          'dubious',
          'side_eye'
        ],
        shortName: 'unamused'
      },
      {
        name: 'Face with Rolling Eyes',
        unified: '1F644',
        shortName: 'face_with_rolling_eyes'
      },
      {
        name: 'Grimacing Face',
        unified: '1F62C',
        keywords: ['face', 'grimace', 'teeth'],
        shortName: 'grimacing'
      },
      {
        name: 'Lying Face',
        unified: '1F925',
        keywords: ['face', 'lie', 'pinocchio'],
        shortName: 'lying_face'
      },
      {
        name: 'Relieved Face',
        unified: '1F60C',
        keywords: ['face', 'relaxed', 'phew', 'massage', 'happiness'],
        shortName: 'relieved'
      },
      {
        name: 'Pensive Face',
        unified: '1F614',
        keywords: ['face', 'sad', 'depressed', 'upset'],
        shortName: 'pensive'
      },
      {
        name: 'Sleepy Face',
        unified: '1F62A',
        keywords: ['face', 'tired', 'rest', 'nap'],
        shortName: 'sleepy'
      },
      {
        name: 'Drooling Face',
        unified: '1F924',
        keywords: ['face'],
        shortName: 'drooling_face'
      },
      {
        name: 'Sleeping Face',
        unified: '1F634',
        keywords: ['face', 'tired', 'sleepy', 'night', 'zzz'],
        shortName: 'sleeping'
      },
      {
        name: 'Face with Medical Mask',
        unified: '1F637',
        keywords: ['face', 'sick', 'ill', 'disease'],
        shortName: 'mask'
      },
      {
        name: 'Face with Thermometer',
        unified: '1F912',
        keywords: ['sick', 'temperature', 'thermometer', 'cold', 'fever'],
        shortName: 'face_with_thermometer'
      },
      {
        name: 'Face with Head-Bandage',
        unified: '1F915',
        keywords: ['injured', 'clumsy', 'bandage', 'hurt'],
        shortName: 'face_with_head_bandage'
      },
      {
        name: 'Nauseated Face',
        unified: '1F922',
        keywords: ['face', 'vomit', 'gross', 'green', 'sick', 'throw up', 'ill'],
        shortName: 'nauseated_face'
      },
      {
        name: 'Face with Open Mouth Vomiting',
        unified: '1F92E',
        shortNames: ['face_vomiting', 'face_with_open_mouth_vomiting'],
        shortName: 'face_vomiting'
      },
      {
        name: 'Sneezing Face',
        unified: '1F927',
        keywords: ['face', 'gesundheit', 'sneeze', 'sick', 'allergy'],
        shortName: 'sneezing_face'
      },
      {
        name: 'Overheated Face',
        unified: '1F975',
        shortName: 'hot_face'
      },
      {
        name: 'Freezing Face',
        unified: '1F976',
        shortName: 'cold_face'
      },
      {
        name: 'Face with Uneven Eyes and Wavy Mouth',
        unified: '1F974',
        shortName: 'woozy_face'
      },
      {
        name: 'Dizzy Face',
        unified: '1F635',
        keywords: ['spent', 'unconscious', 'xox', 'dizzy'],
        shortName: 'dizzy_face'
      },
      {
        name: 'Shocked Face with Exploding Head',
        unified: '1F92F',
        keywords: ['face', 'shocked', 'mind', 'blown'],
        shortNames: ['exploding_head', 'shocked_face_with_exploding_head'],
        shortName: 'exploding_head'
      },
      {
        name: 'Face with Cowboy Hat',
        unified: '1F920',
        shortName: 'face_with_cowboy_hat'
      },
      {
        name: 'Face with Party Horn and Party Hat',
        unified: '1F973',
        shortName: 'partying_face'
      },
      {
        name: 'Smiling Face with Sunglasses',
        unified: '1F60E',
        emoticons: ['8)'],
        keywords: ['face', 'cool', 'smile', 'summer', 'beach', 'sunglass'],
        shortName: 'sunglasses'
      },
      {
        name: 'Nerd Face',
        unified: '1F913',
        keywords: ['face', 'nerdy', 'geek', 'dork'],
        shortName: 'nerd_face'
      },
      {
        name: 'Face with Monocle',
        unified: '1F9D0',
        shortName: 'face_with_monocle'
      },
      {
        name: 'Confused Face',
        unified: '1F615',
        emoticons: [':\\', ':-\\', ':/', ':-/'],
        keywords: ['face', 'indifference', 'huh', 'weird', 'hmmm', ':/'],
        shortName: 'confused'
      },
      {
        name: 'Worried Face',
        unified: '1F61F',
        keywords: ['face', 'concern', 'nervous', ':('],
        shortName: 'worried'
      },
      {
        name: 'Slightly Frowning Face',
        unified: '1F641',
        keywords: ['face', 'frowning', 'disappointed', 'sad', 'upset'],
        shortName: 'slightly_frowning_face'
      },
      {
        name: 'White Frowning Face',
        unified: '2639-FE0F',
        shortName: 'white_frowning_face'
      },
      {
        name: 'Face with Open Mouth',
        unified: '1F62E',
        emoticons: [':o', ':-o', ':O', ':-O'],
        keywords: ['face', 'surprise', 'impressed', 'wow', 'whoa', ':O'],
        shortName: 'open_mouth'
      },
      {
        name: 'Hushed Face',
        unified: '1F62F',
        keywords: ['face', 'woo', 'shh'],
        shortName: 'hushed'
      },
      {
        name: 'Astonished Face',
        unified: '1F632',
        keywords: ['face', 'xox', 'surprised', 'poisoned'],
        shortName: 'astonished'
      },
      {
        name: 'Flushed Face',
        unified: '1F633',
        keywords: ['face', 'blush', 'shy', 'flattered'],
        shortName: 'flushed'
      },
      {
        name: 'Face with Pleading Eyes',
        unified: '1F97A',
        shortName: 'pleading_face'
      },
      {
        name: 'Frowning Face with Open Mouth',
        unified: '1F626',
        keywords: ['face', 'aw', 'what'],
        shortName: 'frowning'
      },
      {
        name: 'Anguished Face',
        unified: '1F627',
        emoticons: ['D:'],
        keywords: ['face', 'stunned', 'nervous'],
        shortName: 'anguished'
      },
      {
        name: 'Fearful Face',
        unified: '1F628',
        keywords: ['face', 'scared', 'terrified', 'nervous', 'oops', 'huh'],
        shortName: 'fearful'
      },
      {
        name: 'Face with Open Mouth and Cold Sweat',
        unified: '1F630',
        keywords: ['face', 'nervous', 'sweat'],
        shortName: 'cold_sweat'
      },
      {
        name: 'Disappointed but Relieved Face',
        unified: '1F625',
        keywords: ['face', 'phew', 'sweat', 'nervous'],
        shortName: 'disappointed_relieved'
      },
      {
        name: 'Crying Face',
        unified: '1F622',
        text: ":'(",
        emoticons: [":'("],
        keywords: ['face', 'tears', 'sad', 'depressed', 'upset', ":'("],
        shortName: 'cry'
      },
      {
        name: 'Loudly Crying Face',
        unified: '1F62D',
        text: ":'(",
        keywords: ['face', 'cry', 'tears', 'sad', 'upset', 'depressed'],
        shortName: 'sob'
      },
      {
        name: 'Face Screaming in Fear',
        unified: '1F631',
        keywords: ['face', 'munch', 'scared', 'omg'],
        shortName: 'scream'
      },
      {
        name: 'Confounded Face',
        unified: '1F616',
        keywords: ['face', 'confused', 'sick', 'unwell', 'oops', ':S'],
        shortName: 'confounded'
      },
      {
        name: 'Persevering Face',
        unified: '1F623',
        keywords: ['face', 'sick', 'no', 'upset', 'oops'],
        shortName: 'persevere'
      },
      {
        name: 'Disappointed Face',
        unified: '1F61E',
        text: ':(',
        emoticons: ['):', ':(', ':-('],
        keywords: ['face', 'sad', 'upset', 'depressed', ':('],
        shortName: 'disappointed'
      },
      {
        name: 'Face with Cold Sweat',
        unified: '1F613',
        keywords: ['face', 'hot', 'sad', 'tired', 'exercise'],
        shortName: 'sweat'
      },
      {
        name: 'Weary Face',
        unified: '1F629',
        keywords: ['face', 'tired', 'sleepy', 'sad', 'frustrated', 'upset'],
        shortName: 'weary'
      },
      {
        name: 'Tired Face',
        unified: '1F62B',
        keywords: ['sick', 'whine', 'upset', 'frustrated'],
        shortName: 'tired_face'
      },
      {
        name: 'Yawning Face',
        unified: '1F971',
        shortName: 'yawning_face'
      },
      {
        name: 'Face with Look of Triumph',
        unified: '1F624',
        keywords: ['face', 'gas', 'phew', 'proud', 'pride'],
        shortName: 'triumph'
      },
      {
        name: 'Pouting Face',
        unified: '1F621',
        keywords: ['angry', 'mad', 'hate', 'despise'],
        shortName: 'rage'
      },
      {
        name: 'Angry Face',
        unified: '1F620',
        emoticons: ['>:(', '>:-('],
        keywords: ['mad', 'face', 'annoyed', 'frustrated'],
        shortName: 'angry'
      },
      {
        name: 'Serious Face with Symbols Covering Mouth',
        unified: '1F92C',
        shortNames: ['face_with_symbols_on_mouth', 'serious_face_with_symbols_covering_mouth'],
        shortName: 'face_with_symbols_on_mouth'
      },
      {
        name: 'Smiling Face with Horns',
        unified: '1F608',
        keywords: ['devil', 'horns'],
        shortName: 'smiling_imp'
      },
      {
        name: 'Imp',
        unified: '1F47F',
        keywords: ['devil', 'angry', 'horns'],
        shortName: 'imp'
      },
      {
        name: 'Skull',
        unified: '1F480',
        keywords: ['dead', 'skeleton', 'creepy', 'death'],
        shortName: 'skull'
      },
      {
        name: 'Skull and Crossbones',
        unified: '2620-FE0F',
        keywords: ['poison', 'danger', 'deadly', 'scary', 'death', 'pirate', 'evil'],
        shortName: 'skull_and_crossbones'
      },
      {
        name: 'Pile of Poo',
        unified: '1F4A9',
        shortNames: ['hankey', 'poop', 'shit'],
        shortName: 'hankey'
      },
      {
        name: 'Clown Face',
        unified: '1F921',
        keywords: ['face'],
        shortName: 'clown_face'
      },
      {
        name: 'Japanese Ogre',
        unified: '1F479',
        keywords: ['monster', 'red', 'mask', 'halloween', 'scary', 'creepy', 'devil', 'demon', 'japanese', 'ogre'],
        shortName: 'japanese_ogre'
      },
      {
        name: 'Japanese Goblin',
        unified: '1F47A',
        keywords: ['red', 'evil', 'mask', 'monster', 'scary', 'creepy', 'japanese', 'goblin'],
        shortName: 'japanese_goblin'
      },
      {
        name: 'Ghost',
        unified: '1F47B',
        keywords: ['halloween', 'spooky', 'scary'],
        shortName: 'ghost'
      },
      {
        name: 'Extraterrestrial Alien',
        unified: '1F47D',
        keywords: ['UFO', 'paul', 'weird', 'outer_space'],
        shortName: 'alien'
      },
      {
        name: 'Alien Monster',
        unified: '1F47E',
        keywords: ['game', 'arcade', 'play'],
        shortName: 'space_invader'
      },
      {
        name: 'Robot Face',
        unified: '1F916',
        shortName: 'robot_face'
      },
      {
        name: 'Smiling Cat Face with Open Mouth',
        unified: '1F63A',
        keywords: ['animal', 'cats', 'happy', 'smile'],
        shortName: 'smiley_cat'
      },
      {
        name: 'Grinning Cat Face with Smiling Eyes',
        unified: '1F638',
        keywords: ['animal', 'cats', 'smile'],
        shortName: 'smile_cat'
      },
      {
        name: 'Cat Face with Tears of Joy',
        unified: '1F639',
        keywords: ['animal', 'cats', 'haha', 'happy', 'tears'],
        shortName: 'joy_cat'
      },
      {
        name: 'Smiling Cat Face with Heart-Shaped Eyes',
        unified: '1F63B',
        keywords: ['animal', 'love', 'like', 'affection', 'cats', 'valentines', 'heart'],
        shortName: 'heart_eyes_cat'
      },
      {
        name: 'Cat Face with Wry Smile',
        unified: '1F63C',
        keywords: ['animal', 'cats', 'smirk'],
        shortName: 'smirk_cat'
      },
      {
        name: 'Kissing Cat Face with Closed Eyes',
        unified: '1F63D',
        keywords: ['animal', 'cats', 'kiss'],
        shortName: 'kissing_cat'
      },
      {
        name: 'Weary Cat Face',
        unified: '1F640',
        keywords: ['animal', 'cats', 'munch', 'scared', 'scream'],
        shortName: 'scream_cat'
      },
      {
        name: 'Crying Cat Face',
        unified: '1F63F',
        keywords: ['animal', 'tears', 'weep', 'sad', 'cats', 'upset', 'cry'],
        shortName: 'crying_cat_face'
      },
      {
        name: 'Pouting Cat Face',
        unified: '1F63E',
        keywords: ['animal', 'cats'],
        shortName: 'pouting_cat'
      },
      {
        name: 'See-No-Evil Monkey',
        unified: '1F648',
        keywords: ['monkey', 'animal', 'nature', 'haha'],
        shortName: 'see_no_evil'
      },
      {
        name: 'Hear-No-Evil Monkey',
        unified: '1F649',
        keywords: ['animal', 'monkey', 'nature'],
        shortName: 'hear_no_evil'
      },
      {
        name: 'Speak-No-Evil Monkey',
        unified: '1F64A',
        keywords: ['monkey', 'animal', 'nature', 'omg'],
        shortName: 'speak_no_evil'
      },
      {
        name: 'Waving Hand Sign',
        unified: '1F44B',
        keywords: ['hands', 'gesture', 'goodbye', 'solong', 'farewell', 'hello', 'hi', 'palm'],
        skinVariations: [
          {
            unified: '1F44B-1F3FB'
          },
          {
            unified: '1F44B-1F3FC'
          },
          {
            unified: '1F44B-1F3FD'
          },
          {
            unified: '1F44B-1F3FE'
          },
          {
            unified: '1F44B-1F3FF'
          }
        ],
        shortName: 'wave'
      },
      {
        name: 'Raised Back of Hand',
        unified: '1F91A',
        keywords: ['fingers', 'raised', 'backhand'],
        skinVariations: [
          {
            unified: '1F91A-1F3FB'
          },
          {
            unified: '1F91A-1F3FC'
          },
          {
            unified: '1F91A-1F3FD'
          },
          {
            unified: '1F91A-1F3FE'
          },
          {
            unified: '1F91A-1F3FF'
          }
        ],
        shortName: 'raised_back_of_hand'
      },
      {
        name: 'Raised Hand with Fingers Splayed',
        unified: '1F590-FE0F',
        keywords: ['hand', 'fingers', 'palm'],
        skinVariations: [
          {
            unified: '1F590-1F3FB'
          },
          {
            unified: '1F590-1F3FC'
          },
          {
            unified: '1F590-1F3FD'
          },
          {
            unified: '1F590-1F3FE'
          },
          {
            unified: '1F590-1F3FF'
          }
        ],
        shortName: 'raised_hand_with_fingers_splayed'
      },
      {
        name: 'Raised Hand',
        unified: '270B',
        skinVariations: [
          {
            unified: '270B-1F3FB'
          },
          {
            unified: '270B-1F3FC'
          },
          {
            unified: '270B-1F3FD'
          },
          {
            unified: '270B-1F3FE'
          },
          {
            unified: '270B-1F3FF'
          }
        ],
        shortNames: ['hand', 'raised_hand'],
        shortName: 'hand'
      },
      {
        name: 'Raised Hand with Part Between Middle and Ring Fingers',
        unified: '1F596',
        skinVariations: [
          {
            unified: '1F596-1F3FB'
          },
          {
            unified: '1F596-1F3FC'
          },
          {
            unified: '1F596-1F3FD'
          },
          {
            unified: '1F596-1F3FE'
          },
          {
            unified: '1F596-1F3FF'
          }
        ],
        shortName: 'spock-hand'
      },
      {
        name: 'Ok Hand Sign',
        unified: '1F44C',
        keywords: ['fingers', 'limbs', 'perfect', 'ok', 'okay'],
        skinVariations: [
          {
            unified: '1F44C-1F3FB'
          },
          {
            unified: '1F44C-1F3FC'
          },
          {
            unified: '1F44C-1F3FD'
          },
          {
            unified: '1F44C-1F3FE'
          },
          {
            unified: '1F44C-1F3FF'
          }
        ],
        shortName: 'ok_hand'
      },
      {
        name: 'Pinching Hand',
        unified: '1F90F',
        skinVariations: [
          {
            unified: '1F90F-1F3FB'
          },
          {
            unified: '1F90F-1F3FC'
          },
          {
            unified: '1F90F-1F3FD'
          },
          {
            unified: '1F90F-1F3FE'
          },
          {
            unified: '1F90F-1F3FF'
          }
        ],
        shortName: 'pinching_hand'
      },
      {
        name: 'Victory Hand',
        unified: '270C-FE0F',
        keywords: ['fingers', 'ohyeah', 'hand', 'peace', 'victory', 'two'],
        skinVariations: [
          {
            unified: '270C-1F3FB'
          },
          {
            unified: '270C-1F3FC'
          },
          {
            unified: '270C-1F3FD'
          },
          {
            unified: '270C-1F3FE'
          },
          {
            unified: '270C-1F3FF'
          }
        ],
        shortName: 'v'
      },
      {
        name: 'Hand with Index and Middle Fingers Crossed',
        unified: '1F91E',
        keywords: ['good', 'lucky'],
        skinVariations: [
          {
            unified: '1F91E-1F3FB'
          },
          {
            unified: '1F91E-1F3FC'
          },
          {
            unified: '1F91E-1F3FD'
          },
          {
            unified: '1F91E-1F3FE'
          },
          {
            unified: '1F91E-1F3FF'
          }
        ],
        shortNames: ['crossed_fingers', 'hand_with_index_and_middle_fingers_crossed'],
        shortName: 'crossed_fingers'
      },
      {
        name: 'I Love You Hand Sign',
        unified: '1F91F',
        skinVariations: [
          {
            unified: '1F91F-1F3FB'
          },
          {
            unified: '1F91F-1F3FC'
          },
          {
            unified: '1F91F-1F3FD'
          },
          {
            unified: '1F91F-1F3FE'
          },
          {
            unified: '1F91F-1F3FF'
          }
        ],
        shortName: 'i_love_you_hand_sign'
      },
      {
        name: 'Sign of the Horns',
        unified: '1F918',
        skinVariations: [
          {
            unified: '1F918-1F3FB'
          },
          {
            unified: '1F918-1F3FC'
          },
          {
            unified: '1F918-1F3FD'
          },
          {
            unified: '1F918-1F3FE'
          },
          {
            unified: '1F918-1F3FF'
          }
        ],
        shortNames: ['the_horns', 'sign_of_the_horns'],
        shortName: 'the_horns'
      },
      {
        name: 'Call Me Hand',
        unified: '1F919',
        keywords: ['hands', 'gesture'],
        skinVariations: [
          {
            unified: '1F919-1F3FB'
          },
          {
            unified: '1F919-1F3FC'
          },
          {
            unified: '1F919-1F3FD'
          },
          {
            unified: '1F919-1F3FE'
          },
          {
            unified: '1F919-1F3FF'
          }
        ],
        shortName: 'call_me_hand'
      },
      {
        name: 'White Left Pointing Backhand Index',
        unified: '1F448',
        keywords: ['direction', 'fingers', 'hand', 'left'],
        skinVariations: [
          {
            unified: '1F448-1F3FB'
          },
          {
            unified: '1F448-1F3FC'
          },
          {
            unified: '1F448-1F3FD'
          },
          {
            unified: '1F448-1F3FE'
          },
          {
            unified: '1F448-1F3FF'
          }
        ],
        shortName: 'point_left'
      },
      {
        name: 'White Right Pointing Backhand Index',
        unified: '1F449',
        keywords: ['fingers', 'hand', 'direction', 'right'],
        skinVariations: [
          {
            unified: '1F449-1F3FB'
          },
          {
            unified: '1F449-1F3FC'
          },
          {
            unified: '1F449-1F3FD'
          },
          {
            unified: '1F449-1F3FE'
          },
          {
            unified: '1F449-1F3FF'
          }
        ],
        shortName: 'point_right'
      },
      {
        name: 'White Up Pointing Backhand Index',
        unified: '1F446',
        keywords: ['fingers', 'hand', 'direction', 'up'],
        skinVariations: [
          {
            unified: '1F446-1F3FB'
          },
          {
            unified: '1F446-1F3FC'
          },
          {
            unified: '1F446-1F3FD'
          },
          {
            unified: '1F446-1F3FE'
          },
          {
            unified: '1F446-1F3FF'
          }
        ],
        shortName: 'point_up_2'
      },
      {
        name: 'Reversed Hand with Middle Finger Extended',
        unified: '1F595',
        skinVariations: [
          {
            unified: '1F595-1F3FB'
          },
          {
            unified: '1F595-1F3FC'
          },
          {
            unified: '1F595-1F3FD'
          },
          {
            unified: '1F595-1F3FE'
          },
          {
            unified: '1F595-1F3FF'
          }
        ],
        shortNames: ['middle_finger', 'reversed_hand_with_middle_finger_extended'],
        shortName: 'middle_finger'
      },
      {
        name: 'White Down Pointing Backhand Index',
        unified: '1F447',
        keywords: ['fingers', 'hand', 'direction', 'down'],
        skinVariations: [
          {
            unified: '1F447-1F3FB'
          },
          {
            unified: '1F447-1F3FC'
          },
          {
            unified: '1F447-1F3FD'
          },
          {
            unified: '1F447-1F3FE'
          },
          {
            unified: '1F447-1F3FF'
          }
        ],
        shortName: 'point_down'
      },
      {
        name: 'White Up Pointing Index',
        unified: '261D-FE0F',
        keywords: ['hand', 'fingers', 'direction', 'up'],
        skinVariations: [
          {
            unified: '261D-1F3FB'
          },
          {
            unified: '261D-1F3FC'
          },
          {
            unified: '261D-1F3FD'
          },
          {
            unified: '261D-1F3FE'
          },
          {
            unified: '261D-1F3FF'
          }
        ],
        shortName: 'point_up'
      },
      {
        name: 'Thumbs Up Sign',
        unified: '1F44D',
        keywords: ['thumbsup', 'yes', 'awesome', 'good', 'agree', 'accept', 'cool', 'hand', 'like'],
        skinVariations: [
          {
            unified: '1F44D-1F3FB'
          },
          {
            unified: '1F44D-1F3FC'
          },
          {
            unified: '1F44D-1F3FD'
          },
          {
            unified: '1F44D-1F3FE'
          },
          {
            unified: '1F44D-1F3FF'
          }
        ],
        shortNames: ['+1', 'thumbsup'],
        shortName: '+1'
      },
      {
        name: 'Thumbs Down Sign',
        unified: '1F44E',
        keywords: ['thumbsdown', 'no', 'dislike', 'hand'],
        skinVariations: [
          {
            unified: '1F44E-1F3FB'
          },
          {
            unified: '1F44E-1F3FC'
          },
          {
            unified: '1F44E-1F3FD'
          },
          {
            unified: '1F44E-1F3FE'
          },
          {
            unified: '1F44E-1F3FF'
          }
        ],
        shortNames: ['-1', 'thumbsdown'],
        shortName: '-1'
      },
      {
        name: 'Raised Fist',
        unified: '270A',
        keywords: ['fingers', 'hand', 'grasp'],
        skinVariations: [
          {
            unified: '270A-1F3FB'
          },
          {
            unified: '270A-1F3FC'
          },
          {
            unified: '270A-1F3FD'
          },
          {
            unified: '270A-1F3FE'
          },
          {
            unified: '270A-1F3FF'
          }
        ],
        shortName: 'fist'
      },
      {
        name: 'Fisted Hand Sign',
        unified: '1F44A',
        keywords: ['angry', 'violence', 'fist', 'hit', 'attack', 'hand'],
        skinVariations: [
          {
            unified: '1F44A-1F3FB'
          },
          {
            unified: '1F44A-1F3FC'
          },
          {
            unified: '1F44A-1F3FD'
          },
          {
            unified: '1F44A-1F3FE'
          },
          {
            unified: '1F44A-1F3FF'
          }
        ],
        shortNames: ['facepunch', 'punch'],
        shortName: 'facepunch'
      },
      {
        name: 'Left-Facing Fist',
        unified: '1F91B',
        skinVariations: [
          {
            unified: '1F91B-1F3FB'
          },
          {
            unified: '1F91B-1F3FC'
          },
          {
            unified: '1F91B-1F3FD'
          },
          {
            unified: '1F91B-1F3FE'
          },
          {
            unified: '1F91B-1F3FF'
          }
        ],
        shortName: 'left-facing_fist'
      },
      {
        name: 'Right-Facing Fist',
        unified: '1F91C',
        skinVariations: [
          {
            unified: '1F91C-1F3FB'
          },
          {
            unified: '1F91C-1F3FC'
          },
          {
            unified: '1F91C-1F3FD'
          },
          {
            unified: '1F91C-1F3FE'
          },
          {
            unified: '1F91C-1F3FF'
          }
        ],
        shortName: 'right-facing_fist'
      },
      {
        name: 'Clapping Hands Sign',
        unified: '1F44F',
        keywords: ['hands', 'praise', 'applause', 'congrats', 'yay'],
        skinVariations: [
          {
            unified: '1F44F-1F3FB'
          },
          {
            unified: '1F44F-1F3FC'
          },
          {
            unified: '1F44F-1F3FD'
          },
          {
            unified: '1F44F-1F3FE'
          },
          {
            unified: '1F44F-1F3FF'
          }
        ],
        shortName: 'clap'
      },
      {
        name: 'Person Raising Both Hands in Celebration',
        unified: '1F64C',
        keywords: ['gesture', 'hooray', 'yea', 'celebration', 'hands'],
        skinVariations: [
          {
            unified: '1F64C-1F3FB'
          },
          {
            unified: '1F64C-1F3FC'
          },
          {
            unified: '1F64C-1F3FD'
          },
          {
            unified: '1F64C-1F3FE'
          },
          {
            unified: '1F64C-1F3FF'
          }
        ],
        shortName: 'raised_hands'
      },
      {
        name: 'Open Hands Sign',
        unified: '1F450',
        keywords: ['fingers', 'butterfly', 'hands', 'open'],
        skinVariations: [
          {
            unified: '1F450-1F3FB'
          },
          {
            unified: '1F450-1F3FC'
          },
          {
            unified: '1F450-1F3FD'
          },
          {
            unified: '1F450-1F3FE'
          },
          {
            unified: '1F450-1F3FF'
          }
        ],
        shortName: 'open_hands'
      },
      {
        name: 'Palms Up Together',
        unified: '1F932',
        skinVariations: [
          {
            unified: '1F932-1F3FB'
          },
          {
            unified: '1F932-1F3FC'
          },
          {
            unified: '1F932-1F3FD'
          },
          {
            unified: '1F932-1F3FE'
          },
          {
            unified: '1F932-1F3FF'
          }
        ],
        shortName: 'palms_up_together'
      },
      {
        name: 'Handshake',
        unified: '1F91D',
        keywords: ['agreement', 'shake'],
        shortName: 'handshake'
      },
      {
        name: 'Person with Folded Hands',
        unified: '1F64F',
        keywords: ['please', 'hope', 'wish', 'namaste', 'highfive'],
        skinVariations: [
          {
            unified: '1F64F-1F3FB'
          },
          {
            unified: '1F64F-1F3FC'
          },
          {
            unified: '1F64F-1F3FD'
          },
          {
            unified: '1F64F-1F3FE'
          },
          {
            unified: '1F64F-1F3FF'
          }
        ],
        shortName: 'pray'
      },
      {
        name: 'Writing Hand',
        unified: '270D-FE0F',
        keywords: ['lower_left_ballpoint_pen', 'stationery', 'write', 'compose'],
        skinVariations: [
          {
            unified: '270D-1F3FB'
          },
          {
            unified: '270D-1F3FC'
          },
          {
            unified: '270D-1F3FD'
          },
          {
            unified: '270D-1F3FE'
          },
          {
            unified: '270D-1F3FF'
          }
        ],
        shortName: 'writing_hand'
      },
      {
        name: 'Nail Polish',
        unified: '1F485',
        keywords: ['beauty', 'manicure', 'finger', 'fashion', 'nail'],
        skinVariations: [
          {
            unified: '1F485-1F3FB'
          },
          {
            unified: '1F485-1F3FC'
          },
          {
            unified: '1F485-1F3FD'
          },
          {
            unified: '1F485-1F3FE'
          },
          {
            unified: '1F485-1F3FF'
          }
        ],
        shortName: 'nail_care'
      },
      {
        name: 'Selfie',
        unified: '1F933',
        keywords: ['camera', 'phone'],
        skinVariations: [
          {
            unified: '1F933-1F3FB'
          },
          {
            unified: '1F933-1F3FC'
          },
          {
            unified: '1F933-1F3FD'
          },
          {
            unified: '1F933-1F3FE'
          },
          {
            unified: '1F933-1F3FF'
          }
        ],
        shortName: 'selfie'
      },
      {
        name: 'Flexed Biceps',
        unified: '1F4AA',
        keywords: ['arm', 'flex', 'hand', 'summer', 'strong', 'biceps'],
        skinVariations: [
          {
            unified: '1F4AA-1F3FB'
          },
          {
            unified: '1F4AA-1F3FC'
          },
          {
            unified: '1F4AA-1F3FD'
          },
          {
            unified: '1F4AA-1F3FE'
          },
          {
            unified: '1F4AA-1F3FF'
          }
        ],
        shortName: 'muscle'
      },
      {
        name: 'Mechanical Arm',
        unified: '1F9BE',
        shortName: 'mechanical_arm'
      },
      {
        name: 'Mechanical Leg',
        unified: '1F9BF',
        shortName: 'mechanical_leg'
      },
      {
        name: 'Leg',
        unified: '1F9B5',
        keywords: ['kick', 'limb'],
        skinVariations: [
          {
            unified: '1F9B5-1F3FB'
          },
          {
            unified: '1F9B5-1F3FC'
          },
          {
            unified: '1F9B5-1F3FD'
          },
          {
            unified: '1F9B5-1F3FE'
          },
          {
            unified: '1F9B5-1F3FF'
          }
        ],
        shortName: 'leg'
      },
      {
        name: 'Foot',
        unified: '1F9B6',
        keywords: ['kick', 'stomp'],
        skinVariations: [
          {
            unified: '1F9B6-1F3FB'
          },
          {
            unified: '1F9B6-1F3FC'
          },
          {
            unified: '1F9B6-1F3FD'
          },
          {
            unified: '1F9B6-1F3FE'
          },
          {
            unified: '1F9B6-1F3FF'
          }
        ],
        shortName: 'foot'
      },
      {
        name: 'Ear',
        unified: '1F442',
        keywords: ['face', 'hear', 'sound', 'listen'],
        skinVariations: [
          {
            unified: '1F442-1F3FB'
          },
          {
            unified: '1F442-1F3FC'
          },
          {
            unified: '1F442-1F3FD'
          },
          {
            unified: '1F442-1F3FE'
          },
          {
            unified: '1F442-1F3FF'
          }
        ],
        shortName: 'ear'
      },
      {
        name: 'Ear with Hearing Aid',
        unified: '1F9BB',
        skinVariations: [
          {
            unified: '1F9BB-1F3FB'
          },
          {
            unified: '1F9BB-1F3FC'
          },
          {
            unified: '1F9BB-1F3FD'
          },
          {
            unified: '1F9BB-1F3FE'
          },
          {
            unified: '1F9BB-1F3FF'
          }
        ],
        shortName: 'ear_with_hearing_aid'
      },
      {
        name: 'Nose',
        unified: '1F443',
        keywords: ['smell', 'sniff'],
        skinVariations: [
          {
            unified: '1F443-1F3FB'
          },
          {
            unified: '1F443-1F3FC'
          },
          {
            unified: '1F443-1F3FD'
          },
          {
            unified: '1F443-1F3FE'
          },
          {
            unified: '1F443-1F3FF'
          }
        ],
        shortName: 'nose'
      },
      {
        name: 'Brain',
        unified: '1F9E0',
        keywords: ['smart', 'intelligent'],
        shortName: 'brain'
      },
      {
        name: 'Tooth',
        unified: '1F9B7',
        keywords: ['teeth', 'dentist'],
        shortName: 'tooth'
      },
      {
        name: 'Bone',
        unified: '1F9B4',
        keywords: ['skeleton'],
        shortName: 'bone'
      },
      {
        name: 'Eyes',
        unified: '1F440',
        keywords: ['look', 'watch', 'stalk', 'peek', 'see'],
        shortName: 'eyes'
      },
      {
        name: 'Eye',
        unified: '1F441-FE0F',
        keywords: ['face', 'look', 'see', 'watch', 'stare'],
        shortName: 'eye'
      },
      {
        name: 'Tongue',
        unified: '1F445',
        keywords: ['mouth', 'playful'],
        shortName: 'tongue'
      },
      {
        name: 'Mouth',
        unified: '1F444',
        keywords: ['mouth', 'kiss'],
        shortName: 'lips'
      },
      {
        name: 'Baby',
        unified: '1F476',
        keywords: ['child', 'boy', 'girl', 'toddler'],
        skinVariations: [
          {
            unified: '1F476-1F3FB'
          },
          {
            unified: '1F476-1F3FC'
          },
          {
            unified: '1F476-1F3FD'
          },
          {
            unified: '1F476-1F3FE'
          },
          {
            unified: '1F476-1F3FF'
          }
        ],
        shortName: 'baby'
      },
      {
        name: 'Child',
        unified: '1F9D2',
        keywords: ['gender-neutral', 'young'],
        skinVariations: [
          {
            unified: '1F9D2-1F3FB'
          },
          {
            unified: '1F9D2-1F3FC'
          },
          {
            unified: '1F9D2-1F3FD'
          },
          {
            unified: '1F9D2-1F3FE'
          },
          {
            unified: '1F9D2-1F3FF'
          }
        ],
        shortName: 'child'
      },
      {
        name: 'Boy',
        unified: '1F466',
        keywords: ['man', 'male', 'guy', 'teenager'],
        skinVariations: [
          {
            unified: '1F466-1F3FB'
          },
          {
            unified: '1F466-1F3FC'
          },
          {
            unified: '1F466-1F3FD'
          },
          {
            unified: '1F466-1F3FE'
          },
          {
            unified: '1F466-1F3FF'
          }
        ],
        shortName: 'boy'
      },
      {
        name: 'Girl',
        unified: '1F467',
        keywords: ['female', 'woman', 'teenager'],
        skinVariations: [
          {
            unified: '1F467-1F3FB'
          },
          {
            unified: '1F467-1F3FC'
          },
          {
            unified: '1F467-1F3FD'
          },
          {
            unified: '1F467-1F3FE'
          },
          {
            unified: '1F467-1F3FF'
          }
        ],
        shortName: 'girl'
      },
      {
        name: 'Adult',
        unified: '1F9D1',
        keywords: ['gender-neutral', 'person'],
        skinVariations: [
          {
            unified: '1F9D1-1F3FB'
          },
          {
            unified: '1F9D1-1F3FC'
          },
          {
            unified: '1F9D1-1F3FD'
          },
          {
            unified: '1F9D1-1F3FE'
          },
          {
            unified: '1F9D1-1F3FF'
          }
        ],
        shortName: 'adult'
      },
      {
        name: 'Person with Blond Hair',
        unified: '1F471',
        skinVariations: [
          {
            unified: '1F471-1F3FB'
          },
          {
            unified: '1F471-1F3FC'
          },
          {
            unified: '1F471-1F3FD'
          },
          {
            unified: '1F471-1F3FE'
          },
          {
            unified: '1F471-1F3FF'
          }
        ],
        shortName: 'person_with_blond_hair',
        obsoletedBy: '1F471-200D-2642-FE0F'
      },
      {
        name: 'Man',
        unified: '1F468',
        keywords: ['mustache', 'father', 'dad', 'guy', 'classy', 'sir', 'moustache'],
        skinVariations: [
          {
            unified: '1F468-1F3FB'
          },
          {
            unified: '1F468-1F3FC'
          },
          {
            unified: '1F468-1F3FD'
          },
          {
            unified: '1F468-1F3FE'
          },
          {
            unified: '1F468-1F3FF'
          }
        ],
        shortName: 'man'
      },
      {
        name: 'Bearded Person',
        unified: '1F9D4',
        keywords: ['person', 'bewhiskered'],
        skinVariations: [
          {
            unified: '1F9D4-1F3FB'
          },
          {
            unified: '1F9D4-1F3FC'
          },
          {
            unified: '1F9D4-1F3FD'
          },
          {
            unified: '1F9D4-1F3FE'
          },
          {
            unified: '1F9D4-1F3FF'
          }
        ],
        shortName: 'bearded_person'
      },
      {
        name: 'Red Haired Man',
        unified: '1F468-200D-1F9B0',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9B0'
          },
          {
            unified: '1F468-1F3FC-200D-1F9B0'
          },
          {
            unified: '1F468-1F3FD-200D-1F9B0'
          },
          {
            unified: '1F468-1F3FE-200D-1F9B0'
          },
          {
            unified: '1F468-1F3FF-200D-1F9B0'
          }
        ],
        shortName: 'red_haired_man'
      },
      {
        name: 'Curly Haired Man',
        unified: '1F468-200D-1F9B1',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9B1'
          },
          {
            unified: '1F468-1F3FC-200D-1F9B1'
          },
          {
            unified: '1F468-1F3FD-200D-1F9B1'
          },
          {
            unified: '1F468-1F3FE-200D-1F9B1'
          },
          {
            unified: '1F468-1F3FF-200D-1F9B1'
          }
        ],
        shortName: 'curly_haired_man'
      },
      {
        name: 'White Haired Man',
        unified: '1F468-200D-1F9B3',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9B3'
          },
          {
            unified: '1F468-1F3FC-200D-1F9B3'
          },
          {
            unified: '1F468-1F3FD-200D-1F9B3'
          },
          {
            unified: '1F468-1F3FE-200D-1F9B3'
          },
          {
            unified: '1F468-1F3FF-200D-1F9B3'
          }
        ],
        shortName: 'white_haired_man'
      },
      {
        name: 'Bald Man',
        unified: '1F468-200D-1F9B2',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9B2'
          },
          {
            unified: '1F468-1F3FC-200D-1F9B2'
          },
          {
            unified: '1F468-1F3FD-200D-1F9B2'
          },
          {
            unified: '1F468-1F3FE-200D-1F9B2'
          },
          {
            unified: '1F468-1F3FF-200D-1F9B2'
          }
        ],
        shortName: 'bald_man'
      },
      {
        name: 'Woman',
        unified: '1F469',
        keywords: ['female', 'girls', 'lady'],
        skinVariations: [
          {
            unified: '1F469-1F3FB'
          },
          {
            unified: '1F469-1F3FC'
          },
          {
            unified: '1F469-1F3FD'
          },
          {
            unified: '1F469-1F3FE'
          },
          {
            unified: '1F469-1F3FF'
          }
        ],
        shortName: 'woman'
      },
      {
        name: 'Red Haired Woman',
        unified: '1F469-200D-1F9B0',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9B0'
          },
          {
            unified: '1F469-1F3FC-200D-1F9B0'
          },
          {
            unified: '1F469-1F3FD-200D-1F9B0'
          },
          {
            unified: '1F469-1F3FE-200D-1F9B0'
          },
          {
            unified: '1F469-1F3FF-200D-1F9B0'
          }
        ],
        shortName: 'red_haired_woman'
      },
      {
        name: 'Curly Haired Woman',
        unified: '1F469-200D-1F9B1',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9B1'
          },
          {
            unified: '1F469-1F3FC-200D-1F9B1'
          },
          {
            unified: '1F469-1F3FD-200D-1F9B1'
          },
          {
            unified: '1F469-1F3FE-200D-1F9B1'
          },
          {
            unified: '1F469-1F3FF-200D-1F9B1'
          }
        ],
        shortName: 'curly_haired_woman'
      },
      {
        name: 'White Haired Woman',
        unified: '1F469-200D-1F9B3',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9B3'
          },
          {
            unified: '1F469-1F3FC-200D-1F9B3'
          },
          {
            unified: '1F469-1F3FD-200D-1F9B3'
          },
          {
            unified: '1F469-1F3FE-200D-1F9B3'
          },
          {
            unified: '1F469-1F3FF-200D-1F9B3'
          }
        ],
        shortName: 'white_haired_woman'
      },
      {
        name: 'Bald Woman',
        unified: '1F469-200D-1F9B2',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9B2'
          },
          {
            unified: '1F469-1F3FC-200D-1F9B2'
          },
          {
            unified: '1F469-1F3FD-200D-1F9B2'
          },
          {
            unified: '1F469-1F3FE-200D-1F9B2'
          },
          {
            unified: '1F469-1F3FF-200D-1F9B2'
          }
        ],
        shortName: 'bald_woman'
      },
      {
        name: 'Blond Haired Woman',
        unified: '1F471-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F471-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F471-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F471-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F471-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F471-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'blond-haired-woman'
      },
      {
        name: 'Blond Haired Man',
        unified: '1F471-200D-2642-FE0F',
        obsoletes: '1F471',
        skinVariations: [
          {
            unified: '1F471-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F471-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F471-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F471-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F471-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'blond-haired-man'
      },
      {
        name: 'Older Adult',
        unified: '1F9D3',
        keywords: ['human', 'elder', 'senior', 'gender-neutral'],
        skinVariations: [
          {
            unified: '1F9D3-1F3FB'
          },
          {
            unified: '1F9D3-1F3FC'
          },
          {
            unified: '1F9D3-1F3FD'
          },
          {
            unified: '1F9D3-1F3FE'
          },
          {
            unified: '1F9D3-1F3FF'
          }
        ],
        shortName: 'older_adult'
      },
      {
        name: 'Older Man',
        unified: '1F474',
        keywords: ['human', 'male', 'men', 'old', 'elder', 'senior'],
        skinVariations: [
          {
            unified: '1F474-1F3FB'
          },
          {
            unified: '1F474-1F3FC'
          },
          {
            unified: '1F474-1F3FD'
          },
          {
            unified: '1F474-1F3FE'
          },
          {
            unified: '1F474-1F3FF'
          }
        ],
        shortName: 'older_man'
      },
      {
        name: 'Older Woman',
        unified: '1F475',
        keywords: ['human', 'female', 'women', 'lady', 'old', 'elder', 'senior'],
        skinVariations: [
          {
            unified: '1F475-1F3FB'
          },
          {
            unified: '1F475-1F3FC'
          },
          {
            unified: '1F475-1F3FD'
          },
          {
            unified: '1F475-1F3FE'
          },
          {
            unified: '1F475-1F3FF'
          }
        ],
        shortName: 'older_woman'
      },
      {
        name: 'Person Frowning',
        unified: '1F64D',
        skinVariations: [
          {
            unified: '1F64D-1F3FB'
          },
          {
            unified: '1F64D-1F3FC'
          },
          {
            unified: '1F64D-1F3FD'
          },
          {
            unified: '1F64D-1F3FE'
          },
          {
            unified: '1F64D-1F3FF'
          }
        ],
        shortName: 'person_frowning',
        obsoletedBy: '1F64D-200D-2640-FE0F'
      },
      {
        name: 'Man Frowning',
        unified: '1F64D-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F64D-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F64D-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F64D-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F64D-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F64D-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-frowning'
      },
      {
        name: 'Woman Frowning',
        unified: '1F64D-200D-2640-FE0F',
        obsoletes: '1F64D',
        skinVariations: [
          {
            unified: '1F64D-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F64D-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F64D-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F64D-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F64D-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-frowning'
      },
      {
        name: 'Person with Pouting Face',
        unified: '1F64E',
        skinVariations: [
          {
            unified: '1F64E-1F3FB'
          },
          {
            unified: '1F64E-1F3FC'
          },
          {
            unified: '1F64E-1F3FD'
          },
          {
            unified: '1F64E-1F3FE'
          },
          {
            unified: '1F64E-1F3FF'
          }
        ],
        shortName: 'person_with_pouting_face',
        obsoletedBy: '1F64E-200D-2640-FE0F'
      },
      {
        name: 'Man Pouting',
        unified: '1F64E-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F64E-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F64E-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F64E-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F64E-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F64E-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-pouting'
      },
      {
        name: 'Woman Pouting',
        unified: '1F64E-200D-2640-FE0F',
        obsoletes: '1F64E',
        skinVariations: [
          {
            unified: '1F64E-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F64E-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F64E-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F64E-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F64E-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-pouting'
      },
      {
        name: 'Face with No Good Gesture',
        unified: '1F645',
        skinVariations: [
          {
            unified: '1F645-1F3FB'
          },
          {
            unified: '1F645-1F3FC'
          },
          {
            unified: '1F645-1F3FD'
          },
          {
            unified: '1F645-1F3FE'
          },
          {
            unified: '1F645-1F3FF'
          }
        ],
        shortName: 'no_good',
        obsoletedBy: '1F645-200D-2640-FE0F'
      },
      {
        name: 'Man Gesturing No',
        unified: '1F645-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F645-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F645-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F645-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F645-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F645-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-gesturing-no'
      },
      {
        name: 'Woman Gesturing No',
        unified: '1F645-200D-2640-FE0F',
        obsoletes: '1F645',
        skinVariations: [
          {
            unified: '1F645-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F645-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F645-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F645-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F645-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-gesturing-no'
      },
      {
        name: 'Face with Ok Gesture',
        unified: '1F646',
        keywords: ['women', 'girl', 'female', 'pink', 'human', 'woman'],
        skinVariations: [
          {
            unified: '1F646-1F3FB'
          },
          {
            unified: '1F646-1F3FC'
          },
          {
            unified: '1F646-1F3FD'
          },
          {
            unified: '1F646-1F3FE'
          },
          {
            unified: '1F646-1F3FF'
          }
        ],
        shortName: 'ok_woman',
        obsoletedBy: '1F646-200D-2640-FE0F'
      },
      {
        name: 'Man Gesturing Ok',
        unified: '1F646-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F646-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F646-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F646-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F646-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F646-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-gesturing-ok'
      },
      {
        name: 'Woman Gesturing Ok',
        unified: '1F646-200D-2640-FE0F',
        obsoletes: '1F646',
        skinVariations: [
          {
            unified: '1F646-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F646-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F646-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F646-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F646-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-gesturing-ok'
      },
      {
        name: 'Information Desk Person',
        unified: '1F481',
        skinVariations: [
          {
            unified: '1F481-1F3FB'
          },
          {
            unified: '1F481-1F3FC'
          },
          {
            unified: '1F481-1F3FD'
          },
          {
            unified: '1F481-1F3FE'
          },
          {
            unified: '1F481-1F3FF'
          }
        ],
        shortName: 'information_desk_person',
        obsoletedBy: '1F481-200D-2640-FE0F'
      },
      {
        name: 'Man Tipping Hand',
        unified: '1F481-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F481-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F481-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F481-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F481-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F481-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-tipping-hand'
      },
      {
        name: 'Woman Tipping Hand',
        unified: '1F481-200D-2640-FE0F',
        obsoletes: '1F481',
        skinVariations: [
          {
            unified: '1F481-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F481-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F481-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F481-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F481-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-tipping-hand'
      },
      {
        name: 'Happy Person Raising One Hand',
        unified: '1F64B',
        skinVariations: [
          {
            unified: '1F64B-1F3FB'
          },
          {
            unified: '1F64B-1F3FC'
          },
          {
            unified: '1F64B-1F3FD'
          },
          {
            unified: '1F64B-1F3FE'
          },
          {
            unified: '1F64B-1F3FF'
          }
        ],
        shortName: 'raising_hand',
        obsoletedBy: '1F64B-200D-2640-FE0F'
      },
      {
        name: 'Man Raising Hand',
        unified: '1F64B-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F64B-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F64B-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F64B-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F64B-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F64B-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-raising-hand'
      },
      {
        name: 'Woman Raising Hand',
        unified: '1F64B-200D-2640-FE0F',
        obsoletes: '1F64B',
        skinVariations: [
          {
            unified: '1F64B-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F64B-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F64B-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F64B-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F64B-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-raising-hand'
      },
      {
        name: 'Deaf Person',
        unified: '1F9CF',
        skinVariations: [
          {
            unified: '1F9CF-1F3FB'
          },
          {
            unified: '1F9CF-1F3FC'
          },
          {
            unified: '1F9CF-1F3FD'
          },
          {
            unified: '1F9CF-1F3FE'
          },
          {
            unified: '1F9CF-1F3FF'
          }
        ],
        shortName: 'deaf_person'
      },
      {
        name: 'Deaf Man',
        unified: '1F9CF-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9CF-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9CF-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9CF-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9CF-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9CF-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'deaf_man'
      },
      {
        name: 'Deaf Woman',
        unified: '1F9CF-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F9CF-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9CF-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9CF-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9CF-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9CF-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'deaf_woman'
      },
      {
        name: 'Person Bowing Deeply',
        unified: '1F647',
        skinVariations: [
          {
            unified: '1F647-1F3FB'
          },
          {
            unified: '1F647-1F3FC'
          },
          {
            unified: '1F647-1F3FD'
          },
          {
            unified: '1F647-1F3FE'
          },
          {
            unified: '1F647-1F3FF'
          }
        ],
        shortName: 'bow',
        obsoletedBy: '1F647-200D-2642-FE0F'
      },
      {
        name: 'Man Bowing',
        unified: '1F647-200D-2642-FE0F',
        obsoletes: '1F647',
        skinVariations: [
          {
            unified: '1F647-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F647-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F647-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F647-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F647-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-bowing'
      },
      {
        name: 'Woman Bowing',
        unified: '1F647-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F647-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F647-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F647-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F647-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F647-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-bowing'
      },
      {
        name: 'Face Palm',
        unified: '1F926',
        skinVariations: [
          {
            unified: '1F926-1F3FB'
          },
          {
            unified: '1F926-1F3FC'
          },
          {
            unified: '1F926-1F3FD'
          },
          {
            unified: '1F926-1F3FE'
          },
          {
            unified: '1F926-1F3FF'
          }
        ],
        shortName: 'face_palm'
      },
      {
        name: 'Man Facepalming',
        unified: '1F926-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F926-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F926-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F926-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F926-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F926-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-facepalming'
      },
      {
        name: 'Woman Facepalming',
        unified: '1F926-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F926-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F926-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F926-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F926-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F926-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-facepalming'
      },
      {
        name: 'Shrug',
        unified: '1F937',
        skinVariations: [
          {
            unified: '1F937-1F3FB'
          },
          {
            unified: '1F937-1F3FC'
          },
          {
            unified: '1F937-1F3FD'
          },
          {
            unified: '1F937-1F3FE'
          },
          {
            unified: '1F937-1F3FF'
          }
        ],
        shortName: 'shrug'
      },
      {
        name: 'Man Shrugging',
        unified: '1F937-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F937-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F937-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F937-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F937-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F937-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-shrugging'
      },
      {
        name: 'Woman Shrugging',
        unified: '1F937-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F937-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F937-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F937-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F937-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F937-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-shrugging'
      },
      {
        name: 'Male Doctor',
        unified: '1F468-200D-2695-FE0F',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-2695-FE0F'
          },
          {
            unified: '1F468-1F3FC-200D-2695-FE0F'
          },
          {
            unified: '1F468-1F3FD-200D-2695-FE0F'
          },
          {
            unified: '1F468-1F3FE-200D-2695-FE0F'
          },
          {
            unified: '1F468-1F3FF-200D-2695-FE0F'
          }
        ],
        shortName: 'male-doctor'
      },
      {
        name: 'Female Doctor',
        unified: '1F469-200D-2695-FE0F',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-2695-FE0F'
          },
          {
            unified: '1F469-1F3FC-200D-2695-FE0F'
          },
          {
            unified: '1F469-1F3FD-200D-2695-FE0F'
          },
          {
            unified: '1F469-1F3FE-200D-2695-FE0F'
          },
          {
            unified: '1F469-1F3FF-200D-2695-FE0F'
          }
        ],
        shortName: 'female-doctor'
      },
      {
        name: 'Male Student',
        unified: '1F468-200D-1F393',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F393'
          },
          {
            unified: '1F468-1F3FC-200D-1F393'
          },
          {
            unified: '1F468-1F3FD-200D-1F393'
          },
          {
            unified: '1F468-1F3FE-200D-1F393'
          },
          {
            unified: '1F468-1F3FF-200D-1F393'
          }
        ],
        shortName: 'male-student'
      },
      {
        name: 'Female Student',
        unified: '1F469-200D-1F393',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F393'
          },
          {
            unified: '1F469-1F3FC-200D-1F393'
          },
          {
            unified: '1F469-1F3FD-200D-1F393'
          },
          {
            unified: '1F469-1F3FE-200D-1F393'
          },
          {
            unified: '1F469-1F3FF-200D-1F393'
          }
        ],
        shortName: 'female-student'
      },
      {
        name: 'Male Teacher',
        unified: '1F468-200D-1F3EB',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F3EB'
          },
          {
            unified: '1F468-1F3FC-200D-1F3EB'
          },
          {
            unified: '1F468-1F3FD-200D-1F3EB'
          },
          {
            unified: '1F468-1F3FE-200D-1F3EB'
          },
          {
            unified: '1F468-1F3FF-200D-1F3EB'
          }
        ],
        shortName: 'male-teacher'
      },
      {
        name: 'Female Teacher',
        unified: '1F469-200D-1F3EB',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F3EB'
          },
          {
            unified: '1F469-1F3FC-200D-1F3EB'
          },
          {
            unified: '1F469-1F3FD-200D-1F3EB'
          },
          {
            unified: '1F469-1F3FE-200D-1F3EB'
          },
          {
            unified: '1F469-1F3FF-200D-1F3EB'
          }
        ],
        shortName: 'female-teacher'
      },
      {
        name: 'Male Judge',
        unified: '1F468-200D-2696-FE0F',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-2696-FE0F'
          },
          {
            unified: '1F468-1F3FC-200D-2696-FE0F'
          },
          {
            unified: '1F468-1F3FD-200D-2696-FE0F'
          },
          {
            unified: '1F468-1F3FE-200D-2696-FE0F'
          },
          {
            unified: '1F468-1F3FF-200D-2696-FE0F'
          }
        ],
        shortName: 'male-judge'
      },
      {
        name: 'Female Judge',
        unified: '1F469-200D-2696-FE0F',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-2696-FE0F'
          },
          {
            unified: '1F469-1F3FC-200D-2696-FE0F'
          },
          {
            unified: '1F469-1F3FD-200D-2696-FE0F'
          },
          {
            unified: '1F469-1F3FE-200D-2696-FE0F'
          },
          {
            unified: '1F469-1F3FF-200D-2696-FE0F'
          }
        ],
        shortName: 'female-judge'
      },
      {
        name: 'Male Farmer',
        unified: '1F468-200D-1F33E',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F33E'
          },
          {
            unified: '1F468-1F3FC-200D-1F33E'
          },
          {
            unified: '1F468-1F3FD-200D-1F33E'
          },
          {
            unified: '1F468-1F3FE-200D-1F33E'
          },
          {
            unified: '1F468-1F3FF-200D-1F33E'
          }
        ],
        shortName: 'male-farmer'
      },
      {
        name: 'Female Farmer',
        unified: '1F469-200D-1F33E',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F33E'
          },
          {
            unified: '1F469-1F3FC-200D-1F33E'
          },
          {
            unified: '1F469-1F3FD-200D-1F33E'
          },
          {
            unified: '1F469-1F3FE-200D-1F33E'
          },
          {
            unified: '1F469-1F3FF-200D-1F33E'
          }
        ],
        shortName: 'female-farmer'
      },
      {
        name: 'Male Cook',
        unified: '1F468-200D-1F373',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F373'
          },
          {
            unified: '1F468-1F3FC-200D-1F373'
          },
          {
            unified: '1F468-1F3FD-200D-1F373'
          },
          {
            unified: '1F468-1F3FE-200D-1F373'
          },
          {
            unified: '1F468-1F3FF-200D-1F373'
          }
        ],
        shortName: 'male-cook'
      },
      {
        name: 'Female Cook',
        unified: '1F469-200D-1F373',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F373'
          },
          {
            unified: '1F469-1F3FC-200D-1F373'
          },
          {
            unified: '1F469-1F3FD-200D-1F373'
          },
          {
            unified: '1F469-1F3FE-200D-1F373'
          },
          {
            unified: '1F469-1F3FF-200D-1F373'
          }
        ],
        shortName: 'female-cook'
      },
      {
        name: 'Male Mechanic',
        unified: '1F468-200D-1F527',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F527'
          },
          {
            unified: '1F468-1F3FC-200D-1F527'
          },
          {
            unified: '1F468-1F3FD-200D-1F527'
          },
          {
            unified: '1F468-1F3FE-200D-1F527'
          },
          {
            unified: '1F468-1F3FF-200D-1F527'
          }
        ],
        shortName: 'male-mechanic'
      },
      {
        name: 'Female Mechanic',
        unified: '1F469-200D-1F527',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F527'
          },
          {
            unified: '1F469-1F3FC-200D-1F527'
          },
          {
            unified: '1F469-1F3FD-200D-1F527'
          },
          {
            unified: '1F469-1F3FE-200D-1F527'
          },
          {
            unified: '1F469-1F3FF-200D-1F527'
          }
        ],
        shortName: 'female-mechanic'
      },
      {
        name: 'Male Factory Worker',
        unified: '1F468-200D-1F3ED',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F3ED'
          },
          {
            unified: '1F468-1F3FC-200D-1F3ED'
          },
          {
            unified: '1F468-1F3FD-200D-1F3ED'
          },
          {
            unified: '1F468-1F3FE-200D-1F3ED'
          },
          {
            unified: '1F468-1F3FF-200D-1F3ED'
          }
        ],
        shortName: 'male-factory-worker'
      },
      {
        name: 'Female Factory Worker',
        unified: '1F469-200D-1F3ED',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F3ED'
          },
          {
            unified: '1F469-1F3FC-200D-1F3ED'
          },
          {
            unified: '1F469-1F3FD-200D-1F3ED'
          },
          {
            unified: '1F469-1F3FE-200D-1F3ED'
          },
          {
            unified: '1F469-1F3FF-200D-1F3ED'
          }
        ],
        shortName: 'female-factory-worker'
      },
      {
        name: 'Male Office Worker',
        unified: '1F468-200D-1F4BC',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F4BC'
          },
          {
            unified: '1F468-1F3FC-200D-1F4BC'
          },
          {
            unified: '1F468-1F3FD-200D-1F4BC'
          },
          {
            unified: '1F468-1F3FE-200D-1F4BC'
          },
          {
            unified: '1F468-1F3FF-200D-1F4BC'
          }
        ],
        shortName: 'male-office-worker'
      },
      {
        name: 'Female Office Worker',
        unified: '1F469-200D-1F4BC',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F4BC'
          },
          {
            unified: '1F469-1F3FC-200D-1F4BC'
          },
          {
            unified: '1F469-1F3FD-200D-1F4BC'
          },
          {
            unified: '1F469-1F3FE-200D-1F4BC'
          },
          {
            unified: '1F469-1F3FF-200D-1F4BC'
          }
        ],
        shortName: 'female-office-worker'
      },
      {
        name: 'Male Scientist',
        unified: '1F468-200D-1F52C',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F52C'
          },
          {
            unified: '1F468-1F3FC-200D-1F52C'
          },
          {
            unified: '1F468-1F3FD-200D-1F52C'
          },
          {
            unified: '1F468-1F3FE-200D-1F52C'
          },
          {
            unified: '1F468-1F3FF-200D-1F52C'
          }
        ],
        shortName: 'male-scientist'
      },
      {
        name: 'Female Scientist',
        unified: '1F469-200D-1F52C',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F52C'
          },
          {
            unified: '1F469-1F3FC-200D-1F52C'
          },
          {
            unified: '1F469-1F3FD-200D-1F52C'
          },
          {
            unified: '1F469-1F3FE-200D-1F52C'
          },
          {
            unified: '1F469-1F3FF-200D-1F52C'
          }
        ],
        shortName: 'female-scientist'
      },
      {
        name: 'Male Technologist',
        unified: '1F468-200D-1F4BB',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F4BB'
          },
          {
            unified: '1F468-1F3FC-200D-1F4BB'
          },
          {
            unified: '1F468-1F3FD-200D-1F4BB'
          },
          {
            unified: '1F468-1F3FE-200D-1F4BB'
          },
          {
            unified: '1F468-1F3FF-200D-1F4BB'
          }
        ],
        shortName: 'male-technologist'
      },
      {
        name: 'Female Technologist',
        unified: '1F469-200D-1F4BB',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F4BB'
          },
          {
            unified: '1F469-1F3FC-200D-1F4BB'
          },
          {
            unified: '1F469-1F3FD-200D-1F4BB'
          },
          {
            unified: '1F469-1F3FE-200D-1F4BB'
          },
          {
            unified: '1F469-1F3FF-200D-1F4BB'
          }
        ],
        shortName: 'female-technologist'
      },
      {
        name: 'Male Singer',
        unified: '1F468-200D-1F3A4',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F3A4'
          },
          {
            unified: '1F468-1F3FC-200D-1F3A4'
          },
          {
            unified: '1F468-1F3FD-200D-1F3A4'
          },
          {
            unified: '1F468-1F3FE-200D-1F3A4'
          },
          {
            unified: '1F468-1F3FF-200D-1F3A4'
          }
        ],
        shortName: 'male-singer'
      },
      {
        name: 'Female Singer',
        unified: '1F469-200D-1F3A4',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F3A4'
          },
          {
            unified: '1F469-1F3FC-200D-1F3A4'
          },
          {
            unified: '1F469-1F3FD-200D-1F3A4'
          },
          {
            unified: '1F469-1F3FE-200D-1F3A4'
          },
          {
            unified: '1F469-1F3FF-200D-1F3A4'
          }
        ],
        shortName: 'female-singer'
      },
      {
        name: 'Male Artist',
        unified: '1F468-200D-1F3A8',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F3A8'
          },
          {
            unified: '1F468-1F3FC-200D-1F3A8'
          },
          {
            unified: '1F468-1F3FD-200D-1F3A8'
          },
          {
            unified: '1F468-1F3FE-200D-1F3A8'
          },
          {
            unified: '1F468-1F3FF-200D-1F3A8'
          }
        ],
        shortName: 'male-artist'
      },
      {
        name: 'Female Artist',
        unified: '1F469-200D-1F3A8',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F3A8'
          },
          {
            unified: '1F469-1F3FC-200D-1F3A8'
          },
          {
            unified: '1F469-1F3FD-200D-1F3A8'
          },
          {
            unified: '1F469-1F3FE-200D-1F3A8'
          },
          {
            unified: '1F469-1F3FF-200D-1F3A8'
          }
        ],
        shortName: 'female-artist'
      },
      {
        name: 'Male Pilot',
        unified: '1F468-200D-2708-FE0F',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-2708-FE0F'
          },
          {
            unified: '1F468-1F3FC-200D-2708-FE0F'
          },
          {
            unified: '1F468-1F3FD-200D-2708-FE0F'
          },
          {
            unified: '1F468-1F3FE-200D-2708-FE0F'
          },
          {
            unified: '1F468-1F3FF-200D-2708-FE0F'
          }
        ],
        shortName: 'male-pilot'
      },
      {
        name: 'Female Pilot',
        unified: '1F469-200D-2708-FE0F',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-2708-FE0F'
          },
          {
            unified: '1F469-1F3FC-200D-2708-FE0F'
          },
          {
            unified: '1F469-1F3FD-200D-2708-FE0F'
          },
          {
            unified: '1F469-1F3FE-200D-2708-FE0F'
          },
          {
            unified: '1F469-1F3FF-200D-2708-FE0F'
          }
        ],
        shortName: 'female-pilot'
      },
      {
        name: 'Male Astronaut',
        unified: '1F468-200D-1F680',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F680'
          },
          {
            unified: '1F468-1F3FC-200D-1F680'
          },
          {
            unified: '1F468-1F3FD-200D-1F680'
          },
          {
            unified: '1F468-1F3FE-200D-1F680'
          },
          {
            unified: '1F468-1F3FF-200D-1F680'
          }
        ],
        shortName: 'male-astronaut'
      },
      {
        name: 'Female Astronaut',
        unified: '1F469-200D-1F680',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F680'
          },
          {
            unified: '1F469-1F3FC-200D-1F680'
          },
          {
            unified: '1F469-1F3FD-200D-1F680'
          },
          {
            unified: '1F469-1F3FE-200D-1F680'
          },
          {
            unified: '1F469-1F3FF-200D-1F680'
          }
        ],
        shortName: 'female-astronaut'
      },
      {
        name: 'Male Firefighter',
        unified: '1F468-200D-1F692',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F692'
          },
          {
            unified: '1F468-1F3FC-200D-1F692'
          },
          {
            unified: '1F468-1F3FD-200D-1F692'
          },
          {
            unified: '1F468-1F3FE-200D-1F692'
          },
          {
            unified: '1F468-1F3FF-200D-1F692'
          }
        ],
        shortName: 'male-firefighter'
      },
      {
        name: 'Female Firefighter',
        unified: '1F469-200D-1F692',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F692'
          },
          {
            unified: '1F469-1F3FC-200D-1F692'
          },
          {
            unified: '1F469-1F3FD-200D-1F692'
          },
          {
            unified: '1F469-1F3FE-200D-1F692'
          },
          {
            unified: '1F469-1F3FF-200D-1F692'
          }
        ],
        shortName: 'female-firefighter'
      },
      {
        name: 'Police Officer',
        unified: '1F46E',
        skinVariations: [
          {
            unified: '1F46E-1F3FB'
          },
          {
            unified: '1F46E-1F3FC'
          },
          {
            unified: '1F46E-1F3FD'
          },
          {
            unified: '1F46E-1F3FE'
          },
          {
            unified: '1F46E-1F3FF'
          }
        ],
        shortName: 'cop',
        obsoletedBy: '1F46E-200D-2642-FE0F'
      },
      {
        name: 'Male Police Officer',
        unified: '1F46E-200D-2642-FE0F',
        obsoletes: '1F46E',
        skinVariations: [
          {
            unified: '1F46E-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F46E-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F46E-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F46E-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F46E-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male-police-officer'
      },
      {
        name: 'Female Police Officer',
        unified: '1F46E-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F46E-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F46E-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F46E-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F46E-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F46E-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female-police-officer'
      },
      {
        name: 'Sleuth or Spy',
        unified: '1F575-FE0F',
        skinVariations: [
          {
            unified: '1F575-1F3FB'
          },
          {
            unified: '1F575-1F3FC'
          },
          {
            unified: '1F575-1F3FD'
          },
          {
            unified: '1F575-1F3FE'
          },
          {
            unified: '1F575-1F3FF'
          }
        ],
        shortName: 'sleuth_or_spy',
        obsoletedBy: '1F575-FE0F-200D-2642-FE0F'
      },
      {
        name: 'Male Detective',
        unified: '1F575-FE0F-200D-2642-FE0F',
        obsoletes: '1F575-FE0F',
        skinVariations: [
          {
            unified: '1F575-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F575-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F575-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F575-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F575-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male-detective'
      },
      {
        name: 'Female Detective',
        unified: '1F575-FE0F-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F575-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F575-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F575-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F575-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F575-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female-detective'
      },
      {
        name: 'Guardsman',
        unified: '1F482',
        keywords: ['uk', 'gb', 'british', 'male', 'guy', 'royal'],
        skinVariations: [
          {
            unified: '1F482-1F3FB'
          },
          {
            unified: '1F482-1F3FC'
          },
          {
            unified: '1F482-1F3FD'
          },
          {
            unified: '1F482-1F3FE'
          },
          {
            unified: '1F482-1F3FF'
          }
        ],
        shortName: 'guardsman',
        obsoletedBy: '1F482-200D-2642-FE0F'
      },
      {
        name: 'Male Guard',
        unified: '1F482-200D-2642-FE0F',
        obsoletes: '1F482',
        skinVariations: [
          {
            unified: '1F482-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F482-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F482-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F482-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F482-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male-guard'
      },
      {
        name: 'Female Guard',
        unified: '1F482-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F482-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F482-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F482-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F482-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F482-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female-guard'
      },
      {
        name: 'Construction Worker',
        unified: '1F477',
        skinVariations: [
          {
            unified: '1F477-1F3FB'
          },
          {
            unified: '1F477-1F3FC'
          },
          {
            unified: '1F477-1F3FD'
          },
          {
            unified: '1F477-1F3FE'
          },
          {
            unified: '1F477-1F3FF'
          }
        ],
        shortName: 'construction_worker',
        obsoletedBy: '1F477-200D-2642-FE0F'
      },
      {
        name: 'Male Construction Worker',
        unified: '1F477-200D-2642-FE0F',
        obsoletes: '1F477',
        skinVariations: [
          {
            unified: '1F477-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F477-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F477-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F477-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F477-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male-construction-worker'
      },
      {
        name: 'Female Construction Worker',
        unified: '1F477-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F477-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F477-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F477-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F477-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F477-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female-construction-worker'
      },
      {
        name: 'Prince',
        unified: '1F934',
        keywords: ['boy', 'man', 'male', 'crown', 'royal', 'king'],
        skinVariations: [
          {
            unified: '1F934-1F3FB'
          },
          {
            unified: '1F934-1F3FC'
          },
          {
            unified: '1F934-1F3FD'
          },
          {
            unified: '1F934-1F3FE'
          },
          {
            unified: '1F934-1F3FF'
          }
        ],
        shortName: 'prince'
      },
      {
        name: 'Princess',
        unified: '1F478',
        keywords: ['girl', 'woman', 'female', 'blond', 'crown', 'royal', 'queen'],
        skinVariations: [
          {
            unified: '1F478-1F3FB'
          },
          {
            unified: '1F478-1F3FC'
          },
          {
            unified: '1F478-1F3FD'
          },
          {
            unified: '1F478-1F3FE'
          },
          {
            unified: '1F478-1F3FF'
          }
        ],
        shortName: 'princess'
      },
      {
        name: 'Man with Turban',
        unified: '1F473',
        keywords: ['male', 'indian', 'hinduism', 'arabs'],
        skinVariations: [
          {
            unified: '1F473-1F3FB'
          },
          {
            unified: '1F473-1F3FC'
          },
          {
            unified: '1F473-1F3FD'
          },
          {
            unified: '1F473-1F3FE'
          },
          {
            unified: '1F473-1F3FF'
          }
        ],
        shortName: 'man_with_turban',
        obsoletedBy: '1F473-200D-2642-FE0F'
      },
      {
        name: 'Man Wearing Turban',
        unified: '1F473-200D-2642-FE0F',
        obsoletes: '1F473',
        skinVariations: [
          {
            unified: '1F473-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F473-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F473-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F473-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F473-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-wearing-turban'
      },
      {
        name: 'Woman Wearing Turban',
        unified: '1F473-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F473-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F473-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F473-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F473-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F473-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-wearing-turban'
      },
      {
        name: 'Man with Gua Pi Mao',
        unified: '1F472',
        keywords: ['male', 'boy', 'chinese'],
        skinVariations: [
          {
            unified: '1F472-1F3FB'
          },
          {
            unified: '1F472-1F3FC'
          },
          {
            unified: '1F472-1F3FD'
          },
          {
            unified: '1F472-1F3FE'
          },
          {
            unified: '1F472-1F3FF'
          }
        ],
        shortName: 'man_with_gua_pi_mao'
      },
      {
        name: 'Person with Headscarf',
        unified: '1F9D5',
        skinVariations: [
          {
            unified: '1F9D5-1F3FB'
          },
          {
            unified: '1F9D5-1F3FC'
          },
          {
            unified: '1F9D5-1F3FD'
          },
          {
            unified: '1F9D5-1F3FE'
          },
          {
            unified: '1F9D5-1F3FF'
          }
        ],
        shortName: 'person_with_headscarf'
      },
      {
        name: 'Man in Tuxedo',
        unified: '1F935',
        keywords: ['couple', 'marriage', 'wedding', 'groom'],
        skinVariations: [
          {
            unified: '1F935-1F3FB'
          },
          {
            unified: '1F935-1F3FC'
          },
          {
            unified: '1F935-1F3FD'
          },
          {
            unified: '1F935-1F3FE'
          },
          {
            unified: '1F935-1F3FF'
          }
        ],
        shortName: 'man_in_tuxedo'
      },
      {
        name: 'Bride with Veil',
        unified: '1F470',
        keywords: ['couple', 'marriage', 'wedding', 'woman', 'bride'],
        skinVariations: [
          {
            unified: '1F470-1F3FB'
          },
          {
            unified: '1F470-1F3FC'
          },
          {
            unified: '1F470-1F3FD'
          },
          {
            unified: '1F470-1F3FE'
          },
          {
            unified: '1F470-1F3FF'
          }
        ],
        shortName: 'bride_with_veil'
      },
      {
        name: 'Pregnant Woman',
        unified: '1F930',
        keywords: ['baby'],
        skinVariations: [
          {
            unified: '1F930-1F3FB'
          },
          {
            unified: '1F930-1F3FC'
          },
          {
            unified: '1F930-1F3FD'
          },
          {
            unified: '1F930-1F3FE'
          },
          {
            unified: '1F930-1F3FF'
          }
        ],
        shortName: 'pregnant_woman'
      },
      {
        name: 'Breast-Feeding',
        unified: '1F931',
        skinVariations: [
          {
            unified: '1F931-1F3FB'
          },
          {
            unified: '1F931-1F3FC'
          },
          {
            unified: '1F931-1F3FD'
          },
          {
            unified: '1F931-1F3FE'
          },
          {
            unified: '1F931-1F3FF'
          }
        ],
        shortName: 'breast-feeding'
      },
      {
        name: 'Baby Angel',
        unified: '1F47C',
        keywords: ['heaven', 'wings', 'halo'],
        skinVariations: [
          {
            unified: '1F47C-1F3FB'
          },
          {
            unified: '1F47C-1F3FC'
          },
          {
            unified: '1F47C-1F3FD'
          },
          {
            unified: '1F47C-1F3FE'
          },
          {
            unified: '1F47C-1F3FF'
          }
        ],
        shortName: 'angel'
      },
      {
        name: 'Father Christmas',
        unified: '1F385',
        keywords: ['festival', 'man', 'male', 'xmas', 'father christmas'],
        skinVariations: [
          {
            unified: '1F385-1F3FB'
          },
          {
            unified: '1F385-1F3FC'
          },
          {
            unified: '1F385-1F3FD'
          },
          {
            unified: '1F385-1F3FE'
          },
          {
            unified: '1F385-1F3FF'
          }
        ],
        shortName: 'santa'
      },
      {
        name: 'Mother Christmas',
        unified: '1F936',
        keywords: ['woman', 'female', 'xmas', 'mother christmas'],
        skinVariations: [
          {
            unified: '1F936-1F3FB'
          },
          {
            unified: '1F936-1F3FC'
          },
          {
            unified: '1F936-1F3FD'
          },
          {
            unified: '1F936-1F3FE'
          },
          {
            unified: '1F936-1F3FF'
          }
        ],
        shortNames: ['mrs_claus', 'mother_christmas'],
        shortName: 'mrs_claus'
      },
      {
        name: 'Superhero',
        unified: '1F9B8',
        skinVariations: [
          {
            unified: '1F9B8-1F3FB'
          },
          {
            unified: '1F9B8-1F3FC'
          },
          {
            unified: '1F9B8-1F3FD'
          },
          {
            unified: '1F9B8-1F3FE'
          },
          {
            unified: '1F9B8-1F3FF'
          }
        ],
        shortName: 'superhero'
      },
      {
        name: 'Male Superhero',
        unified: '1F9B8-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9B8-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9B8-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9B8-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9B8-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9B8-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male_superhero'
      },
      {
        name: 'Female Superhero',
        unified: '1F9B8-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F9B8-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9B8-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9B8-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9B8-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9B8-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female_superhero'
      },
      {
        name: 'Supervillain',
        unified: '1F9B9',
        skinVariations: [
          {
            unified: '1F9B9-1F3FB'
          },
          {
            unified: '1F9B9-1F3FC'
          },
          {
            unified: '1F9B9-1F3FD'
          },
          {
            unified: '1F9B9-1F3FE'
          },
          {
            unified: '1F9B9-1F3FF'
          }
        ],
        shortName: 'supervillain'
      },
      {
        name: 'Male Supervillain',
        unified: '1F9B9-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9B9-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9B9-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9B9-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9B9-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9B9-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male_supervillain'
      },
      {
        name: 'Female Supervillain',
        unified: '1F9B9-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F9B9-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9B9-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9B9-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9B9-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9B9-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female_supervillain'
      },
      {
        name: 'Mage',
        unified: '1F9D9',
        skinVariations: [
          {
            unified: '1F9D9-1F3FB'
          },
          {
            unified: '1F9D9-1F3FC'
          },
          {
            unified: '1F9D9-1F3FD'
          },
          {
            unified: '1F9D9-1F3FE'
          },
          {
            unified: '1F9D9-1F3FF'
          }
        ],
        shortName: 'mage',
        obsoletedBy: '1F9D9-200D-2640-FE0F'
      },
      {
        name: 'Male Mage',
        unified: '1F9D9-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9D9-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9D9-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9D9-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9D9-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9D9-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male_mage'
      },
      {
        name: 'Female Mage',
        unified: '1F9D9-200D-2640-FE0F',
        obsoletes: '1F9D9',
        skinVariations: [
          {
            unified: '1F9D9-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9D9-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9D9-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9D9-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9D9-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female_mage'
      },
      {
        name: 'Fairy',
        unified: '1F9DA',
        skinVariations: [
          {
            unified: '1F9DA-1F3FB'
          },
          {
            unified: '1F9DA-1F3FC'
          },
          {
            unified: '1F9DA-1F3FD'
          },
          {
            unified: '1F9DA-1F3FE'
          },
          {
            unified: '1F9DA-1F3FF'
          }
        ],
        shortName: 'fairy',
        obsoletedBy: '1F9DA-200D-2640-FE0F'
      },
      {
        name: 'Male Fairy',
        unified: '1F9DA-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9DA-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9DA-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9DA-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9DA-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9DA-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male_fairy'
      },
      {
        name: 'Female Fairy',
        unified: '1F9DA-200D-2640-FE0F',
        obsoletes: '1F9DA',
        skinVariations: [
          {
            unified: '1F9DA-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9DA-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9DA-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9DA-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9DA-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female_fairy'
      },
      {
        name: 'Vampire',
        unified: '1F9DB',
        skinVariations: [
          {
            unified: '1F9DB-1F3FB'
          },
          {
            unified: '1F9DB-1F3FC'
          },
          {
            unified: '1F9DB-1F3FD'
          },
          {
            unified: '1F9DB-1F3FE'
          },
          {
            unified: '1F9DB-1F3FF'
          }
        ],
        shortName: 'vampire',
        obsoletedBy: '1F9DB-200D-2640-FE0F'
      },
      {
        name: 'Male Vampire',
        unified: '1F9DB-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9DB-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9DB-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9DB-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9DB-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9DB-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male_vampire'
      },
      {
        name: 'Female Vampire',
        unified: '1F9DB-200D-2640-FE0F',
        obsoletes: '1F9DB',
        skinVariations: [
          {
            unified: '1F9DB-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9DB-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9DB-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9DB-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9DB-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female_vampire'
      },
      {
        name: 'Merperson',
        unified: '1F9DC',
        skinVariations: [
          {
            unified: '1F9DC-1F3FB'
          },
          {
            unified: '1F9DC-1F3FC'
          },
          {
            unified: '1F9DC-1F3FD'
          },
          {
            unified: '1F9DC-1F3FE'
          },
          {
            unified: '1F9DC-1F3FF'
          }
        ],
        shortName: 'merperson',
        obsoletedBy: '1F9DC-200D-2642-FE0F'
      },
      {
        name: 'Merman',
        unified: '1F9DC-200D-2642-FE0F',
        obsoletes: '1F9DC',
        keywords: ['man', 'male', 'triton'],
        skinVariations: [
          {
            unified: '1F9DC-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9DC-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9DC-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9DC-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9DC-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'merman'
      },
      {
        name: 'Mermaid',
        unified: '1F9DC-200D-2640-FE0F',
        keywords: ['woman', 'female', 'merwoman', 'ariel'],
        skinVariations: [
          {
            unified: '1F9DC-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9DC-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9DC-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9DC-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9DC-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'mermaid'
      },
      {
        name: 'Elf',
        unified: '1F9DD',
        skinVariations: [
          {
            unified: '1F9DD-1F3FB'
          },
          {
            unified: '1F9DD-1F3FC'
          },
          {
            unified: '1F9DD-1F3FD'
          },
          {
            unified: '1F9DD-1F3FE'
          },
          {
            unified: '1F9DD-1F3FF'
          }
        ],
        shortName: 'elf',
        obsoletedBy: '1F9DD-200D-2642-FE0F'
      },
      {
        name: 'Male Elf',
        unified: '1F9DD-200D-2642-FE0F',
        obsoletes: '1F9DD',
        skinVariations: [
          {
            unified: '1F9DD-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9DD-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9DD-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9DD-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9DD-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'male_elf'
      },
      {
        name: 'Female Elf',
        unified: '1F9DD-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F9DD-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9DD-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9DD-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9DD-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9DD-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'female_elf'
      },
      {
        name: 'Genie',
        unified: '1F9DE',
        shortName: 'genie',
        obsoletedBy: '1F9DE-200D-2642-FE0F'
      },
      {
        name: 'Male Genie',
        unified: '1F9DE-200D-2642-FE0F',
        obsoletes: '1F9DE',
        shortName: 'male_genie'
      },
      {
        name: 'Female Genie',
        unified: '1F9DE-200D-2640-FE0F',
        shortName: 'female_genie'
      },
      {
        name: 'Zombie',
        unified: '1F9DF',
        shortName: 'zombie',
        obsoletedBy: '1F9DF-200D-2642-FE0F'
      },
      {
        name: 'Male Zombie',
        unified: '1F9DF-200D-2642-FE0F',
        obsoletes: '1F9DF',
        shortName: 'male_zombie'
      },
      {
        name: 'Female Zombie',
        unified: '1F9DF-200D-2640-FE0F',
        shortName: 'female_zombie'
      },
      {
        name: 'Face Massage',
        unified: '1F486',
        skinVariations: [
          {
            unified: '1F486-1F3FB'
          },
          {
            unified: '1F486-1F3FC'
          },
          {
            unified: '1F486-1F3FD'
          },
          {
            unified: '1F486-1F3FE'
          },
          {
            unified: '1F486-1F3FF'
          }
        ],
        shortName: 'massage',
        obsoletedBy: '1F486-200D-2640-FE0F'
      },
      {
        name: 'Man Getting Massage',
        unified: '1F486-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F486-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F486-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F486-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F486-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F486-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-getting-massage'
      },
      {
        name: 'Woman Getting Massage',
        unified: '1F486-200D-2640-FE0F',
        obsoletes: '1F486',
        skinVariations: [
          {
            unified: '1F486-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F486-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F486-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F486-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F486-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-getting-massage'
      },
      {
        name: 'Haircut',
        unified: '1F487',
        skinVariations: [
          {
            unified: '1F487-1F3FB'
          },
          {
            unified: '1F487-1F3FC'
          },
          {
            unified: '1F487-1F3FD'
          },
          {
            unified: '1F487-1F3FE'
          },
          {
            unified: '1F487-1F3FF'
          }
        ],
        shortName: 'haircut',
        obsoletedBy: '1F487-200D-2640-FE0F'
      },
      {
        name: 'Man Getting Haircut',
        unified: '1F487-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F487-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F487-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F487-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F487-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F487-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-getting-haircut'
      },
      {
        name: 'Woman Getting Haircut',
        unified: '1F487-200D-2640-FE0F',
        obsoletes: '1F487',
        skinVariations: [
          {
            unified: '1F487-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F487-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F487-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F487-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F487-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-getting-haircut'
      },
      {
        name: 'Pedestrian',
        unified: '1F6B6',
        skinVariations: [
          {
            unified: '1F6B6-1F3FB'
          },
          {
            unified: '1F6B6-1F3FC'
          },
          {
            unified: '1F6B6-1F3FD'
          },
          {
            unified: '1F6B6-1F3FE'
          },
          {
            unified: '1F6B6-1F3FF'
          }
        ],
        shortName: 'walking',
        obsoletedBy: '1F6B6-200D-2642-FE0F'
      },
      {
        name: 'Man Walking',
        unified: '1F6B6-200D-2642-FE0F',
        obsoletes: '1F6B6',
        skinVariations: [
          {
            unified: '1F6B6-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F6B6-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F6B6-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F6B6-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F6B6-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-walking'
      },
      {
        name: 'Woman Walking',
        unified: '1F6B6-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F6B6-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F6B6-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F6B6-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F6B6-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F6B6-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-walking'
      },
      {
        name: 'Standing Person',
        unified: '1F9CD',
        skinVariations: [
          {
            unified: '1F9CD-1F3FB'
          },
          {
            unified: '1F9CD-1F3FC'
          },
          {
            unified: '1F9CD-1F3FD'
          },
          {
            unified: '1F9CD-1F3FE'
          },
          {
            unified: '1F9CD-1F3FF'
          }
        ],
        shortName: 'standing_person'
      },
      {
        name: 'Man Standing',
        unified: '1F9CD-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9CD-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9CD-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9CD-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9CD-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9CD-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man_standing'
      },
      {
        name: 'Woman Standing',
        unified: '1F9CD-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F9CD-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9CD-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9CD-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9CD-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9CD-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman_standing'
      },
      {
        name: 'Kneeling Person',
        unified: '1F9CE',
        skinVariations: [
          {
            unified: '1F9CE-1F3FB'
          },
          {
            unified: '1F9CE-1F3FC'
          },
          {
            unified: '1F9CE-1F3FD'
          },
          {
            unified: '1F9CE-1F3FE'
          },
          {
            unified: '1F9CE-1F3FF'
          }
        ],
        shortName: 'kneeling_person'
      },
      {
        name: 'Man Kneeling',
        unified: '1F9CE-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9CE-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9CE-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9CE-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9CE-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9CE-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man_kneeling'
      },
      {
        name: 'Woman Kneeling',
        unified: '1F9CE-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F9CE-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9CE-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9CE-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9CE-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9CE-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman_kneeling'
      },
      {
        name: 'Man with Probing Cane',
        unified: '1F468-200D-1F9AF',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9AF'
          },
          {
            unified: '1F468-1F3FC-200D-1F9AF'
          },
          {
            unified: '1F468-1F3FD-200D-1F9AF'
          },
          {
            unified: '1F468-1F3FE-200D-1F9AF'
          },
          {
            unified: '1F468-1F3FF-200D-1F9AF'
          }
        ],
        shortName: 'man_with_probing_cane'
      },
      {
        name: 'Woman with Probing Cane',
        unified: '1F469-200D-1F9AF',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9AF'
          },
          {
            unified: '1F469-1F3FC-200D-1F9AF'
          },
          {
            unified: '1F469-1F3FD-200D-1F9AF'
          },
          {
            unified: '1F469-1F3FE-200D-1F9AF'
          },
          {
            unified: '1F469-1F3FF-200D-1F9AF'
          }
        ],
        shortName: 'woman_with_probing_cane'
      },
      {
        name: 'Man in Motorized Wheelchair',
        unified: '1F468-200D-1F9BC',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9BC'
          },
          {
            unified: '1F468-1F3FC-200D-1F9BC'
          },
          {
            unified: '1F468-1F3FD-200D-1F9BC'
          },
          {
            unified: '1F468-1F3FE-200D-1F9BC'
          },
          {
            unified: '1F468-1F3FF-200D-1F9BC'
          }
        ],
        shortName: 'man_in_motorized_wheelchair'
      },
      {
        name: 'Woman in Motorized Wheelchair',
        unified: '1F469-200D-1F9BC',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9BC'
          },
          {
            unified: '1F469-1F3FC-200D-1F9BC'
          },
          {
            unified: '1F469-1F3FD-200D-1F9BC'
          },
          {
            unified: '1F469-1F3FE-200D-1F9BC'
          },
          {
            unified: '1F469-1F3FF-200D-1F9BC'
          }
        ],
        shortName: 'woman_in_motorized_wheelchair'
      },
      {
        name: 'Man in Manual Wheelchair',
        unified: '1F468-200D-1F9BD',
        skinVariations: [
          {
            unified: '1F468-1F3FB-200D-1F9BD'
          },
          {
            unified: '1F468-1F3FC-200D-1F9BD'
          },
          {
            unified: '1F468-1F3FD-200D-1F9BD'
          },
          {
            unified: '1F468-1F3FE-200D-1F9BD'
          },
          {
            unified: '1F468-1F3FF-200D-1F9BD'
          }
        ],
        shortName: 'man_in_manual_wheelchair'
      },
      {
        name: 'Woman in Manual Wheelchair',
        unified: '1F469-200D-1F9BD',
        skinVariations: [
          {
            unified: '1F469-1F3FB-200D-1F9BD'
          },
          {
            unified: '1F469-1F3FC-200D-1F9BD'
          },
          {
            unified: '1F469-1F3FD-200D-1F9BD'
          },
          {
            unified: '1F469-1F3FE-200D-1F9BD'
          },
          {
            unified: '1F469-1F3FF-200D-1F9BD'
          }
        ],
        shortName: 'woman_in_manual_wheelchair'
      },
      {
        name: 'Runner',
        unified: '1F3C3',
        skinVariations: [
          {
            unified: '1F3C3-1F3FB'
          },
          {
            unified: '1F3C3-1F3FC'
          },
          {
            unified: '1F3C3-1F3FD'
          },
          {
            unified: '1F3C3-1F3FE'
          },
          {
            unified: '1F3C3-1F3FF'
          }
        ],
        shortNames: ['runner', 'running'],
        shortName: 'runner',
        obsoletedBy: '1F3C3-200D-2642-FE0F'
      },
      {
        name: 'Man Running',
        unified: '1F3C3-200D-2642-FE0F',
        obsoletes: '1F3C3',
        skinVariations: [
          {
            unified: '1F3C3-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F3C3-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F3C3-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F3C3-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F3C3-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-running'
      },
      {
        name: 'Woman Running',
        unified: '1F3C3-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F3C3-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F3C3-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F3C3-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F3C3-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F3C3-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-running'
      },
      {
        name: 'Dancer',
        unified: '1F483',
        keywords: ['female', 'girl', 'woman', 'fun'],
        skinVariations: [
          {
            unified: '1F483-1F3FB'
          },
          {
            unified: '1F483-1F3FC'
          },
          {
            unified: '1F483-1F3FD'
          },
          {
            unified: '1F483-1F3FE'
          },
          {
            unified: '1F483-1F3FF'
          }
        ],
        shortName: 'dancer'
      },
      {
        name: 'Man Dancing',
        unified: '1F57A',
        keywords: ['male', 'boy', 'fun', 'dancer'],
        skinVariations: [
          {
            unified: '1F57A-1F3FB'
          },
          {
            unified: '1F57A-1F3FC'
          },
          {
            unified: '1F57A-1F3FD'
          },
          {
            unified: '1F57A-1F3FE'
          },
          {
            unified: '1F57A-1F3FF'
          }
        ],
        shortName: 'man_dancing'
      },
      {
        name: 'Man in Business Suit Levitating',
        unified: '1F574-FE0F',
        skinVariations: [
          {
            unified: '1F574-1F3FB'
          },
          {
            unified: '1F574-1F3FC'
          },
          {
            unified: '1F574-1F3FD'
          },
          {
            unified: '1F574-1F3FE'
          },
          {
            unified: '1F574-1F3FF'
          }
        ],
        shortName: 'man_in_business_suit_levitating'
      },
      {
        name: 'Woman with Bunny Ears',
        unified: '1F46F',
        shortName: 'dancers',
        obsoletedBy: '1F46F-200D-2640-FE0F'
      },
      {
        name: 'Man with Bunny Ears Partying',
        unified: '1F46F-200D-2642-FE0F',
        shortName: 'man-with-bunny-ears-partying'
      },
      {
        name: 'Woman with Bunny Ears Partying',
        unified: '1F46F-200D-2640-FE0F',
        obsoletes: '1F46F',
        shortName: 'woman-with-bunny-ears-partying'
      },
      {
        name: 'Person in Steamy Room',
        unified: '1F9D6',
        skinVariations: [
          {
            unified: '1F9D6-1F3FB'
          },
          {
            unified: '1F9D6-1F3FC'
          },
          {
            unified: '1F9D6-1F3FD'
          },
          {
            unified: '1F9D6-1F3FE'
          },
          {
            unified: '1F9D6-1F3FF'
          }
        ],
        shortName: 'person_in_steamy_room',
        obsoletedBy: '1F9D6-200D-2642-FE0F'
      },
      {
        name: 'Man in Steamy Room',
        unified: '1F9D6-200D-2642-FE0F',
        obsoletes: '1F9D6',
        keywords: ['male', 'man', 'spa', 'steamroom', 'sauna'],
        skinVariations: [
          {
            unified: '1F9D6-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9D6-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9D6-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9D6-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9D6-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man_in_steamy_room'
      },
      {
        name: 'Woman in Steamy Room',
        unified: '1F9D6-200D-2640-FE0F',
        keywords: ['female', 'woman', 'spa', 'steamroom', 'sauna'],
        skinVariations: [
          {
            unified: '1F9D6-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9D6-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9D6-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9D6-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9D6-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman_in_steamy_room'
      },
      {
        name: 'Person Climbing',
        unified: '1F9D7',
        skinVariations: [
          {
            unified: '1F9D7-1F3FB'
          },
          {
            unified: '1F9D7-1F3FC'
          },
          {
            unified: '1F9D7-1F3FD'
          },
          {
            unified: '1F9D7-1F3FE'
          },
          {
            unified: '1F9D7-1F3FF'
          }
        ],
        shortName: 'person_climbing',
        obsoletedBy: '1F9D7-200D-2640-FE0F'
      },
      {
        name: 'Man Climbing',
        unified: '1F9D7-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F9D7-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9D7-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9D7-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9D7-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9D7-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man_climbing'
      },
      {
        name: 'Woman Climbing',
        unified: '1F9D7-200D-2640-FE0F',
        obsoletes: '1F9D7',
        skinVariations: [
          {
            unified: '1F9D7-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9D7-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9D7-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9D7-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9D7-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman_climbing'
      },
      {
        name: 'Fencer',
        unified: '1F93A',
        shortName: 'fencer'
      },
      {
        name: 'Horse Racing',
        unified: '1F3C7',
        keywords: ['animal', 'betting', 'competition', 'gambling', 'luck'],
        skinVariations: [
          {
            unified: '1F3C7-1F3FB'
          },
          {
            unified: '1F3C7-1F3FC'
          },
          {
            unified: '1F3C7-1F3FD'
          },
          {
            unified: '1F3C7-1F3FE'
          },
          {
            unified: '1F3C7-1F3FF'
          }
        ],
        shortName: 'horse_racing'
      },
      {
        name: 'Skier',
        unified: '26F7-FE0F',
        keywords: ['sports', 'winter', 'snow'],
        shortName: 'skier'
      },
      {
        name: 'Snowboarder',
        unified: '1F3C2',
        keywords: ['sports', 'winter'],
        skinVariations: [
          {
            unified: '1F3C2-1F3FB'
          },
          {
            unified: '1F3C2-1F3FC'
          },
          {
            unified: '1F3C2-1F3FD'
          },
          {
            unified: '1F3C2-1F3FE'
          },
          {
            unified: '1F3C2-1F3FF'
          }
        ],
        shortName: 'snowboarder'
      },
      {
        name: 'Golfer',
        unified: '1F3CC-FE0F',
        skinVariations: [
          {
            unified: '1F3CC-1F3FB'
          },
          {
            unified: '1F3CC-1F3FC'
          },
          {
            unified: '1F3CC-1F3FD'
          },
          {
            unified: '1F3CC-1F3FE'
          },
          {
            unified: '1F3CC-1F3FF'
          }
        ],
        shortName: 'golfer',
        obsoletedBy: '1F3CC-FE0F-200D-2642-FE0F'
      },
      {
        name: 'Man Golfing',
        unified: '1F3CC-FE0F-200D-2642-FE0F',
        obsoletes: '1F3CC-FE0F',
        skinVariations: [
          {
            unified: '1F3CC-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F3CC-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F3CC-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F3CC-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F3CC-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-golfing'
      },
      {
        name: 'Woman Golfing',
        unified: '1F3CC-FE0F-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F3CC-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F3CC-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F3CC-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F3CC-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F3CC-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-golfing'
      },
      {
        name: 'Surfer',
        unified: '1F3C4',
        skinVariations: [
          {
            unified: '1F3C4-1F3FB'
          },
          {
            unified: '1F3C4-1F3FC'
          },
          {
            unified: '1F3C4-1F3FD'
          },
          {
            unified: '1F3C4-1F3FE'
          },
          {
            unified: '1F3C4-1F3FF'
          }
        ],
        shortName: 'surfer',
        obsoletedBy: '1F3C4-200D-2642-FE0F'
      },
      {
        name: 'Man Surfing',
        unified: '1F3C4-200D-2642-FE0F',
        obsoletes: '1F3C4',
        skinVariations: [
          {
            unified: '1F3C4-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F3C4-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F3C4-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F3C4-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F3C4-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-surfing'
      },
      {
        name: 'Woman Surfing',
        unified: '1F3C4-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F3C4-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F3C4-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F3C4-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F3C4-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F3C4-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-surfing'
      },
      {
        name: 'Rowboat',
        unified: '1F6A3',
        skinVariations: [
          {
            unified: '1F6A3-1F3FB'
          },
          {
            unified: '1F6A3-1F3FC'
          },
          {
            unified: '1F6A3-1F3FD'
          },
          {
            unified: '1F6A3-1F3FE'
          },
          {
            unified: '1F6A3-1F3FF'
          }
        ],
        shortName: 'rowboat',
        obsoletedBy: '1F6A3-200D-2642-FE0F'
      },
      {
        name: 'Man Rowing Boat',
        unified: '1F6A3-200D-2642-FE0F',
        obsoletes: '1F6A3',
        skinVariations: [
          {
            unified: '1F6A3-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F6A3-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F6A3-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F6A3-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F6A3-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-rowing-boat'
      },
      {
        name: 'Woman Rowing Boat',
        unified: '1F6A3-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F6A3-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F6A3-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F6A3-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F6A3-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F6A3-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-rowing-boat'
      },
      {
        name: 'Swimmer',
        unified: '1F3CA',
        skinVariations: [
          {
            unified: '1F3CA-1F3FB'
          },
          {
            unified: '1F3CA-1F3FC'
          },
          {
            unified: '1F3CA-1F3FD'
          },
          {
            unified: '1F3CA-1F3FE'
          },
          {
            unified: '1F3CA-1F3FF'
          }
        ],
        shortName: 'swimmer',
        obsoletedBy: '1F3CA-200D-2642-FE0F'
      },
      {
        name: 'Man Swimming',
        unified: '1F3CA-200D-2642-FE0F',
        obsoletes: '1F3CA',
        skinVariations: [
          {
            unified: '1F3CA-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F3CA-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F3CA-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F3CA-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F3CA-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-swimming'
      },
      {
        name: 'Woman Swimming',
        unified: '1F3CA-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F3CA-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F3CA-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F3CA-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F3CA-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F3CA-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-swimming'
      },
      {
        name: 'Person with Ball',
        unified: '26F9-FE0F',
        skinVariations: [
          {
            unified: '26F9-1F3FB'
          },
          {
            unified: '26F9-1F3FC'
          },
          {
            unified: '26F9-1F3FD'
          },
          {
            unified: '26F9-1F3FE'
          },
          {
            unified: '26F9-1F3FF'
          }
        ],
        shortName: 'person_with_ball',
        obsoletedBy: '26F9-FE0F-200D-2642-FE0F'
      },
      {
        name: 'Man Bouncing Ball',
        unified: '26F9-FE0F-200D-2642-FE0F',
        obsoletes: '26F9-FE0F',
        skinVariations: [
          {
            unified: '26F9-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '26F9-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '26F9-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '26F9-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '26F9-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-bouncing-ball'
      },
      {
        name: 'Woman Bouncing Ball',
        unified: '26F9-FE0F-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '26F9-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '26F9-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '26F9-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '26F9-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '26F9-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-bouncing-ball'
      },
      {
        name: 'Weight Lifter',
        unified: '1F3CB-FE0F',
        skinVariations: [
          {
            unified: '1F3CB-1F3FB'
          },
          {
            unified: '1F3CB-1F3FC'
          },
          {
            unified: '1F3CB-1F3FD'
          },
          {
            unified: '1F3CB-1F3FE'
          },
          {
            unified: '1F3CB-1F3FF'
          }
        ],
        shortName: 'weight_lifter',
        obsoletedBy: '1F3CB-FE0F-200D-2642-FE0F'
      },
      {
        name: 'Man Lifting Weights',
        unified: '1F3CB-FE0F-200D-2642-FE0F',
        obsoletes: '1F3CB-FE0F',
        skinVariations: [
          {
            unified: '1F3CB-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F3CB-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F3CB-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F3CB-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F3CB-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-lifting-weights'
      },
      {
        name: 'Woman Lifting Weights',
        unified: '1F3CB-FE0F-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F3CB-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F3CB-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F3CB-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F3CB-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F3CB-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-lifting-weights'
      },
      {
        name: 'Bicyclist',
        unified: '1F6B4',
        skinVariations: [
          {
            unified: '1F6B4-1F3FB'
          },
          {
            unified: '1F6B4-1F3FC'
          },
          {
            unified: '1F6B4-1F3FD'
          },
          {
            unified: '1F6B4-1F3FE'
          },
          {
            unified: '1F6B4-1F3FF'
          }
        ],
        shortName: 'bicyclist',
        obsoletedBy: '1F6B4-200D-2642-FE0F'
      },
      {
        name: 'Man Biking',
        unified: '1F6B4-200D-2642-FE0F',
        obsoletes: '1F6B4',
        skinVariations: [
          {
            unified: '1F6B4-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F6B4-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F6B4-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F6B4-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F6B4-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-biking'
      },
      {
        name: 'Woman Biking',
        unified: '1F6B4-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F6B4-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F6B4-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F6B4-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F6B4-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F6B4-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-biking'
      },
      {
        name: 'Mountain Bicyclist',
        unified: '1F6B5',
        skinVariations: [
          {
            unified: '1F6B5-1F3FB'
          },
          {
            unified: '1F6B5-1F3FC'
          },
          {
            unified: '1F6B5-1F3FD'
          },
          {
            unified: '1F6B5-1F3FE'
          },
          {
            unified: '1F6B5-1F3FF'
          }
        ],
        shortName: 'mountain_bicyclist',
        obsoletedBy: '1F6B5-200D-2642-FE0F'
      },
      {
        name: 'Man Mountain Biking',
        unified: '1F6B5-200D-2642-FE0F',
        obsoletes: '1F6B5',
        skinVariations: [
          {
            unified: '1F6B5-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F6B5-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F6B5-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F6B5-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F6B5-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-mountain-biking'
      },
      {
        name: 'Woman Mountain Biking',
        unified: '1F6B5-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F6B5-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F6B5-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F6B5-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F6B5-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F6B5-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-mountain-biking'
      },
      {
        name: 'Person Doing Cartwheel',
        unified: '1F938',
        skinVariations: [
          {
            unified: '1F938-1F3FB'
          },
          {
            unified: '1F938-1F3FC'
          },
          {
            unified: '1F938-1F3FD'
          },
          {
            unified: '1F938-1F3FE'
          },
          {
            unified: '1F938-1F3FF'
          }
        ],
        shortName: 'person_doing_cartwheel'
      },
      {
        name: 'Man Cartwheeling',
        unified: '1F938-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F938-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F938-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F938-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F938-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F938-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-cartwheeling'
      },
      {
        name: 'Woman Cartwheeling',
        unified: '1F938-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F938-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F938-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F938-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F938-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F938-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-cartwheeling'
      },
      {
        name: 'Wrestlers',
        unified: '1F93C',
        shortName: 'wrestlers'
      },
      {
        name: 'Man Wrestling',
        unified: '1F93C-200D-2642-FE0F',
        shortName: 'man-wrestling'
      },
      {
        name: 'Woman Wrestling',
        unified: '1F93C-200D-2640-FE0F',
        shortName: 'woman-wrestling'
      },
      {
        name: 'Water Polo',
        unified: '1F93D',
        skinVariations: [
          {
            unified: '1F93D-1F3FB'
          },
          {
            unified: '1F93D-1F3FC'
          },
          {
            unified: '1F93D-1F3FD'
          },
          {
            unified: '1F93D-1F3FE'
          },
          {
            unified: '1F93D-1F3FF'
          }
        ],
        shortName: 'water_polo'
      },
      {
        name: 'Man Playing Water Polo',
        unified: '1F93D-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F93D-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F93D-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F93D-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F93D-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F93D-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-playing-water-polo'
      },
      {
        name: 'Woman Playing Water Polo',
        unified: '1F93D-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F93D-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F93D-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F93D-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F93D-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F93D-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-playing-water-polo'
      },
      {
        name: 'Handball',
        unified: '1F93E',
        skinVariations: [
          {
            unified: '1F93E-1F3FB'
          },
          {
            unified: '1F93E-1F3FC'
          },
          {
            unified: '1F93E-1F3FD'
          },
          {
            unified: '1F93E-1F3FE'
          },
          {
            unified: '1F93E-1F3FF'
          }
        ],
        shortName: 'handball'
      },
      {
        name: 'Man Playing Handball',
        unified: '1F93E-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F93E-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F93E-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F93E-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F93E-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F93E-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-playing-handball'
      },
      {
        name: 'Woman Playing Handball',
        unified: '1F93E-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F93E-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F93E-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F93E-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F93E-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F93E-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-playing-handball'
      },
      {
        name: 'Juggling',
        unified: '1F939',
        skinVariations: [
          {
            unified: '1F939-1F3FB'
          },
          {
            unified: '1F939-1F3FC'
          },
          {
            unified: '1F939-1F3FD'
          },
          {
            unified: '1F939-1F3FE'
          },
          {
            unified: '1F939-1F3FF'
          }
        ],
        shortName: 'juggling'
      },
      {
        name: 'Man Juggling',
        unified: '1F939-200D-2642-FE0F',
        skinVariations: [
          {
            unified: '1F939-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F939-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F939-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F939-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F939-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man-juggling'
      },
      {
        name: 'Woman Juggling',
        unified: '1F939-200D-2640-FE0F',
        skinVariations: [
          {
            unified: '1F939-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F939-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F939-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F939-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F939-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman-juggling'
      },
      {
        name: 'Person in Lotus Position',
        unified: '1F9D8',
        skinVariations: [
          {
            unified: '1F9D8-1F3FB'
          },
          {
            unified: '1F9D8-1F3FC'
          },
          {
            unified: '1F9D8-1F3FD'
          },
          {
            unified: '1F9D8-1F3FE'
          },
          {
            unified: '1F9D8-1F3FF'
          }
        ],
        shortName: 'person_in_lotus_position',
        obsoletedBy: '1F9D8-200D-2640-FE0F'
      },
      {
        name: 'Man in Lotus Position',
        unified: '1F9D8-200D-2642-FE0F',
        keywords: ['man', 'male', 'meditation', 'yoga', 'serenity', 'zen', 'mindfulness'],
        skinVariations: [
          {
            unified: '1F9D8-1F3FB-200D-2642-FE0F'
          },
          {
            unified: '1F9D8-1F3FC-200D-2642-FE0F'
          },
          {
            unified: '1F9D8-1F3FD-200D-2642-FE0F'
          },
          {
            unified: '1F9D8-1F3FE-200D-2642-FE0F'
          },
          {
            unified: '1F9D8-1F3FF-200D-2642-FE0F'
          }
        ],
        shortName: 'man_in_lotus_position'
      },
      {
        name: 'Woman in Lotus Position',
        unified: '1F9D8-200D-2640-FE0F',
        obsoletes: '1F9D8',
        keywords: ['woman', 'female', 'meditation', 'yoga', 'serenity', 'zen', 'mindfulness'],
        skinVariations: [
          {
            unified: '1F9D8-1F3FB-200D-2640-FE0F'
          },
          {
            unified: '1F9D8-1F3FC-200D-2640-FE0F'
          },
          {
            unified: '1F9D8-1F3FD-200D-2640-FE0F'
          },
          {
            unified: '1F9D8-1F3FE-200D-2640-FE0F'
          },
          {
            unified: '1F9D8-1F3FF-200D-2640-FE0F'
          }
        ],
        shortName: 'woman_in_lotus_position'
      },
      {
        name: 'Bath',
        unified: '1F6C0',
        keywords: ['clean', 'shower', 'bathroom'],
        skinVariations: [
          {
            unified: '1F6C0-1F3FB'
          },
          {
            unified: '1F6C0-1F3FC'
          },
          {
            unified: '1F6C0-1F3FD'
          },
          {
            unified: '1F6C0-1F3FE'
          },
          {
            unified: '1F6C0-1F3FF'
          }
        ],
        shortName: 'bath'
      },
      {
        name: 'Sleeping Accommodation',
        unified: '1F6CC',
        skinVariations: [
          {
            unified: '1F6CC-1F3FB'
          },
          {
            unified: '1F6CC-1F3FC'
          },
          {
            unified: '1F6CC-1F3FD'
          },
          {
            unified: '1F6CC-1F3FE'
          },
          {
            unified: '1F6CC-1F3FF'
          }
        ],
        shortName: 'sleeping_accommodation'
      },
      {
        name: 'People Holding Hands',
        unified: '1F9D1-200D-1F91D-200D-1F9D1',
        skinVariations: [
          {
            unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FB'
          },
          {
            unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FC'
          },
          {
            unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FD'
          },
          {
            unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FE'
          },
          {
            unified: '1F9D1-1F3FB-200D-1F91D-200D-1F9D1-1F3FF'
          },
          {
            unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FB'
          },
          {
            unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FC'
          },
          {
            unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FD'
          },
          {
            unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FE'
          },
          {
            unified: '1F9D1-1F3FC-200D-1F91D-200D-1F9D1-1F3FF'
          },
          {
            unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FB'
          },
          {
            unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FC'
          },
          {
            unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FD'
          },
          {
            unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FE'
          },
          {
            unified: '1F9D1-1F3FD-200D-1F91D-200D-1F9D1-1F3FF'
          },
          {
            unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FB'
          },
          {
            unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FC'
          },
          {
            unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FD'
          },
          {
            unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FE'
          },
          {
            unified: '1F9D1-1F3FE-200D-1F91D-200D-1F9D1-1F3FF'
          },
          {
            unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FB'
          },
          {
            unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FC'
          },
          {
            unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FD'
          },
          {
            unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FE'
          },
          {
            unified: '1F9D1-1F3FF-200D-1F91D-200D-1F9D1-1F3FF'
          }
        ],
        shortName: 'people_holding_hands'
      },
      {
        name: 'Two Women Holding Hands',
        unified: '1F46D',
        keywords: ['pair', 'friendship', 'couple', 'love', 'like', 'female', 'people', 'human'],
        skinVariations: [
          {
            unified: '1F46D-1F3FB'
          },
          {
            unified: '1F46D-1F3FC'
          },
          {
            unified: '1F46D-1F3FD'
          },
          {
            unified: '1F46D-1F3FE'
          },
          {
            unified: '1F46D-1F3FF'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FC'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FD'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FE'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F469-1F3FF'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FB'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FD'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FE'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F469-1F3FF'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FB'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FC'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FE'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F469-1F3FF'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FB'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FC'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FD'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F469-1F3FF'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FB'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FC'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FD'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F469-1F3FE'
          }
        ],
        shortNames: ['two_women_holding_hands', 'women_holding_hands'],
        shortName: 'two_women_holding_hands'
      },
      {
        name: 'Man and Woman Holding Hands',
        unified: '1F46B',
        keywords: ['pair', 'people', 'human', 'love', 'date', 'dating', 'like', 'affection', 'valentines', 'marriage'],
        skinVariations: [
          {
            unified: '1F46B-1F3FB'
          },
          {
            unified: '1F46B-1F3FC'
          },
          {
            unified: '1F46B-1F3FD'
          },
          {
            unified: '1F46B-1F3FE'
          },
          {
            unified: '1F46B-1F3FF'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FE'
          },
          {
            unified: '1F469-1F3FB-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FE'
          },
          {
            unified: '1F469-1F3FC-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FE'
          },
          {
            unified: '1F469-1F3FD-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F469-1F3FE-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F469-1F3FF-200D-1F91D-200D-1F468-1F3FE'
          }
        ],
        shortNames: ['couple', 'man_and_woman_holding_hands', 'woman_and_man_holding_hands'],
        shortName: 'couple'
      },
      {
        name: 'Two Men Holding Hands',
        unified: '1F46C',
        keywords: ['pair', 'couple', 'love', 'like', 'bromance', 'friendship', 'people', 'human'],
        skinVariations: [
          {
            unified: '1F46C-1F3FB'
          },
          {
            unified: '1F46C-1F3FC'
          },
          {
            unified: '1F46C-1F3FD'
          },
          {
            unified: '1F46C-1F3FE'
          },
          {
            unified: '1F46C-1F3FF'
          },
          {
            unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FE'
          },
          {
            unified: '1F468-1F3FB-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FE'
          },
          {
            unified: '1F468-1F3FC-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FE'
          },
          {
            unified: '1F468-1F3FD-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F468-1F3FE-200D-1F91D-200D-1F468-1F3FF'
          },
          {
            unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FB'
          },
          {
            unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FC'
          },
          {
            unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FD'
          },
          {
            unified: '1F468-1F3FF-200D-1F91D-200D-1F468-1F3FE'
          }
        ],
        shortNames: ['two_men_holding_hands', 'men_holding_hands'],
        shortName: 'two_men_holding_hands'
      },
      {
        name: 'Kiss',
        unified: '1F48F',
        shortName: 'couplekiss',
        obsoletedBy: '1F469-200D-2764-FE0F-200D-1F48B-200D-1F468'
      },
      {
        name: 'Woman Kiss Man',
        unified: '1F469-200D-2764-FE0F-200D-1F48B-200D-1F468',
        obsoletes: '1F48F',
        shortName: 'woman-kiss-man'
      },
      {
        name: 'Man Kiss Man',
        unified: '1F468-200D-2764-FE0F-200D-1F48B-200D-1F468',
        shortName: 'man-kiss-man'
      },
      {
        name: 'Woman Kiss Woman',
        unified: '1F469-200D-2764-FE0F-200D-1F48B-200D-1F469',
        shortName: 'woman-kiss-woman'
      },
      {
        name: 'Couple with Heart',
        unified: '1F491',
        shortName: 'couple_with_heart',
        obsoletedBy: '1F469-200D-2764-FE0F-200D-1F468'
      },
      {
        name: 'Woman Heart Man',
        unified: '1F469-200D-2764-FE0F-200D-1F468',
        obsoletes: '1F491',
        shortName: 'woman-heart-man'
      },
      {
        name: 'Man Heart Man',
        unified: '1F468-200D-2764-FE0F-200D-1F468',
        shortName: 'man-heart-man'
      },
      {
        name: 'Woman Heart Woman',
        unified: '1F469-200D-2764-FE0F-200D-1F469',
        shortName: 'woman-heart-woman'
      },
      {
        name: 'Family',
        unified: '1F46A',
        shortNames: ['family', 'man-woman-boy'],
        shortName: 'family',
        obsoletedBy: '1F468-200D-1F469-200D-1F466'
      },
      {
        name: 'Man Woman Boy',
        unified: '1F468-200D-1F469-200D-1F466',
        obsoletes: '1F46A',
        shortNames: ['man-woman-boy', 'family'],
        shortName: 'man-woman-boy'
      },
      {
        name: 'Man Woman Girl',
        unified: '1F468-200D-1F469-200D-1F467',
        shortName: 'man-woman-girl'
      },
      {
        name: 'Man Woman Girl Boy',
        unified: '1F468-200D-1F469-200D-1F467-200D-1F466',
        shortName: 'man-woman-girl-boy'
      },
      {
        name: 'Man Woman Boy Boy',
        unified: '1F468-200D-1F469-200D-1F466-200D-1F466',
        shortName: 'man-woman-boy-boy'
      },
      {
        name: 'Man Woman Girl Girl',
        unified: '1F468-200D-1F469-200D-1F467-200D-1F467',
        shortName: 'man-woman-girl-girl'
      },
      {
        name: 'Man Man Boy',
        unified: '1F468-200D-1F468-200D-1F466',
        shortName: 'man-man-boy'
      },
      {
        name: 'Man Man Girl',
        unified: '1F468-200D-1F468-200D-1F467',
        shortName: 'man-man-girl'
      },
      {
        name: 'Man Man Girl Boy',
        unified: '1F468-200D-1F468-200D-1F467-200D-1F466',
        shortName: 'man-man-girl-boy'
      },
      {
        name: 'Man Man Boy Boy',
        unified: '1F468-200D-1F468-200D-1F466-200D-1F466',
        shortName: 'man-man-boy-boy'
      },
      {
        name: 'Man Man Girl Girl',
        unified: '1F468-200D-1F468-200D-1F467-200D-1F467',
        shortName: 'man-man-girl-girl'
      },
      {
        name: 'Woman Woman Boy',
        unified: '1F469-200D-1F469-200D-1F466',
        shortName: 'woman-woman-boy'
      },
      {
        name: 'Woman Woman Girl',
        unified: '1F469-200D-1F469-200D-1F467',
        shortName: 'woman-woman-girl'
      },
      {
        name: 'Woman Woman Girl Boy',
        unified: '1F469-200D-1F469-200D-1F467-200D-1F466',
        shortName: 'woman-woman-girl-boy'
      },
      {
        name: 'Woman Woman Boy Boy',
        unified: '1F469-200D-1F469-200D-1F466-200D-1F466',
        shortName: 'woman-woman-boy-boy'
      },
      {
        name: 'Woman Woman Girl Girl',
        unified: '1F469-200D-1F469-200D-1F467-200D-1F467',
        shortName: 'woman-woman-girl-girl'
      },
      {
        name: 'Man Boy',
        unified: '1F468-200D-1F466',
        shortName: 'man-boy'
      },
      {
        name: 'Man Boy Boy',
        unified: '1F468-200D-1F466-200D-1F466',
        shortName: 'man-boy-boy'
      },
      {
        name: 'Man Girl',
        unified: '1F468-200D-1F467',
        shortName: 'man-girl'
      },
      {
        name: 'Man Girl Boy',
        unified: '1F468-200D-1F467-200D-1F466',
        shortName: 'man-girl-boy'
      },
      {
        name: 'Man Girl Girl',
        unified: '1F468-200D-1F467-200D-1F467',
        shortName: 'man-girl-girl'
      },
      {
        name: 'Woman Boy',
        unified: '1F469-200D-1F466',
        shortName: 'woman-boy'
      },
      {
        name: 'Woman Boy Boy',
        unified: '1F469-200D-1F466-200D-1F466',
        shortName: 'woman-boy-boy'
      },
      {
        name: 'Woman Girl',
        unified: '1F469-200D-1F467',
        shortName: 'woman-girl'
      },
      {
        name: 'Woman Girl Boy',
        unified: '1F469-200D-1F467-200D-1F466',
        shortName: 'woman-girl-boy'
      },
      {
        name: 'Woman Girl Girl',
        unified: '1F469-200D-1F467-200D-1F467',
        shortName: 'woman-girl-girl'
      },
      {
        name: 'Speaking Head in Silhouette',
        unified: '1F5E3-FE0F',
        shortName: 'speaking_head_in_silhouette'
      },
      {
        name: 'Bust in Silhouette',
        unified: '1F464',
        keywords: ['user', 'person', 'human'],
        shortName: 'bust_in_silhouette'
      },
      {
        name: 'Busts in Silhouette',
        unified: '1F465',
        keywords: ['user', 'person', 'human', 'group', 'team'],
        shortName: 'busts_in_silhouette'
      },
      {
        name: 'Footprints',
        unified: '1F463',
        keywords: ['feet', 'tracking', 'walking', 'beach'],
        shortName: 'footprints'
      },
      {
        name: 'Kiss Mark',
        unified: '1F48B',
        keywords: ['face', 'lips', 'love', 'like', 'affection', 'valentines'],
        shortName: 'kiss'
      },
      {
        name: 'Love Letter',
        unified: '1F48C',
        keywords: ['email', 'like', 'affection', 'envelope', 'valentines'],
        shortName: 'love_letter'
      },
      {
        name: 'Heart with Arrow',
        unified: '1F498',
        keywords: ['love', 'like', 'heart', 'affection', 'valentines'],
        shortName: 'cupid'
      },
      {
        name: 'Heart with Ribbon',
        unified: '1F49D',
        keywords: ['love', 'valentines'],
        shortName: 'gift_heart'
      },
      {
        name: 'Sparkling Heart',
        unified: '1F496',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'sparkling_heart'
      },
      {
        name: 'Growing Heart',
        unified: '1F497',
        keywords: ['like', 'love', 'affection', 'valentines', 'pink'],
        shortName: 'heartpulse'
      },
      {
        name: 'Beating Heart',
        unified: '1F493',
        keywords: ['love', 'like', 'affection', 'valentines', 'pink', 'heart'],
        shortName: 'heartbeat'
      },
      {
        name: 'Revolving Hearts',
        unified: '1F49E',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'revolving_hearts'
      },
      {
        name: 'Two Hearts',
        unified: '1F495',
        keywords: ['love', 'like', 'affection', 'valentines', 'heart'],
        shortName: 'two_hearts'
      },
      {
        name: 'Heart Decoration',
        unified: '1F49F',
        keywords: ['purple-square', 'love', 'like'],
        shortName: 'heart_decoration'
      },
      {
        name: 'Heavy Heart Exclamation Mark Ornament',
        unified: '2763-FE0F',
        shortName: 'heavy_heart_exclamation_mark_ornament'
      },
      {
        name: 'Broken Heart',
        unified: '1F494',
        text: '</3',
        emoticons: ['</3'],
        keywords: ['sad', 'sorry', 'break', 'heart', 'heartbreak'],
        shortName: 'broken_heart'
      },
      {
        name: 'Heavy Black Heart',
        unified: '2764-FE0F',
        text: '<3',
        emoticons: ['<3'],
        keywords: ['love', 'like', 'valentines'],
        shortName: 'heart'
      },
      {
        name: 'Orange Heart',
        unified: '1F9E1',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'orange_heart'
      },
      {
        name: 'Yellow Heart',
        unified: '1F49B',
        text: '<3',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'yellow_heart'
      },
      {
        name: 'Green Heart',
        unified: '1F49A',
        text: '<3',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'green_heart'
      },
      {
        name: 'Blue Heart',
        unified: '1F499',
        text: '<3',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'blue_heart'
      },
      {
        name: 'Purple Heart',
        unified: '1F49C',
        text: '<3',
        keywords: ['love', 'like', 'affection', 'valentines'],
        shortName: 'purple_heart'
      },
      {
        name: 'Brown Heart',
        unified: '1F90E',
        shortName: 'brown_heart'
      },
      {
        name: 'Black Heart',
        unified: '1F5A4',
        keywords: ['evil'],
        shortName: 'black_heart'
      },
      {
        name: 'White Heart',
        unified: '1F90D',
        shortName: 'white_heart'
      },
      {
        name: 'Hundred Points Symbol',
        unified: '1F4AF',
        keywords: ['score', 'perfect', 'numbers', 'century', 'exam', 'quiz', 'test', 'pass', 'hundred'],
        shortName: '100'
      },
      {
        name: 'Anger Symbol',
        unified: '1F4A2',
        keywords: ['angry', 'mad'],
        shortName: 'anger'
      },
      {
        name: 'Collision Symbol',
        unified: '1F4A5',
        keywords: ['bomb', 'explode', 'explosion', 'collision', 'blown'],
        shortNames: ['boom', 'collision'],
        shortName: 'boom'
      },
      {
        name: 'Dizzy Symbol',
        unified: '1F4AB',
        keywords: ['star', 'sparkle', 'shoot', 'magic'],
        shortName: 'dizzy'
      },
      {
        name: 'Splashing Sweat Symbol',
        unified: '1F4A6',
        keywords: ['water', 'drip', 'oops'],
        shortName: 'sweat_drops'
      },
      {
        name: 'Dash Symbol',
        unified: '1F4A8',
        keywords: ['wind', 'air', 'fast', 'shoo', 'fart', 'smoke', 'puff'],
        shortName: 'dash'
      },
      {
        name: 'Hole',
        unified: '1F573-FE0F',
        keywords: ['embarrassing'],
        shortName: 'hole'
      },
      {
        name: 'Bomb',
        unified: '1F4A3',
        keywords: ['boom', 'explode', 'explosion', 'terrorism'],
        shortName: 'bomb'
      },
      {
        name: 'Speech Balloon',
        unified: '1F4AC',
        keywords: ['bubble', 'words', 'message', 'talk', 'chatting'],
        shortName: 'speech_balloon'
      },
      {
        name: 'Eye in Speech Bubble',
        unified: '1F441-200D-1F5E8',
        shortName: 'eye-in-speech-bubble'
      },
      {
        name: 'Left Speech Bubble',
        unified: '1F5E8-FE0F',
        keywords: ['words', 'message', 'talk', 'chatting'],
        shortName: 'left_speech_bubble'
      },
      {
        name: 'Right Anger Bubble',
        unified: '1F5EF-FE0F',
        keywords: ['caption', 'speech', 'thinking', 'mad'],
        shortName: 'right_anger_bubble'
      },
      {
        name: 'Thought Balloon',
        unified: '1F4AD',
        keywords: ['bubble', 'cloud', 'speech', 'thinking', 'dream'],
        shortName: 'thought_balloon'
      },
      {
        name: 'Sleeping Symbol',
        unified: '1F4A4',
        keywords: ['sleepy', 'tired', 'dream'],
        shortName: 'zzz'
      }
    ]
  },
  {
    id: 'nature',
    name: 'Animals & Nature',
    emojis: [
      {
        name: 'Monkey Face',
        unified: '1F435',
        emoticons: [':o)'],
        keywords: ['animal', 'nature', 'circus'],
        shortName: 'monkey_face'
      },
      {
        name: 'Monkey',
        unified: '1F412',
        keywords: ['animal', 'nature', 'banana', 'circus'],
        shortName: 'monkey'
      },
      {
        name: 'Gorilla',
        unified: '1F98D',
        keywords: ['animal', 'nature', 'circus'],
        shortName: 'gorilla'
      },
      {
        name: 'Orangutan',
        unified: '1F9A7',
        shortName: 'orangutan'
      },
      {
        name: 'Dog Face',
        unified: '1F436',
        keywords: ['animal', 'friend', 'nature', 'woof', 'puppy', 'pet', 'faithful'],
        shortName: 'dog'
      },
      {
        name: 'Dog',
        unified: '1F415',
        keywords: ['animal', 'nature', 'friend', 'doge', 'pet', 'faithful'],
        shortName: 'dog2'
      },
      {
        name: 'Guide Dog',
        unified: '1F9AE',
        shortName: 'guide_dog'
      },
      {
        name: 'Service Dog',
        unified: '1F415-200D-1F9BA',
        shortName: 'service_dog'
      },
      {
        name: 'Poodle',
        unified: '1F429',
        keywords: ['dog', 'animal', '101', 'nature', 'pet'],
        shortName: 'poodle'
      },
      {
        name: 'Wolf Face',
        unified: '1F43A',
        keywords: ['animal', 'nature', 'wild'],
        shortName: 'wolf'
      },
      {
        name: 'Fox Face',
        unified: '1F98A',
        keywords: ['animal', 'nature', 'face'],
        shortName: 'fox_face'
      },
      {
        name: 'Raccoon',
        unified: '1F99D',
        keywords: ['animal', 'nature'],
        shortName: 'raccoon'
      },
      {
        name: 'Cat Face',
        unified: '1F431',
        keywords: ['animal', 'meow', 'nature', 'pet', 'kitten'],
        shortName: 'cat'
      },
      {
        name: 'Cat',
        unified: '1F408',
        keywords: ['animal', 'meow', 'pet', 'cats'],
        shortName: 'cat2'
      },
      {
        name: 'Lion Face',
        unified: '1F981',
        shortName: 'lion_face'
      },
      {
        name: 'Tiger Face',
        unified: '1F42F',
        keywords: ['animal', 'cat', 'danger', 'wild', 'nature', 'roar'],
        shortName: 'tiger'
      },
      {
        name: 'Tiger',
        unified: '1F405',
        keywords: ['animal', 'nature', 'roar'],
        shortName: 'tiger2'
      },
      {
        name: 'Leopard',
        unified: '1F406',
        keywords: ['animal', 'nature'],
        shortName: 'leopard'
      },
      {
        name: 'Horse Face',
        unified: '1F434',
        keywords: ['animal', 'brown', 'nature'],
        shortName: 'horse'
      },
      {
        name: 'Horse',
        unified: '1F40E',
        keywords: ['animal', 'gamble', 'luck'],
        shortName: 'racehorse'
      },
      {
        name: 'Unicorn Face',
        unified: '1F984',
        shortName: 'unicorn_face'
      },
      {
        name: 'Zebra Face',
        unified: '1F993',
        shortName: 'zebra_face'
      },
      {
        name: 'Deer',
        unified: '1F98C',
        keywords: ['animal', 'nature', 'horns', 'venison'],
        shortName: 'deer'
      },
      {
        name: 'Cow Face',
        unified: '1F42E',
        keywords: ['beef', 'ox', 'animal', 'nature', 'moo', 'milk'],
        shortName: 'cow'
      },
      {
        name: 'Ox',
        unified: '1F402',
        keywords: ['animal', 'cow', 'beef'],
        shortName: 'ox'
      },
      {
        name: 'Water Buffalo',
        unified: '1F403',
        keywords: ['animal', 'nature', 'ox', 'cow'],
        shortName: 'water_buffalo'
      },
      {
        name: 'Cow',
        unified: '1F404',
        keywords: ['beef', 'ox', 'animal', 'nature', 'moo', 'milk'],
        shortName: 'cow2'
      },
      {
        name: 'Pig Face',
        unified: '1F437',
        keywords: ['animal', 'oink', 'nature'],
        shortName: 'pig'
      },
      {
        name: 'Pig',
        unified: '1F416',
        keywords: ['animal', 'nature'],
        shortName: 'pig2'
      },
      {
        name: 'Boar',
        unified: '1F417',
        keywords: ['animal', 'nature'],
        shortName: 'boar'
      },
      {
        name: 'Pig Nose',
        unified: '1F43D',
        keywords: ['animal', 'oink'],
        shortName: 'pig_nose'
      },
      {
        name: 'Ram',
        unified: '1F40F',
        keywords: ['animal', 'sheep', 'nature'],
        shortName: 'ram'
      },
      {
        name: 'Sheep',
        unified: '1F411',
        keywords: ['animal', 'nature', 'wool', 'shipit'],
        shortName: 'sheep'
      },
      {
        name: 'Goat',
        unified: '1F410',
        keywords: ['animal', 'nature'],
        shortName: 'goat'
      },
      {
        name: 'Dromedary Camel',
        unified: '1F42A',
        keywords: ['animal', 'hot', 'desert', 'hump'],
        shortName: 'dromedary_camel'
      },
      {
        name: 'Bactrian Camel',
        unified: '1F42B',
        keywords: ['animal', 'nature', 'hot', 'desert', 'hump'],
        shortName: 'camel'
      },
      {
        name: 'Llama',
        unified: '1F999',
        keywords: ['animal', 'nature', 'alpaca'],
        shortName: 'llama'
      },
      {
        name: 'Giraffe Face',
        unified: '1F992',
        shortName: 'giraffe_face'
      },
      {
        name: 'Elephant',
        unified: '1F418',
        keywords: ['animal', 'nature', 'nose', 'th', 'circus'],
        shortName: 'elephant'
      },
      {
        name: 'Rhinoceros',
        unified: '1F98F',
        keywords: ['animal', 'nature', 'horn'],
        shortName: 'rhinoceros'
      },
      {
        name: 'Hippopotamus',
        unified: '1F99B',
        keywords: ['animal', 'nature'],
        shortName: 'hippopotamus'
      },
      {
        name: 'Mouse Face',
        unified: '1F42D',
        keywords: ['animal', 'nature', 'cheese_wedge', 'rodent'],
        shortName: 'mouse'
      },
      {
        name: 'Mouse',
        unified: '1F401',
        keywords: ['animal', 'nature', 'rodent'],
        shortName: 'mouse2'
      },
      {
        name: 'Rat',
        unified: '1F400',
        keywords: ['animal', 'mouse', 'rodent'],
        shortName: 'rat'
      },
      {
        name: 'Hamster Face',
        unified: '1F439',
        keywords: ['animal', 'nature'],
        shortName: 'hamster'
      },
      {
        name: 'Rabbit Face',
        unified: '1F430',
        keywords: ['animal', 'nature', 'pet', 'spring', 'magic', 'bunny'],
        shortName: 'rabbit'
      },
      {
        name: 'Rabbit',
        unified: '1F407',
        keywords: ['animal', 'nature', 'pet', 'magic', 'spring'],
        shortName: 'rabbit2'
      },
      {
        name: 'Chipmunk',
        unified: '1F43F-FE0F',
        keywords: ['animal', 'nature', 'rodent', 'squirrel'],
        shortName: 'chipmunk'
      },
      {
        name: 'Hedgehog',
        unified: '1F994',
        keywords: ['animal', 'nature', 'spiny'],
        shortName: 'hedgehog'
      },
      {
        name: 'Bat',
        unified: '1F987',
        keywords: ['animal', 'nature', 'blind', 'vampire'],
        shortName: 'bat'
      },
      {
        name: 'Bear Face',
        unified: '1F43B',
        keywords: ['animal', 'nature', 'wild'],
        shortName: 'bear'
      },
      {
        name: 'Koala',
        unified: '1F428',
        keywords: ['animal', 'nature'],
        shortName: 'koala'
      },
      {
        name: 'Panda Face',
        unified: '1F43C',
        keywords: ['animal', 'nature', 'panda'],
        shortName: 'panda_face'
      },
      {
        name: 'Sloth',
        unified: '1F9A5',
        shortName: 'sloth'
      },
      {
        name: 'Otter',
        unified: '1F9A6',
        shortName: 'otter'
      },
      {
        name: 'Skunk',
        unified: '1F9A8',
        shortName: 'skunk'
      },
      {
        name: 'Kangaroo',
        unified: '1F998',
        keywords: ['animal', 'nature', 'australia', 'joey', 'hop', 'marsupial'],
        shortName: 'kangaroo'
      },
      {
        name: 'Badger',
        unified: '1F9A1',
        keywords: ['animal', 'nature', 'honey'],
        shortName: 'badger'
      },
      {
        name: 'Paw Prints',
        unified: '1F43E',
        shortNames: ['feet', 'paw_prints'],
        shortName: 'feet'
      },
      {
        name: 'Turkey',
        unified: '1F983',
        keywords: ['animal', 'bird'],
        shortName: 'turkey'
      },
      {
        name: 'Chicken',
        unified: '1F414',
        keywords: ['animal', 'cluck', 'nature', 'bird'],
        shortName: 'chicken'
      },
      {
        name: 'Rooster',
        unified: '1F413',
        keywords: ['animal', 'nature', 'chicken'],
        shortName: 'rooster'
      },
      {
        name: 'Hatching Chick',
        unified: '1F423',
        keywords: ['animal', 'chicken', 'egg', 'born', 'baby', 'bird'],
        shortName: 'hatching_chick'
      },
      {
        name: 'Baby Chick',
        unified: '1F424',
        keywords: ['animal', 'chicken', 'bird'],
        shortName: 'baby_chick'
      },
      {
        name: 'Front-Facing Baby Chick',
        unified: '1F425',
        keywords: ['animal', 'chicken', 'baby', 'bird'],
        shortName: 'hatched_chick'
      },
      {
        name: 'Bird',
        unified: '1F426',
        keywords: ['animal', 'nature', 'fly', 'tweet', 'spring'],
        shortName: 'bird'
      },
      {
        name: 'Penguin',
        unified: '1F427',
        keywords: ['animal', 'nature'],
        shortName: 'penguin'
      },
      {
        name: 'Dove of Peace',
        unified: '1F54A-FE0F',
        shortName: 'dove_of_peace'
      },
      {
        name: 'Eagle',
        unified: '1F985',
        keywords: ['animal', 'nature', 'bird'],
        shortName: 'eagle'
      },
      {
        name: 'Duck',
        unified: '1F986',
        keywords: ['animal', 'nature', 'bird', 'mallard'],
        shortName: 'duck'
      },
      {
        name: 'Swan',
        unified: '1F9A2',
        keywords: ['animal', 'nature', 'bird'],
        shortName: 'swan'
      },
      {
        name: 'Owl',
        unified: '1F989',
        keywords: ['animal', 'nature', 'bird', 'hoot'],
        shortName: 'owl'
      },
      {
        name: 'Flamingo',
        unified: '1F9A9',
        shortName: 'flamingo'
      },
      {
        name: 'Peacock',
        unified: '1F99A',
        keywords: ['animal', 'nature', 'peahen', 'bird'],
        shortName: 'peacock'
      },
      {
        name: 'Parrot',
        unified: '1F99C',
        keywords: ['animal', 'nature', 'bird', 'pirate', 'talk'],
        shortName: 'parrot'
      },
      {
        name: 'Frog Face',
        unified: '1F438',
        keywords: ['animal', 'nature', 'croak', 'toad'],
        shortName: 'frog'
      },
      {
        name: 'Crocodile',
        unified: '1F40A',
        keywords: ['animal', 'nature', 'reptile', 'lizard', 'alligator'],
        shortName: 'crocodile'
      },
      {
        name: 'Turtle',
        unified: '1F422',
        keywords: ['animal', 'slow', 'nature', 'tortoise'],
        shortName: 'turtle'
      },
      {
        name: 'Lizard',
        unified: '1F98E',
        keywords: ['animal', 'nature', 'reptile'],
        shortName: 'lizard'
      },
      {
        name: 'Snake',
        unified: '1F40D',
        keywords: ['animal', 'evil', 'nature', 'hiss', 'python'],
        shortName: 'snake'
      },
      {
        name: 'Dragon Face',
        unified: '1F432',
        keywords: ['animal', 'myth', 'nature', 'chinese', 'green'],
        shortName: 'dragon_face'
      },
      {
        name: 'Dragon',
        unified: '1F409',
        keywords: ['animal', 'myth', 'nature', 'chinese', 'green'],
        shortName: 'dragon'
      },
      {
        name: 'Sauropod',
        unified: '1F995',
        keywords: ['animal', 'nature', 'dinosaur', 'brachiosaurus', 'brontosaurus', 'diplodocus', 'extinct'],
        shortName: 'sauropod'
      },
      {
        name: 'T-Rex',
        unified: '1F996',
        keywords: ['animal', 'nature', 'dinosaur', 'tyrannosaurus', 'extinct'],
        shortName: 't-rex'
      },
      {
        name: 'Spouting Whale',
        unified: '1F433',
        keywords: ['animal', 'nature', 'sea', 'ocean'],
        shortName: 'whale'
      },
      {
        name: 'Whale',
        unified: '1F40B',
        keywords: ['animal', 'nature', 'sea', 'ocean'],
        shortName: 'whale2'
      },
      {
        name: 'Dolphin',
        unified: '1F42C',
        keywords: ['animal', 'nature', 'fish', 'sea', 'ocean', 'flipper', 'fins', 'beach'],
        shortNames: ['dolphin', 'flipper'],
        shortName: 'dolphin'
      },
      {
        name: 'Fish',
        unified: '1F41F',
        keywords: ['animal', 'food', 'nature'],
        shortName: 'fish'
      },
      {
        name: 'Tropical Fish',
        unified: '1F420',
        keywords: ['animal', 'swim', 'ocean', 'beach', 'nemo'],
        shortName: 'tropical_fish'
      },
      {
        name: 'Blowfish',
        unified: '1F421',
        keywords: ['animal', 'nature', 'food', 'sea', 'ocean'],
        shortName: 'blowfish'
      },
      {
        name: 'Shark',
        unified: '1F988',
        keywords: ['animal', 'nature', 'fish', 'sea', 'ocean', 'jaws', 'fins', 'beach'],
        shortName: 'shark'
      },
      {
        name: 'Octopus',
        unified: '1F419',
        keywords: ['animal', 'creature', 'ocean', 'sea', 'nature', 'beach'],
        shortName: 'octopus'
      },
      {
        name: 'Spiral Shell',
        unified: '1F41A',
        keywords: ['nature', 'sea', 'beach'],
        shortName: 'shell'
      },
      {
        name: 'Snail',
        unified: '1F40C',
        keywords: ['slow', 'animal', 'shell'],
        shortName: 'snail'
      },
      {
        name: 'Butterfly',
        unified: '1F98B',
        keywords: ['animal', 'insect', 'nature', 'caterpillar'],
        shortName: 'butterfly'
      },
      {
        name: 'Bug',
        unified: '1F41B',
        keywords: ['animal', 'insect', 'nature', 'worm'],
        shortName: 'bug'
      },
      {
        name: 'Ant',
        unified: '1F41C',
        keywords: ['animal', 'insect', 'nature', 'bug'],
        shortName: 'ant'
      },
      {
        name: 'Honeybee',
        unified: '1F41D',
        shortNames: ['bee', 'honeybee'],
        shortName: 'bee'
      },
      {
        name: 'Lady Beetle',
        unified: '1F41E',
        keywords: ['animal', 'insect', 'nature', 'ladybug'],
        shortName: 'beetle'
      },
      {
        name: 'Cricket',
        unified: '1F997',
        keywords: ['sports'],
        shortName: 'cricket'
      },
      {
        name: 'Spider',
        unified: '1F577-FE0F',
        keywords: ['animal', 'arachnid'],
        shortName: 'spider'
      },
      {
        name: 'Spider Web',
        unified: '1F578-FE0F',
        keywords: ['animal', 'insect', 'arachnid', 'silk'],
        shortName: 'spider_web'
      },
      {
        name: 'Scorpion',
        unified: '1F982',
        keywords: ['animal', 'arachnid'],
        shortName: 'scorpion'
      },
      {
        name: 'Mosquito',
        unified: '1F99F',
        keywords: ['animal', 'nature', 'insect', 'malaria'],
        shortName: 'mosquito'
      },
      {
        name: 'Microbe',
        unified: '1F9A0',
        keywords: ['amoeba', 'bacteria', 'germs'],
        shortName: 'microbe'
      },
      {
        name: 'Bouquet',
        unified: '1F490',
        keywords: ['flowers', 'nature', 'spring'],
        shortName: 'bouquet'
      },
      {
        name: 'Cherry Blossom',
        unified: '1F338',
        keywords: ['nature', 'plant', 'spring', 'flower'],
        shortName: 'cherry_blossom'
      },
      {
        name: 'White Flower',
        unified: '1F4AE',
        keywords: ['japanese', 'spring'],
        shortName: 'white_flower'
      },
      {
        name: 'Rosette',
        unified: '1F3F5-FE0F',
        keywords: ['flower', 'decoration', 'military'],
        shortName: 'rosette'
      },
      {
        name: 'Rose',
        unified: '1F339',
        keywords: ['flowers', 'valentines', 'love', 'spring'],
        shortName: 'rose'
      },
      {
        name: 'Wilted Flower',
        unified: '1F940',
        keywords: ['plant', 'nature', 'flower'],
        shortName: 'wilted_flower'
      },
      {
        name: 'Hibiscus',
        unified: '1F33A',
        keywords: ['plant', 'vegetable', 'flowers', 'beach'],
        shortName: 'hibiscus'
      },
      {
        name: 'Sunflower',
        unified: '1F33B',
        keywords: ['nature', 'plant', 'fall'],
        shortName: 'sunflower'
      },
      {
        name: 'Blossom',
        unified: '1F33C',
        keywords: ['nature', 'flowers', 'yellow'],
        shortName: 'blossom'
      },
      {
        name: 'Tulip',
        unified: '1F337',
        keywords: ['flowers', 'plant', 'nature', 'summer', 'spring'],
        shortName: 'tulip'
      },
      {
        name: 'Seedling',
        unified: '1F331',
        keywords: ['plant', 'nature', 'grass', 'lawn', 'spring'],
        shortName: 'seedling'
      },
      {
        name: 'Evergreen Tree',
        unified: '1F332',
        keywords: ['plant', 'nature'],
        shortName: 'evergreen_tree'
      },
      {
        name: 'Deciduous Tree',
        unified: '1F333',
        keywords: ['plant', 'nature'],
        shortName: 'deciduous_tree'
      },
      {
        name: 'Palm Tree',
        unified: '1F334',
        keywords: ['plant', 'vegetable', 'nature', 'summer', 'beach', 'mojito', 'tropical'],
        shortName: 'palm_tree'
      },
      {
        name: 'Cactus',
        unified: '1F335',
        keywords: ['vegetable', 'plant', 'nature'],
        shortName: 'cactus'
      },
      {
        name: 'Ear of Rice',
        unified: '1F33E',
        keywords: ['nature', 'plant'],
        shortName: 'ear_of_rice'
      },
      {
        name: 'Herb',
        unified: '1F33F',
        keywords: ['vegetable', 'plant', 'medicine', 'weed', 'grass', 'lawn'],
        shortName: 'herb'
      },
      {
        name: 'Shamrock',
        unified: '2618-FE0F',
        keywords: ['vegetable', 'plant', 'nature', 'irish', 'clover'],
        shortName: 'shamrock'
      },
      {
        name: 'Four Leaf Clover',
        unified: '1F340',
        keywords: ['vegetable', 'plant', 'nature', 'lucky', 'irish'],
        shortName: 'four_leaf_clover'
      },
      {
        name: 'Maple Leaf',
        unified: '1F341',
        keywords: ['nature', 'plant', 'vegetable', 'ca', 'fall'],
        shortName: 'maple_leaf'
      },
      {
        name: 'Fallen Leaf',
        unified: '1F342',
        keywords: ['nature', 'plant', 'vegetable', 'leaves'],
        shortName: 'fallen_leaf'
      },
      {
        name: 'Leaf Fluttering in Wind',
        unified: '1F343',
        keywords: ['nature', 'plant', 'tree', 'vegetable', 'grass', 'lawn', 'spring'],
        shortName: 'leaves'
      }
    ]
  },
  {
    id: 'foods',
    name: 'Food & Drink',
    emojis: [
      {
        name: 'Grapes',
        unified: '1F347',
        keywords: ['fruit', 'food', 'wine'],
        shortName: 'grapes'
      },
      {
        name: 'Melon',
        unified: '1F348',
        keywords: ['fruit', 'nature', 'food'],
        shortName: 'melon'
      },
      {
        name: 'Watermelon',
        unified: '1F349',
        keywords: ['fruit', 'food', 'picnic', 'summer'],
        shortName: 'watermelon'
      },
      {
        name: 'Tangerine',
        unified: '1F34A',
        keywords: ['food', 'fruit', 'nature', 'orange'],
        shortName: 'tangerine'
      },
      {
        name: 'Lemon',
        unified: '1F34B',
        keywords: ['fruit', 'nature'],
        shortName: 'lemon'
      },
      {
        name: 'Banana',
        unified: '1F34C',
        keywords: ['fruit', 'food', 'monkey'],
        shortName: 'banana'
      },
      {
        name: 'Pineapple',
        unified: '1F34D',
        keywords: ['fruit', 'nature', 'food'],
        shortName: 'pineapple'
      },
      {
        name: 'Mango',
        unified: '1F96D',
        keywords: ['fruit', 'food', 'tropical'],
        shortName: 'mango'
      },
      {
        name: 'Red Apple',
        unified: '1F34E',
        keywords: ['fruit', 'mac', 'school'],
        shortName: 'apple'
      },
      {
        name: 'Green Apple',
        unified: '1F34F',
        keywords: ['fruit', 'nature'],
        shortName: 'green_apple'
      },
      {
        name: 'Pear',
        unified: '1F350',
        keywords: ['fruit', 'nature', 'food'],
        shortName: 'pear'
      },
      {
        name: 'Peach',
        unified: '1F351',
        keywords: ['fruit', 'nature', 'food'],
        shortName: 'peach'
      },
      {
        name: 'Cherries',
        unified: '1F352',
        keywords: ['food', 'fruit'],
        shortName: 'cherries'
      },
      {
        name: 'Strawberry',
        unified: '1F353',
        keywords: ['fruit', 'food', 'nature'],
        shortName: 'strawberry'
      },
      {
        name: 'Kiwifruit',
        unified: '1F95D',
        shortName: 'kiwifruit'
      },
      {
        name: 'Tomato',
        unified: '1F345',
        keywords: ['fruit', 'vegetable', 'nature', 'food'],
        shortName: 'tomato'
      },
      {
        name: 'Coconut',
        unified: '1F965',
        keywords: ['fruit', 'nature', 'food', 'palm'],
        shortName: 'coconut'
      },
      {
        name: 'Avocado',
        unified: '1F951',
        keywords: ['fruit', 'food'],
        shortName: 'avocado'
      },
      {
        name: 'Aubergine',
        unified: '1F346',
        keywords: ['vegetable', 'nature', 'food', 'aubergine'],
        shortName: 'eggplant'
      },
      {
        name: 'Potato',
        unified: '1F954',
        keywords: ['food', 'tuber', 'vegatable', 'starch'],
        shortName: 'potato'
      },
      {
        name: 'Carrot',
        unified: '1F955',
        keywords: ['vegetable', 'food', 'orange'],
        shortName: 'carrot'
      },
      {
        name: 'Ear of Maize',
        unified: '1F33D',
        keywords: ['food', 'vegetable', 'plant'],
        shortName: 'corn'
      },
      {
        name: 'Hot Pepper',
        unified: '1F336-FE0F',
        keywords: ['food', 'spicy', 'chilli', 'chili'],
        shortName: 'hot_pepper'
      },
      {
        name: 'Cucumber',
        unified: '1F952',
        keywords: ['fruit', 'food', 'pickle'],
        shortName: 'cucumber'
      },
      {
        name: 'Leafy Green',
        unified: '1F96C',
        shortName: 'leafy_green'
      },
      {
        name: 'Broccoli',
        unified: '1F966',
        keywords: ['fruit', 'food', 'vegetable'],
        shortName: 'broccoli'
      },
      {
        name: 'Garlic',
        unified: '1F9C4',
        shortName: 'garlic'
      },
      {
        name: 'Onion',
        unified: '1F9C5',
        shortName: 'onion'
      },
      {
        name: 'Mushroom',
        unified: '1F344',
        keywords: ['plant', 'vegetable'],
        shortName: 'mushroom'
      },
      {
        name: 'Peanuts',
        unified: '1F95C',
        keywords: ['food', 'nut'],
        shortName: 'peanuts'
      },
      {
        name: 'Chestnut',
        unified: '1F330',
        keywords: ['food', 'squirrel'],
        shortName: 'chestnut'
      },
      {
        name: 'Bread',
        unified: '1F35E',
        keywords: ['food', 'wheat', 'breakfast', 'toast'],
        shortName: 'bread'
      },
      {
        name: 'Croissant',
        unified: '1F950',
        keywords: ['food', 'bread', 'french'],
        shortName: 'croissant'
      },
      {
        name: 'Baguette Bread',
        unified: '1F956',
        keywords: ['food', 'bread', 'french'],
        shortName: 'baguette_bread'
      },
      {
        name: 'Pretzel',
        unified: '1F968',
        keywords: ['food', 'bread', 'twisted'],
        shortName: 'pretzel'
      },
      {
        name: 'Bagel',
        unified: '1F96F',
        keywords: ['food', 'bread', 'bakery', 'schmear'],
        shortName: 'bagel'
      },
      {
        name: 'Pancakes',
        unified: '1F95E',
        keywords: ['food', 'breakfast', 'flapjacks', 'hotcakes'],
        shortName: 'pancakes'
      },
      {
        name: 'Waffle',
        unified: '1F9C7',
        shortName: 'waffle'
      },
      {
        name: 'Cheese Wedge',
        unified: '1F9C0',
        shortName: 'cheese_wedge'
      },
      {
        name: 'Meat on Bone',
        unified: '1F356',
        keywords: ['good', 'food', 'drumstick'],
        shortName: 'meat_on_bone'
      },
      {
        name: 'Poultry Leg',
        unified: '1F357',
        keywords: ['food', 'meat', 'drumstick', 'bird', 'chicken', 'turkey'],
        shortName: 'poultry_leg'
      },
      {
        name: 'Cut of Meat',
        unified: '1F969',
        shortName: 'cut_of_meat'
      },
      {
        name: 'Bacon',
        unified: '1F953',
        keywords: ['food', 'breakfast', 'pork', 'pig', 'meat'],
        shortName: 'bacon'
      },
      {
        name: 'Hamburger',
        unified: '1F354',
        keywords: ['meat', 'fast food', 'beef', 'cheeseburger', 'mcdonalds', 'burger king'],
        shortName: 'hamburger'
      },
      {
        name: 'French Fries',
        unified: '1F35F',
        keywords: ['chips', 'snack', 'fast food'],
        shortName: 'fries'
      },
      {
        name: 'Slice of Pizza',
        unified: '1F355',
        keywords: ['food', 'party'],
        shortName: 'pizza'
      },
      {
        name: 'Hot Dog',
        unified: '1F32D',
        keywords: ['food', 'frankfurter'],
        shortName: 'hotdog'
      },
      {
        name: 'Sandwich',
        unified: '1F96A',
        keywords: ['food', 'lunch', 'bread'],
        shortName: 'sandwich'
      },
      {
        name: 'Taco',
        unified: '1F32E',
        keywords: ['food', 'mexican'],
        shortName: 'taco'
      },
      {
        name: 'Burrito',
        unified: '1F32F',
        keywords: ['food', 'mexican'],
        shortName: 'burrito'
      },
      {
        name: 'Stuffed Flatbread',
        unified: '1F959',
        keywords: ['food', 'flatbread', 'stuffed', 'gyro'],
        shortName: 'stuffed_flatbread'
      },
      {
        name: 'Falafel',
        unified: '1F9C6',
        shortName: 'falafel'
      },
      {
        name: 'Egg',
        unified: '1F95A',
        keywords: ['food', 'chicken', 'breakfast'],
        shortName: 'egg'
      },
      {
        name: 'Cooking',
        unified: '1F373',
        keywords: ['food', 'breakfast', 'kitchen', 'egg'],
        shortNames: ['fried_egg', 'cooking'],
        shortName: 'fried_egg'
      },
      {
        name: 'Shallow Pan of Food',
        unified: '1F958',
        keywords: ['food', 'cooking', 'casserole', 'paella'],
        shortName: 'shallow_pan_of_food'
      },
      {
        name: 'Pot of Food',
        unified: '1F372',
        keywords: ['food', 'meat', 'soup'],
        shortName: 'stew'
      },
      {
        name: 'Bowl with Spoon',
        unified: '1F963',
        keywords: ['food', 'breakfast', 'cereal', 'oatmeal', 'porridge'],
        shortName: 'bowl_with_spoon'
      },
      {
        name: 'Green Salad',
        unified: '1F957',
        keywords: ['food', 'healthy', 'lettuce'],
        shortName: 'green_salad'
      },
      {
        name: 'Popcorn',
        unified: '1F37F',
        keywords: ['food', 'movie theater', 'films', 'snack'],
        shortName: 'popcorn'
      },
      {
        name: 'Butter',
        unified: '1F9C8',
        shortName: 'butter'
      },
      {
        name: 'Salt Shaker',
        unified: '1F9C2',
        keywords: ['condiment', 'shaker'],
        shortName: 'salt'
      },
      {
        name: 'Canned Food',
        unified: '1F96B',
        keywords: ['food', 'soup'],
        shortName: 'canned_food'
      },
      {
        name: 'Bento Box',
        unified: '1F371',
        keywords: ['food', 'japanese', 'box'],
        shortName: 'bento'
      },
      {
        name: 'Rice Cracker',
        unified: '1F358',
        keywords: ['food', 'japanese'],
        shortName: 'rice_cracker'
      },
      {
        name: 'Rice Ball',
        unified: '1F359',
        keywords: ['food', 'japanese'],
        shortName: 'rice_ball'
      },
      {
        name: 'Cooked Rice',
        unified: '1F35A',
        keywords: ['food', 'china', 'asian'],
        shortName: 'rice'
      },
      {
        name: 'Curry and Rice',
        unified: '1F35B',
        keywords: ['food', 'spicy', 'hot', 'indian'],
        shortName: 'curry'
      },
      {
        name: 'Steaming Bowl',
        unified: '1F35C',
        keywords: ['food', 'japanese', 'noodle', 'chopsticks'],
        shortName: 'ramen'
      },
      {
        name: 'Spaghetti',
        unified: '1F35D',
        keywords: ['food', 'italian', 'noodle'],
        shortName: 'spaghetti'
      },
      {
        name: 'Roasted Sweet Potato',
        unified: '1F360',
        keywords: ['food', 'nature'],
        shortName: 'sweet_potato'
      },
      {
        name: 'Oden',
        unified: '1F362',
        keywords: ['food', 'japanese'],
        shortName: 'oden'
      },
      {
        name: 'Sushi',
        unified: '1F363',
        keywords: ['food', 'fish', 'japanese', 'rice'],
        shortName: 'sushi'
      },
      {
        name: 'Fried Shrimp',
        unified: '1F364',
        keywords: ['food', 'animal', 'appetizer', 'summer'],
        shortName: 'fried_shrimp'
      },
      {
        name: 'Fish Cake with Swirl Design',
        unified: '1F365',
        keywords: ['food', 'japan', 'sea', 'beach', 'narutomaki', 'pink', 'swirl', 'kamaboko', 'surimi', 'ramen'],
        shortName: 'fish_cake'
      },
      {
        name: 'Moon Cake',
        unified: '1F96E',
        keywords: ['food', 'autumn'],
        shortName: 'moon_cake'
      },
      {
        name: 'Dango',
        unified: '1F361',
        keywords: ['food', 'dessert', 'sweet', 'japanese', 'barbecue', 'meat'],
        shortName: 'dango'
      },
      {
        name: 'Dumpling',
        unified: '1F95F',
        keywords: ['food', 'empanada', 'pierogi', 'potsticker'],
        shortName: 'dumpling'
      },
      {
        name: 'Fortune Cookie',
        unified: '1F960',
        keywords: ['food', 'prophecy'],
        shortName: 'fortune_cookie'
      },
      {
        name: 'Takeout Box',
        unified: '1F961',
        keywords: ['food', 'leftovers'],
        shortName: 'takeout_box'
      },
      {
        name: 'Crab',
        unified: '1F980',
        keywords: ['animal', 'crustacean'],
        shortName: 'crab'
      },
      {
        name: 'Lobster',
        unified: '1F99E',
        keywords: ['animal', 'nature', 'bisque', 'claws', 'seafood'],
        shortName: 'lobster'
      },
      {
        name: 'Shrimp',
        unified: '1F990',
        keywords: ['animal', 'ocean', 'nature', 'seafood'],
        shortName: 'shrimp'
      },
      {
        name: 'Squid',
        unified: '1F991',
        keywords: ['animal', 'nature', 'ocean', 'sea'],
        shortName: 'squid'
      },
      {
        name: 'Oyster',
        unified: '1F9AA',
        shortName: 'oyster'
      },
      {
        name: 'Soft Ice Cream',
        unified: '1F366',
        keywords: ['food', 'hot', 'dessert', 'summer'],
        shortName: 'icecream'
      },
      {
        name: 'Shaved Ice',
        unified: '1F367',
        keywords: ['hot', 'dessert', 'summer'],
        shortName: 'shaved_ice'
      },
      {
        name: 'Ice Cream',
        unified: '1F368',
        keywords: ['food', 'hot', 'dessert'],
        shortName: 'ice_cream'
      },
      {
        name: 'Doughnut',
        unified: '1F369',
        keywords: ['food', 'dessert', 'snack', 'sweet', 'donut'],
        shortName: 'doughnut'
      },
      {
        name: 'Cookie',
        unified: '1F36A',
        keywords: ['food', 'snack', 'oreo', 'chocolate', 'sweet', 'dessert'],
        shortName: 'cookie'
      },
      {
        name: 'Birthday Cake',
        unified: '1F382',
        keywords: ['food', 'dessert', 'cake'],
        shortName: 'birthday'
      },
      {
        name: 'Shortcake',
        unified: '1F370',
        keywords: ['food', 'dessert'],
        shortName: 'cake'
      },
      {
        name: 'Cupcake',
        unified: '1F9C1',
        keywords: ['food', 'dessert', 'bakery', 'sweet'],
        shortName: 'cupcake'
      },
      {
        name: 'Pie',
        unified: '1F967',
        keywords: ['food', 'dessert', 'pastry'],
        shortName: 'pie'
      },
      {
        name: 'Chocolate Bar',
        unified: '1F36B',
        keywords: ['food', 'snack', 'dessert', 'sweet'],
        shortName: 'chocolate_bar'
      },
      {
        name: 'Candy',
        unified: '1F36C',
        keywords: ['snack', 'dessert', 'sweet', 'lolly'],
        shortName: 'candy'
      },
      {
        name: 'Lollipop',
        unified: '1F36D',
        keywords: ['food', 'snack', 'candy', 'sweet'],
        shortName: 'lollipop'
      },
      {
        name: 'Custard',
        unified: '1F36E',
        keywords: ['dessert', 'food'],
        shortName: 'custard'
      },
      {
        name: 'Honey Pot',
        unified: '1F36F',
        keywords: ['bees', 'sweet', 'kitchen'],
        shortName: 'honey_pot'
      },
      {
        name: 'Baby Bottle',
        unified: '1F37C',
        keywords: ['food', 'container', 'milk'],
        shortName: 'baby_bottle'
      },
      {
        name: 'Glass of Milk',
        unified: '1F95B',
        shortName: 'glass_of_milk'
      },
      {
        name: 'Hot Beverage',
        unified: '2615',
        keywords: ['beverage', 'caffeine', 'latte', 'espresso'],
        shortName: 'coffee'
      },
      {
        name: 'Teacup Without Handle',
        unified: '1F375',
        keywords: ['drink', 'bowl', 'breakfast', 'green', 'british'],
        shortName: 'tea'
      },
      {
        name: 'Sake Bottle and Cup',
        unified: '1F376',
        keywords: ['wine', 'drink', 'drunk', 'beverage', 'japanese', 'alcohol', 'booze'],
        shortName: 'sake'
      },
      {
        name: 'Bottle with Popping Cork',
        unified: '1F37E',
        keywords: ['drink', 'wine', 'bottle', 'celebration'],
        shortName: 'champagne'
      },
      {
        name: 'Wine Glass',
        unified: '1F377',
        keywords: ['drink', 'beverage', 'drunk', 'alcohol', 'booze'],
        shortName: 'wine_glass'
      },
      {
        name: 'Cocktail Glass',
        unified: '1F378',
        keywords: ['drink', 'drunk', 'alcohol', 'beverage', 'booze', 'mojito'],
        shortName: 'cocktail'
      },
      {
        name: 'Tropical Drink',
        unified: '1F379',
        keywords: ['beverage', 'cocktail', 'summer', 'beach', 'alcohol', 'booze', 'mojito'],
        shortName: 'tropical_drink'
      },
      {
        name: 'Beer Mug',
        unified: '1F37A',
        keywords: ['relax', 'beverage', 'drink', 'drunk', 'party', 'pub', 'summer', 'alcohol', 'booze'],
        shortName: 'beer'
      },
      {
        name: 'Clinking Beer Mugs',
        unified: '1F37B',
        keywords: ['relax', 'beverage', 'drink', 'drunk', 'party', 'pub', 'summer', 'alcohol', 'booze'],
        shortName: 'beers'
      },
      {
        name: 'Clinking Glasses',
        unified: '1F942',
        keywords: ['beverage', 'drink', 'party', 'alcohol', 'celebrate', 'cheers', 'wine', 'champagne', 'toast'],
        shortName: 'clinking_glasses'
      },
      {
        name: 'Tumbler Glass',
        unified: '1F943',
        keywords: [
          'drink',
          'beverage',
          'drunk',
          'alcohol',
          'liquor',
          'booze',
          'bourbon',
          'scotch',
          'whisky',
          'glass',
          'shot'
        ],
        shortName: 'tumbler_glass'
      },
      {
        name: 'Cup with Straw',
        unified: '1F964',
        keywords: ['drink', 'soda'],
        shortName: 'cup_with_straw'
      },
      {
        name: 'Beverage Box',
        unified: '1F9C3',
        shortName: 'beverage_box'
      },
      {
        name: 'Mate Drink',
        unified: '1F9C9',
        shortName: 'mate_drink'
      },
      {
        name: 'Ice Cube',
        unified: '1F9CA',
        shortName: 'ice_cube'
      },
      {
        name: 'Chopsticks',
        unified: '1F962',
        keywords: ['food'],
        shortName: 'chopsticks'
      },
      {
        name: 'Knife Fork Plate',
        unified: '1F37D-FE0F',
        shortName: 'knife_fork_plate'
      },
      {
        name: 'Fork and Knife',
        unified: '1F374',
        keywords: ['cutlery', 'kitchen'],
        shortName: 'fork_and_knife'
      },
      {
        name: 'Spoon',
        unified: '1F944',
        keywords: ['cutlery', 'kitchen', 'tableware'],
        shortName: 'spoon'
      },
      {
        name: 'Hocho',
        unified: '1F52A',
        keywords: ['knife', 'blade', 'cutlery', 'kitchen', 'weapon'],
        shortNames: ['hocho', 'knife'],
        shortName: 'hocho'
      },
      {
        name: 'Amphora',
        unified: '1F3FA',
        keywords: ['vase', 'jar'],
        shortName: 'amphora'
      }
    ]
  },
  {
    id: 'activity',
    name: 'Activities',
    emojis: [
      {
        name: 'Jack-O-Lantern',
        unified: '1F383',
        keywords: ['halloween', 'light', 'pumpkin', 'creepy', 'fall'],
        shortName: 'jack_o_lantern'
      },
      {
        name: 'Christmas Tree',
        unified: '1F384',
        keywords: ['festival', 'vacation', 'december', 'xmas', 'celebration'],
        shortName: 'christmas_tree'
      },
      {
        name: 'Fireworks',
        unified: '1F386',
        keywords: ['photo', 'festival', 'carnival', 'congratulations'],
        shortName: 'fireworks'
      },
      {
        name: 'Firework Sparkler',
        unified: '1F387',
        keywords: ['stars', 'night', 'shine'],
        shortName: 'sparkler'
      },
      {
        name: 'Firecracker',
        unified: '1F9E8',
        keywords: ['dynamite', 'boom', 'explode', 'explosion', 'explosive'],
        shortName: 'firecracker'
      },
      {
        name: 'Sparkles',
        unified: '2728',
        keywords: ['stars', 'shine', 'shiny', 'cool', 'awesome', 'good', 'magic'],
        shortName: 'sparkles'
      },
      {
        name: 'Balloon',
        unified: '1F388',
        keywords: ['party', 'celebration', 'birthday', 'circus'],
        shortName: 'balloon'
      },
      {
        name: 'Party Popper',
        unified: '1F389',
        keywords: ['party', 'congratulations', 'birthday', 'magic', 'circus', 'celebration'],
        shortName: 'tada'
      },
      {
        name: 'Confetti Ball',
        unified: '1F38A',
        keywords: ['festival', 'party', 'birthday', 'circus'],
        shortName: 'confetti_ball'
      },
      {
        name: 'Tanabata Tree',
        unified: '1F38B',
        keywords: ['plant', 'nature', 'branch', 'summer'],
        shortName: 'tanabata_tree'
      },
      {
        name: 'Pine Decoration',
        unified: '1F38D',
        keywords: ['plant', 'nature', 'vegetable', 'panda', 'pine_decoration'],
        shortName: 'bamboo'
      },
      {
        name: 'Japanese Dolls',
        unified: '1F38E',
        keywords: ['japanese', 'toy', 'kimono'],
        shortName: 'dolls'
      },
      {
        name: 'Carp Streamer',
        unified: '1F38F',
        keywords: ['fish', 'japanese', 'koinobori', 'carp', 'banner'],
        shortName: 'flags'
      },
      {
        name: 'Wind Chime',
        unified: '1F390',
        keywords: ['nature', 'ding', 'spring', 'bell'],
        shortName: 'wind_chime'
      },
      {
        name: 'Moon Viewing Ceremony',
        unified: '1F391',
        keywords: ['photo', 'japan', 'asia', 'tsukimi'],
        shortName: 'rice_scene'
      },
      {
        name: 'Red Gift Envelope',
        unified: '1F9E7',
        keywords: ['gift'],
        shortName: 'red_envelope'
      },
      {
        name: 'Ribbon',
        unified: '1F380',
        keywords: ['decoration', 'pink', 'girl', 'bowtie'],
        shortName: 'ribbon'
      },
      {
        name: 'Wrapped Present',
        unified: '1F381',
        keywords: ['present', 'birthday', 'christmas', 'xmas'],
        shortName: 'gift'
      },
      {
        name: 'Reminder Ribbon',
        unified: '1F397-FE0F',
        keywords: ['sports', 'cause', 'support', 'awareness'],
        shortName: 'reminder_ribbon'
      },
      {
        name: 'Admission Tickets',
        unified: '1F39F-FE0F',
        shortName: 'admission_tickets'
      },
      {
        name: 'Ticket',
        unified: '1F3AB',
        keywords: ['event', 'concert', 'pass'],
        shortName: 'ticket'
      },
      {
        name: 'Medal',
        unified: '1F396-FE0F',
        shortName: 'medal'
      },
      {
        name: 'Trophy',
        unified: '1F3C6',
        keywords: ['win', 'award', 'contest', 'place', 'ftw', 'ceremony'],
        shortName: 'trophy'
      },
      {
        name: 'Sports Medal',
        unified: '1F3C5',
        shortName: 'sports_medal'
      },
      {
        name: 'First Place Medal',
        unified: '1F947',
        shortName: 'first_place_medal'
      },
      {
        name: 'Second Place Medal',
        unified: '1F948',
        shortName: 'second_place_medal'
      },
      {
        name: 'Third Place Medal',
        unified: '1F949',
        shortName: 'third_place_medal'
      },
      {
        name: 'Soccer Ball',
        unified: '26BD',
        keywords: ['sports', 'football'],
        shortName: 'soccer'
      },
      {
        name: 'Baseball',
        unified: '26BE',
        keywords: ['sports', 'balls'],
        shortName: 'baseball'
      },
      {
        name: 'Softball',
        unified: '1F94E',
        keywords: ['sports', 'balls'],
        shortName: 'softball'
      },
      {
        name: 'Basketball and Hoop',
        unified: '1F3C0',
        keywords: ['sports', 'balls', 'NBA'],
        shortName: 'basketball'
      },
      {
        name: 'Volleyball',
        unified: '1F3D0',
        keywords: ['sports', 'balls'],
        shortName: 'volleyball'
      },
      {
        name: 'American Football',
        unified: '1F3C8',
        keywords: ['sports', 'balls', 'NFL'],
        shortName: 'football'
      },
      {
        name: 'Rugby Football',
        unified: '1F3C9',
        keywords: ['sports', 'team'],
        shortName: 'rugby_football'
      },
      {
        name: 'Tennis Racquet and Ball',
        unified: '1F3BE',
        keywords: ['sports', 'balls', 'green'],
        shortName: 'tennis'
      },
      {
        name: 'Flying Disc',
        unified: '1F94F',
        keywords: ['sports', 'frisbee', 'ultimate'],
        shortName: 'flying_disc'
      },
      {
        name: 'Bowling',
        unified: '1F3B3',
        keywords: ['sports', 'fun', 'play'],
        shortName: 'bowling'
      },
      {
        name: 'Cricket Bat and Ball',
        unified: '1F3CF',
        shortName: 'cricket_bat_and_ball'
      },
      {
        name: 'Field Hockey Stick and Ball',
        unified: '1F3D1',
        shortName: 'field_hockey_stick_and_ball'
      },
      {
        name: 'Ice Hockey Stick and Puck',
        unified: '1F3D2',
        shortName: 'ice_hockey_stick_and_puck'
      },
      {
        name: 'Lacrosse Stick and Ball',
        unified: '1F94D',
        keywords: ['sports', 'ball', 'stick'],
        shortName: 'lacrosse'
      },
      {
        name: 'Table Tennis Paddle and Ball',
        unified: '1F3D3',
        shortName: 'table_tennis_paddle_and_ball'
      },
      {
        name: 'Badminton Racquet and Shuttlecock',
        unified: '1F3F8',
        shortName: 'badminton_racquet_and_shuttlecock'
      },
      {
        name: 'Boxing Glove',
        unified: '1F94A',
        keywords: ['sports', 'fighting'],
        shortName: 'boxing_glove'
      },
      {
        name: 'Martial Arts Uniform',
        unified: '1F94B',
        keywords: ['judo', 'karate', 'taekwondo'],
        shortName: 'martial_arts_uniform'
      },
      {
        name: 'Goal Net',
        unified: '1F945',
        keywords: ['sports'],
        shortName: 'goal_net'
      },
      {
        name: 'Flag in Hole',
        unified: '26F3',
        keywords: ['sports', 'business', 'flag', 'hole', 'summer'],
        shortName: 'golf'
      },
      {
        name: 'Ice Skate',
        unified: '26F8-FE0F',
        keywords: ['sports'],
        shortName: 'ice_skate'
      },
      {
        name: 'Fishing Pole and Fish',
        unified: '1F3A3',
        keywords: ['food', 'hobby', 'summer'],
        shortName: 'fishing_pole_and_fish'
      },
      {
        name: 'Diving Mask',
        unified: '1F93F',
        shortName: 'diving_mask'
      },
      {
        name: 'Running Shirt with Sash',
        unified: '1F3BD',
        keywords: ['play', 'pageant'],
        shortName: 'running_shirt_with_sash'
      },
      {
        name: 'Ski and Ski Boot',
        unified: '1F3BF',
        keywords: ['sports', 'winter', 'cold', 'snow'],
        shortName: 'ski'
      },
      {
        name: 'Sled',
        unified: '1F6F7',
        keywords: ['sleigh', 'luge', 'toboggan'],
        shortName: 'sled'
      },
      {
        name: 'Curling Stone',
        unified: '1F94C',
        keywords: ['sports'],
        shortName: 'curling_stone'
      },
      {
        name: 'Direct Hit',
        unified: '1F3AF',
        keywords: ['game', 'play', 'bar', 'target', 'bullseye'],
        shortName: 'dart'
      },
      {
        name: 'Yo-Yo',
        unified: '1FA80',
        shortName: 'yo-yo'
      },
      {
        name: 'Kite',
        unified: '1FA81',
        shortName: 'kite'
      },
      {
        name: 'Billiards',
        unified: '1F3B1',
        keywords: ['pool', 'hobby', 'game', 'luck', 'magic'],
        shortName: '8ball'
      },
      {
        name: 'Crystal Ball',
        unified: '1F52E',
        keywords: ['disco', 'party', 'magic', 'circus', 'fortune_teller'],
        shortName: 'crystal_ball'
      },
      {
        name: 'Nazar Amulet',
        unified: '1F9FF',
        keywords: ['bead', 'charm'],
        shortName: 'nazar_amulet'
      },
      {
        name: 'Video Game',
        unified: '1F3AE',
        keywords: ['play', 'console', 'PS4', 'controller'],
        shortName: 'video_game'
      },
      {
        name: 'Joystick',
        unified: '1F579-FE0F',
        keywords: ['game', 'play'],
        shortName: 'joystick'
      },
      {
        name: 'Slot Machine',
        unified: '1F3B0',
        keywords: ['bet', 'gamble', 'vegas', 'fruit machine', 'luck', 'casino'],
        shortName: 'slot_machine'
      },
      {
        name: 'Game Die',
        unified: '1F3B2',
        keywords: ['dice', 'random', 'tabletop', 'play', 'luck'],
        shortName: 'game_die'
      },
      {
        name: 'Jigsaw Puzzle Piece',
        unified: '1F9E9',
        keywords: ['interlocking', 'puzzle', 'piece'],
        shortName: 'jigsaw'
      },
      {
        name: 'Teddy Bear',
        unified: '1F9F8',
        keywords: ['plush', 'stuffed'],
        shortName: 'teddy_bear'
      },
      {
        name: 'Black Spade Suit',
        unified: '2660-FE0F',
        keywords: ['poker', 'cards', 'suits', 'magic'],
        shortName: 'spades'
      },
      {
        name: 'Black Heart Suit',
        unified: '2665-FE0F',
        keywords: ['poker', 'cards', 'magic', 'suits'],
        shortName: 'hearts'
      },
      {
        name: 'Black Diamond Suit',
        unified: '2666-FE0F',
        keywords: ['poker', 'cards', 'magic', 'suits'],
        shortName: 'diamonds'
      },
      {
        name: 'Black Club Suit',
        unified: '2663-FE0F',
        keywords: ['poker', 'cards', 'magic', 'suits'],
        shortName: 'clubs'
      },
      {
        name: 'Chess Pawn',
        unified: '265F-FE0F',
        keywords: ['expendable'],
        shortName: 'chess_pawn'
      },
      {
        name: 'Playing Card Black Joker',
        unified: '1F0CF',
        keywords: ['poker', 'cards', 'game', 'play', 'magic'],
        shortName: 'black_joker'
      },
      {
        name: 'Mahjong Tile Red Dragon',
        unified: '1F004',
        keywords: ['game', 'play', 'chinese', 'kanji'],
        shortName: 'mahjong'
      },
      {
        name: 'Flower Playing Cards',
        unified: '1F3B4',
        keywords: ['game', 'sunset', 'red'],
        shortName: 'flower_playing_cards'
      },
      {
        name: 'Performing Arts',
        unified: '1F3AD',
        keywords: ['acting', 'theater', 'drama'],
        shortName: 'performing_arts'
      },
      {
        name: 'Frame with Picture',
        unified: '1F5BC-FE0F',
        shortName: 'frame_with_picture'
      },
      {
        name: 'Artist Palette',
        unified: '1F3A8',
        keywords: ['design', 'paint', 'draw', 'colors'],
        shortName: 'art'
      },
      {
        name: 'Spool of Thread',
        unified: '1F9F5',
        keywords: ['needle', 'sewing', 'spool', 'string'],
        shortName: 'thread'
      },
      {
        name: 'Ball of Yarn',
        unified: '1F9F6',
        keywords: ['ball', 'crochet', 'knit'],
        shortName: 'yarn'
      }
    ]
  },
  {
    id: 'places',
    name: 'Travel & Places',
    emojis: [
      {
        name: 'Earth Globe Europe-Africa',
        unified: '1F30D',
        keywords: ['globe', 'world', 'international'],
        shortName: 'earth_africa'
      },
      {
        name: 'Earth Globe Americas',
        unified: '1F30E',
        keywords: ['globe', 'world', 'USA', 'international'],
        shortName: 'earth_americas'
      },
      {
        name: 'Earth Globe Asia-Australia',
        unified: '1F30F',
        keywords: ['globe', 'world', 'east', 'international'],
        shortName: 'earth_asia'
      },
      {
        name: 'Globe with Meridians',
        unified: '1F310',
        keywords: ['earth', 'international', 'world', 'internet', 'interweb', 'i18n'],
        shortName: 'globe_with_meridians'
      },
      {
        name: 'World Map',
        unified: '1F5FA-FE0F',
        keywords: ['location', 'direction'],
        shortName: 'world_map'
      },
      {
        name: 'Silhouette of Japan',
        unified: '1F5FE',
        keywords: ['nation', 'country', 'japanese', 'asia'],
        shortName: 'japan'
      },
      {
        name: 'Compass',
        unified: '1F9ED',
        keywords: ['magnetic', 'navigation', 'orienteering'],
        shortName: 'compass'
      },
      {
        name: 'Snow Capped Mountain',
        unified: '1F3D4-FE0F',
        shortName: 'snow_capped_mountain'
      },
      {
        name: 'Mountain',
        unified: '26F0-FE0F',
        keywords: ['photo', 'nature', 'environment'],
        shortName: 'mountain'
      },
      {
        name: 'Volcano',
        unified: '1F30B',
        keywords: ['photo', 'nature', 'disaster'],
        shortName: 'volcano'
      },
      {
        name: 'Mount Fuji',
        unified: '1F5FB',
        keywords: ['photo', 'mountain', 'nature', 'japanese'],
        shortName: 'mount_fuji'
      },
      {
        name: 'Camping',
        unified: '1F3D5-FE0F',
        keywords: ['photo', 'outdoors', 'tent'],
        shortName: 'camping'
      },
      {
        name: 'Beach with Umbrella',
        unified: '1F3D6-FE0F',
        shortName: 'beach_with_umbrella'
      },
      {
        name: 'Desert',
        unified: '1F3DC-FE0F',
        keywords: ['photo', 'warm', 'saharah'],
        shortName: 'desert'
      },
      {
        name: 'Desert Island',
        unified: '1F3DD-FE0F',
        keywords: ['photo', 'tropical', 'mojito'],
        shortName: 'desert_island'
      },
      {
        name: 'National Park',
        unified: '1F3DE-FE0F',
        keywords: ['photo', 'environment', 'nature'],
        shortName: 'national_park'
      },
      {
        name: 'Stadium',
        unified: '1F3DF-FE0F',
        keywords: ['photo', 'place', 'sports', 'concert', 'venue'],
        shortName: 'stadium'
      },
      {
        name: 'Classical Building',
        unified: '1F3DB-FE0F',
        keywords: ['art', 'culture', 'history'],
        shortName: 'classical_building'
      },
      {
        name: 'Building Construction',
        unified: '1F3D7-FE0F',
        keywords: ['wip', 'working', 'progress'],
        shortName: 'building_construction'
      },
      {
        name: 'Brick',
        unified: '1F9F1',
        shortName: 'bricks'
      },
      {
        name: 'House Buildings',
        unified: '1F3D8-FE0F',
        shortName: 'house_buildings'
      },
      {
        name: 'Derelict House Building',
        unified: '1F3DA-FE0F',
        shortName: 'derelict_house_building'
      },
      {
        name: 'House Building',
        unified: '1F3E0',
        keywords: ['building', 'home'],
        shortName: 'house'
      },
      {
        name: 'House with Garden',
        unified: '1F3E1',
        keywords: ['home', 'plant', 'nature'],
        shortName: 'house_with_garden'
      },
      {
        name: 'Office Building',
        unified: '1F3E2',
        keywords: ['building', 'bureau', 'work'],
        shortName: 'office'
      },
      {
        name: 'Japanese Post Office',
        unified: '1F3E3',
        keywords: ['building', 'envelope', 'communication'],
        shortName: 'post_office'
      },
      {
        name: 'European Post Office',
        unified: '1F3E4',
        keywords: ['building', 'email'],
        shortName: 'european_post_office'
      },
      {
        name: 'Hospital',
        unified: '1F3E5',
        keywords: ['building', 'health', 'surgery', 'doctor'],
        shortName: 'hospital'
      },
      {
        name: 'Bank',
        unified: '1F3E6',
        keywords: ['building', 'money', 'sales', 'cash', 'business', 'enterprise'],
        shortName: 'bank'
      },
      {
        name: 'Hotel',
        unified: '1F3E8',
        keywords: ['building', 'accomodation', 'checkin'],
        shortName: 'hotel'
      },
      {
        name: 'Love Hotel',
        unified: '1F3E9',
        keywords: ['like', 'affection', 'dating'],
        shortName: 'love_hotel'
      },
      {
        name: 'Convenience Store',
        unified: '1F3EA',
        keywords: ['building', 'shopping', 'groceries'],
        shortName: 'convenience_store'
      },
      {
        name: 'School',
        unified: '1F3EB',
        keywords: ['building', 'student', 'education', 'learn', 'teach'],
        shortName: 'school'
      },
      {
        name: 'Department Store',
        unified: '1F3EC',
        keywords: ['building', 'shopping', 'mall'],
        shortName: 'department_store'
      },
      {
        name: 'Factory',
        unified: '1F3ED',
        keywords: ['building', 'industry', 'pollution', 'smoke'],
        shortName: 'factory'
      },
      {
        name: 'Japanese Castle',
        unified: '1F3EF',
        keywords: ['photo', 'building'],
        shortName: 'japanese_castle'
      },
      {
        name: 'European Castle',
        unified: '1F3F0',
        keywords: ['building', 'royalty', 'history'],
        shortName: 'european_castle'
      },
      {
        name: 'Wedding',
        unified: '1F492',
        keywords: ['love', 'like', 'affection', 'couple', 'marriage', 'bride', 'groom'],
        shortName: 'wedding'
      },
      {
        name: 'Tokyo Tower',
        unified: '1F5FC',
        keywords: ['photo', 'japanese'],
        shortName: 'tokyo_tower'
      },
      {
        name: 'Statue of Liberty',
        unified: '1F5FD',
        keywords: ['american', 'newyork'],
        shortName: 'statue_of_liberty'
      },
      {
        name: 'Church',
        unified: '26EA',
        keywords: ['building', 'religion', 'christ'],
        shortName: 'church'
      },
      {
        name: 'Mosque',
        unified: '1F54C',
        keywords: ['islam', 'worship', 'minaret'],
        shortName: 'mosque'
      },
      {
        name: 'Hindu Temple',
        unified: '1F6D5',
        shortName: 'hindu_temple'
      },
      {
        name: 'Synagogue',
        unified: '1F54D',
        keywords: ['judaism', 'worship', 'temple', 'jewish'],
        shortName: 'synagogue'
      },
      {
        name: 'Shinto Shrine',
        unified: '26E9-FE0F',
        keywords: ['temple', 'japan', 'kyoto'],
        shortName: 'shinto_shrine'
      },
      {
        name: 'Kaaba',
        unified: '1F54B',
        keywords: ['mecca', 'mosque', 'islam'],
        shortName: 'kaaba'
      },
      {
        name: 'Fountain',
        unified: '26F2',
        keywords: ['photo', 'summer', 'water', 'fresh'],
        shortName: 'fountain'
      },
      {
        name: 'Tent',
        unified: '26FA',
        keywords: ['photo', 'camping', 'outdoors'],
        shortName: 'tent'
      },
      {
        name: 'Foggy',
        unified: '1F301',
        keywords: ['photo', 'mountain'],
        shortName: 'foggy'
      },
      {
        name: 'Night with Stars',
        unified: '1F303',
        keywords: ['evening', 'city', 'downtown'],
        shortName: 'night_with_stars'
      },
      {
        name: 'Cityscape',
        unified: '1F3D9-FE0F',
        keywords: ['photo', 'night life', 'urban'],
        shortName: 'cityscape'
      },
      {
        name: 'Sunrise over Mountains',
        unified: '1F304',
        keywords: ['view', 'vacation', 'photo'],
        shortName: 'sunrise_over_mountains'
      },
      {
        name: 'Sunrise',
        unified: '1F305',
        keywords: ['morning', 'view', 'vacation', 'photo'],
        shortName: 'sunrise'
      },
      {
        name: 'Cityscape at Dusk',
        unified: '1F306',
        keywords: ['photo', 'evening', 'sky', 'buildings'],
        shortName: 'city_sunset'
      },
      {
        name: 'Sunset over Buildings',
        unified: '1F307',
        keywords: ['photo', 'good morning', 'dawn'],
        shortName: 'city_sunrise'
      },
      {
        name: 'Bridge at Night',
        unified: '1F309',
        keywords: ['photo', 'sanfrancisco'],
        shortName: 'bridge_at_night'
      },
      {
        name: 'Hot Springs',
        unified: '2668-FE0F',
        keywords: ['bath', 'warm', 'relax'],
        shortName: 'hotsprings'
      },
      {
        name: 'Carousel Horse',
        unified: '1F3A0',
        keywords: ['photo', 'carnival'],
        shortName: 'carousel_horse'
      },
      {
        name: 'Ferris Wheel',
        unified: '1F3A1',
        keywords: ['photo', 'carnival', 'londoneye'],
        shortName: 'ferris_wheel'
      },
      {
        name: 'Roller Coaster',
        unified: '1F3A2',
        keywords: ['carnival', 'playground', 'photo', 'fun'],
        shortName: 'roller_coaster'
      },
      {
        name: 'Barber Pole',
        unified: '1F488',
        keywords: ['hair', 'salon', 'style'],
        shortName: 'barber'
      },
      {
        name: 'Circus Tent',
        unified: '1F3AA',
        keywords: ['festival', 'carnival', 'party'],
        shortName: 'circus_tent'
      },
      {
        name: 'Steam Locomotive',
        unified: '1F682',
        keywords: ['transportation', 'vehicle', 'train'],
        shortName: 'steam_locomotive'
      },
      {
        name: 'Railway Car',
        unified: '1F683',
        keywords: ['transportation', 'vehicle'],
        shortName: 'railway_car'
      },
      {
        name: 'High-Speed Train',
        unified: '1F684',
        keywords: ['transportation', 'vehicle'],
        shortName: 'bullettrain_side'
      },
      {
        name: 'High-Speed Train with Bullet Nose',
        unified: '1F685',
        keywords: ['transportation', 'vehicle', 'speed', 'fast', 'public', 'travel'],
        shortName: 'bullettrain_front'
      },
      {
        name: 'Train',
        unified: '1F686',
        keywords: ['transportation', 'vehicle'],
        shortName: 'train2'
      },
      {
        name: 'Metro',
        unified: '1F687',
        keywords: ['transportation', 'blue-square', 'mrt', 'underground', 'tube'],
        shortName: 'metro'
      },
      {
        name: 'Light Rail',
        unified: '1F688',
        keywords: ['transportation', 'vehicle'],
        shortName: 'light_rail'
      },
      {
        name: 'Station',
        unified: '1F689',
        keywords: ['transportation', 'vehicle', 'public'],
        shortName: 'station'
      },
      {
        name: 'Tram',
        unified: '1F68A',
        keywords: ['transportation', 'vehicle'],
        shortName: 'tram'
      },
      {
        name: 'Monorail',
        unified: '1F69D',
        keywords: ['transportation', 'vehicle'],
        shortName: 'monorail'
      },
      {
        name: 'Mountain Railway',
        unified: '1F69E',
        keywords: ['transportation', 'vehicle'],
        shortName: 'mountain_railway'
      },
      {
        name: 'Tram Car',
        unified: '1F68B',
        keywords: ['transportation', 'vehicle', 'carriage', 'public', 'travel'],
        shortName: 'train'
      },
      {
        name: 'Bus',
        unified: '1F68C',
        keywords: ['car', 'vehicle', 'transportation'],
        shortName: 'bus'
      },
      {
        name: 'Oncoming Bus',
        unified: '1F68D',
        keywords: ['vehicle', 'transportation'],
        shortName: 'oncoming_bus'
      },
      {
        name: 'Trolleybus',
        unified: '1F68E',
        keywords: ['bart', 'transportation', 'vehicle'],
        shortName: 'trolleybus'
      },
      {
        name: 'Minibus',
        unified: '1F690',
        keywords: ['vehicle', 'car', 'transportation'],
        shortName: 'minibus'
      },
      {
        name: 'Ambulance',
        unified: '1F691',
        keywords: ['health', '911', 'hospital'],
        shortName: 'ambulance'
      },
      {
        name: 'Fire Engine',
        unified: '1F692',
        keywords: ['transportation', 'cars', 'vehicle'],
        shortName: 'fire_engine'
      },
      {
        name: 'Police Car',
        unified: '1F693',
        keywords: ['vehicle', 'cars', 'transportation', 'law', 'legal', 'enforcement'],
        shortName: 'police_car'
      },
      {
        name: 'Oncoming Police Car',
        unified: '1F694',
        keywords: ['vehicle', 'law', 'legal', 'enforcement', '911'],
        shortName: 'oncoming_police_car'
      },
      {
        name: 'Taxi',
        unified: '1F695',
        keywords: ['uber', 'vehicle', 'cars', 'transportation'],
        shortName: 'taxi'
      },
      {
        name: 'Oncoming Taxi',
        unified: '1F696',
        keywords: ['vehicle', 'cars', 'uber'],
        shortName: 'oncoming_taxi'
      },
      {
        name: 'Automobile',
        unified: '1F697',
        shortNames: ['car', 'red_car'],
        shortName: 'car'
      },
      {
        name: 'Oncoming Automobile',
        unified: '1F698',
        keywords: ['car', 'vehicle', 'transportation'],
        shortName: 'oncoming_automobile'
      },
      {
        name: 'Recreational Vehicle',
        unified: '1F699',
        keywords: ['transportation', 'vehicle'],
        shortName: 'blue_car'
      },
      {
        name: 'Delivery Truck',
        unified: '1F69A',
        keywords: ['cars', 'transportation'],
        shortName: 'truck'
      },
      {
        name: 'Articulated Lorry',
        unified: '1F69B',
        keywords: ['vehicle', 'cars', 'transportation', 'express'],
        shortName: 'articulated_lorry'
      },
      {
        name: 'Tractor',
        unified: '1F69C',
        keywords: ['vehicle', 'car', 'farming', 'agriculture'],
        shortName: 'tractor'
      },
      {
        name: 'Racing Car',
        unified: '1F3CE-FE0F',
        keywords: ['sports', 'race', 'fast', 'formula', 'f1'],
        shortName: 'racing_car'
      },
      {
        name: 'Racing Motorcycle',
        unified: '1F3CD-FE0F',
        shortName: 'racing_motorcycle'
      },
      {
        name: 'Motor Scooter',
        unified: '1F6F5',
        keywords: ['vehicle', 'vespa', 'sasha'],
        shortName: 'motor_scooter'
      },
      {
        name: 'Manual Wheelchair',
        unified: '1F9BD',
        shortName: 'manual_wheelchair'
      },
      {
        name: 'Motorized Wheelchair',
        unified: '1F9BC',
        shortName: 'motorized_wheelchair'
      },
      {
        name: 'Auto Rickshaw',
        unified: '1F6FA',
        shortName: 'auto_rickshaw'
      },
      {
        name: 'Bicycle',
        unified: '1F6B2',
        keywords: ['sports', 'bicycle', 'exercise', 'hipster'],
        shortName: 'bike'
      },
      {
        name: 'Scooter',
        unified: '1F6F4',
        shortName: 'scooter'
      },
      {
        name: 'Skateboard',
        unified: '1F6F9',
        keywords: ['board'],
        shortName: 'skateboard'
      },
      {
        name: 'Bus Stop',
        unified: '1F68F',
        keywords: ['transportation', 'wait'],
        shortName: 'busstop'
      },
      {
        name: 'Motorway',
        unified: '1F6E3-FE0F',
        keywords: ['road', 'cupertino', 'interstate', 'highway'],
        shortName: 'motorway'
      },
      {
        name: 'Railway Track',
        unified: '1F6E4-FE0F',
        keywords: ['train', 'transportation'],
        shortName: 'railway_track'
      },
      {
        name: 'Oil Drum',
        unified: '1F6E2-FE0F',
        keywords: ['barrell'],
        shortName: 'oil_drum'
      },
      {
        name: 'Fuel Pump',
        unified: '26FD',
        keywords: ['gas station', 'petroleum'],
        shortName: 'fuelpump'
      },
      {
        name: 'Police Cars Revolving Light',
        unified: '1F6A8',
        keywords: ['police', 'ambulance', '911', 'emergency', 'alert', 'error', 'pinged', 'law', 'legal'],
        shortName: 'rotating_light'
      },
      {
        name: 'Horizontal Traffic Light',
        unified: '1F6A5',
        keywords: ['transportation', 'signal'],
        shortName: 'traffic_light'
      },
      {
        name: 'Vertical Traffic Light',
        unified: '1F6A6',
        keywords: ['transportation', 'driving'],
        shortName: 'vertical_traffic_light'
      },
      {
        name: 'Octagonal Sign',
        unified: '1F6D1',
        shortName: 'octagonal_sign'
      },
      {
        name: 'Construction Sign',
        unified: '1F6A7',
        keywords: ['wip', 'progress', 'caution', 'warning'],
        shortName: 'construction'
      },
      {
        name: 'Anchor',
        unified: '2693',
        keywords: ['ship', 'ferry', 'sea', 'boat'],
        shortName: 'anchor'
      },
      {
        name: 'Sailboat',
        unified: '26F5',
        shortNames: ['boat', 'sailboat'],
        shortName: 'boat'
      },
      {
        name: 'Canoe',
        unified: '1F6F6',
        keywords: ['boat', 'paddle', 'water', 'ship'],
        shortName: 'canoe'
      },
      {
        name: 'Speedboat',
        unified: '1F6A4',
        keywords: ['ship', 'transportation', 'vehicle', 'summer'],
        shortName: 'speedboat'
      },
      {
        name: 'Passenger Ship',
        unified: '1F6F3-FE0F',
        keywords: ['yacht', 'cruise', 'ferry'],
        shortName: 'passenger_ship'
      },
      {
        name: 'Ferry',
        unified: '26F4-FE0F',
        keywords: ['boat', 'ship', 'yacht'],
        shortName: 'ferry'
      },
      {
        name: 'Motor Boat',
        unified: '1F6E5-FE0F',
        keywords: ['ship'],
        shortName: 'motor_boat'
      },
      {
        name: 'Ship',
        unified: '1F6A2',
        keywords: ['transportation', 'titanic', 'deploy'],
        shortName: 'ship'
      },
      {
        name: 'Airplane',
        unified: '2708-FE0F',
        keywords: ['vehicle', 'transportation', 'flight', 'fly'],
        shortName: 'airplane'
      },
      {
        name: 'Small Airplane',
        unified: '1F6E9-FE0F',
        keywords: ['flight', 'transportation', 'fly', 'vehicle'],
        shortName: 'small_airplane'
      },
      {
        name: 'Airplane Departure',
        unified: '1F6EB',
        shortName: 'airplane_departure'
      },
      {
        name: 'Airplane Arriving',
        unified: '1F6EC',
        shortName: 'airplane_arriving'
      },
      {
        name: 'Parachute',
        unified: '1FA82',
        shortName: 'parachute'
      },
      {
        name: 'Seat',
        unified: '1F4BA',
        keywords: ['sit', 'airplane', 'transport', 'bus', 'flight', 'fly'],
        shortName: 'seat'
      },
      {
        name: 'Helicopter',
        unified: '1F681',
        keywords: ['transportation', 'vehicle', 'fly'],
        shortName: 'helicopter'
      },
      {
        name: 'Suspension Railway',
        unified: '1F69F',
        keywords: ['vehicle', 'transportation'],
        shortName: 'suspension_railway'
      },
      {
        name: 'Mountain Cableway',
        unified: '1F6A0',
        keywords: ['transportation', 'vehicle', 'ski'],
        shortName: 'mountain_cableway'
      },
      {
        name: 'Aerial Tramway',
        unified: '1F6A1',
        keywords: ['transportation', 'vehicle', 'ski'],
        shortName: 'aerial_tramway'
      },
      {
        name: 'Satellite',
        unified: '1F6F0-FE0F',
        keywords: ['communication', 'future', 'radio', 'space'],
        shortName: 'satellite'
      },
      {
        name: 'Rocket',
        unified: '1F680',
        keywords: ['launch', 'ship', 'staffmode', 'NASA', 'outer space', 'outer_space', 'fly'],
        shortName: 'rocket'
      },
      {
        name: 'Flying Saucer',
        unified: '1F6F8',
        keywords: ['transportation', 'vehicle', 'ufo'],
        shortName: 'flying_saucer'
      },
      {
        name: 'Bellhop Bell',
        unified: '1F6CE-FE0F',
        keywords: ['service'],
        shortName: 'bellhop_bell'
      },
      {
        name: 'Luggage',
        unified: '1F9F3',
        keywords: ['packing', 'travel'],
        shortName: 'luggage'
      },
      {
        name: 'Hourglass',
        unified: '231B',
        keywords: ['time', 'clock', 'oldschool', 'limit', 'exam', 'quiz', 'test'],
        shortName: 'hourglass'
      },
      {
        name: 'Hourglass with Flowing Sand',
        unified: '23F3',
        keywords: ['oldschool', 'time', 'countdown'],
        shortName: 'hourglass_flowing_sand'
      },
      {
        name: 'Watch',
        unified: '231A',
        keywords: ['time', 'accessories'],
        shortName: 'watch'
      },
      {
        name: 'Alarm Clock',
        unified: '23F0',
        keywords: ['time', 'wake'],
        shortName: 'alarm_clock'
      },
      {
        name: 'Stopwatch',
        unified: '23F1-FE0F',
        keywords: ['time', 'deadline'],
        shortName: 'stopwatch'
      },
      {
        name: 'Timer Clock',
        unified: '23F2-FE0F',
        keywords: ['alarm'],
        shortName: 'timer_clock'
      },
      {
        name: 'Mantelpiece Clock',
        unified: '1F570-FE0F',
        keywords: ['time'],
        shortName: 'mantelpiece_clock'
      },
      {
        name: 'Clock Face Twelve Oclock',
        unified: '1F55B',
        keywords: ['time', 'noon', 'midnight', 'midday', 'late', 'early', 'schedule'],
        shortName: 'clock12'
      },
      {
        name: 'Clock Face Twelve-Thirty',
        unified: '1F567',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock1230'
      },
      {
        name: 'Clock Face One Oclock',
        unified: '1F550',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock1'
      },
      {
        name: 'Clock Face One-Thirty',
        unified: '1F55C',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock130'
      },
      {
        name: 'Clock Face Two Oclock',
        unified: '1F551',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock2'
      },
      {
        name: 'Clock Face Two-Thirty',
        unified: '1F55D',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock230'
      },
      {
        name: 'Clock Face Three Oclock',
        unified: '1F552',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock3'
      },
      {
        name: 'Clock Face Three-Thirty',
        unified: '1F55E',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock330'
      },
      {
        name: 'Clock Face Four Oclock',
        unified: '1F553',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock4'
      },
      {
        name: 'Clock Face Four-Thirty',
        unified: '1F55F',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock430'
      },
      {
        name: 'Clock Face Five Oclock',
        unified: '1F554',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock5'
      },
      {
        name: 'Clock Face Five-Thirty',
        unified: '1F560',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock530'
      },
      {
        name: 'Clock Face Six Oclock',
        unified: '1F555',
        keywords: ['time', 'late', 'early', 'schedule', 'dawn', 'dusk'],
        shortName: 'clock6'
      },
      {
        name: 'Clock Face Six-Thirty',
        unified: '1F561',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock630'
      },
      {
        name: 'Clock Face Seven Oclock',
        unified: '1F556',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock7'
      },
      {
        name: 'Clock Face Seven-Thirty',
        unified: '1F562',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock730'
      },
      {
        name: 'Clock Face Eight Oclock',
        unified: '1F557',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock8'
      },
      {
        name: 'Clock Face Eight-Thirty',
        unified: '1F563',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock830'
      },
      {
        name: 'Clock Face Nine Oclock',
        unified: '1F558',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock9'
      },
      {
        name: 'Clock Face Nine-Thirty',
        unified: '1F564',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock930'
      },
      {
        name: 'Clock Face Ten Oclock',
        unified: '1F559',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock10'
      },
      {
        name: 'Clock Face Ten-Thirty',
        unified: '1F565',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock1030'
      },
      {
        name: 'Clock Face Eleven Oclock',
        unified: '1F55A',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock11'
      },
      {
        name: 'Clock Face Eleven-Thirty',
        unified: '1F566',
        keywords: ['time', 'late', 'early', 'schedule'],
        shortName: 'clock1130'
      },
      {
        name: 'New Moon Symbol',
        unified: '1F311',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'new_moon'
      },
      {
        name: 'Waxing Crescent Moon Symbol',
        unified: '1F312',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'waxing_crescent_moon'
      },
      {
        name: 'First Quarter Moon Symbol',
        unified: '1F313',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'first_quarter_moon'
      },
      {
        name: 'Waxing Gibbous Moon Symbol',
        unified: '1F314',
        shortNames: ['moon', 'waxing_gibbous_moon'],
        shortName: 'moon'
      },
      {
        name: 'Full Moon Symbol',
        unified: '1F315',
        keywords: ['nature', 'yellow', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'full_moon'
      },
      {
        name: 'Waning Gibbous Moon Symbol',
        unified: '1F316',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep', 'waxing_gibbous_moon'],
        shortName: 'waning_gibbous_moon'
      },
      {
        name: 'Last Quarter Moon Symbol',
        unified: '1F317',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'last_quarter_moon'
      },
      {
        name: 'Waning Crescent Moon Symbol',
        unified: '1F318',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'waning_crescent_moon'
      },
      {
        name: 'Crescent Moon',
        unified: '1F319',
        keywords: ['night', 'sleep', 'sky', 'evening', 'magic'],
        shortName: 'crescent_moon'
      },
      {
        name: 'New Moon with Face',
        unified: '1F31A',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'new_moon_with_face'
      },
      {
        name: 'First Quarter Moon with Face',
        unified: '1F31B',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'first_quarter_moon_with_face'
      },
      {
        name: 'Last Quarter Moon with Face',
        unified: '1F31C',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'last_quarter_moon_with_face'
      },
      {
        name: 'Thermometer',
        unified: '1F321-FE0F',
        keywords: ['weather', 'temperature', 'hot', 'cold'],
        shortName: 'thermometer'
      },
      {
        name: 'Black Sun with Rays',
        unified: '2600-FE0F',
        keywords: ['weather', 'nature', 'brightness', 'summer', 'beach', 'spring'],
        shortName: 'sunny'
      },
      {
        name: 'Full Moon with Face',
        unified: '1F31D',
        keywords: ['nature', 'twilight', 'planet', 'space', 'night', 'evening', 'sleep'],
        shortName: 'full_moon_with_face'
      },
      {
        name: 'Sun with Face',
        unified: '1F31E',
        keywords: ['nature', 'morning', 'sky'],
        shortName: 'sun_with_face'
      },
      {
        name: 'Ringed Planet',
        unified: '1FA90',
        shortName: 'ringed_planet'
      },
      {
        name: 'White Medium Star',
        unified: '2B50',
        keywords: ['night', 'yellow'],
        shortName: 'star'
      },
      {
        name: 'Glowing Star',
        unified: '1F31F',
        keywords: ['night', 'sparkle', 'awesome', 'good', 'magic'],
        shortName: 'star2'
      },
      {
        name: 'Shooting Star',
        unified: '1F320',
        keywords: ['night', 'photo'],
        shortName: 'stars'
      },
      {
        name: 'Milky Way',
        unified: '1F30C',
        keywords: ['photo', 'space', 'stars'],
        shortName: 'milky_way'
      },
      {
        name: 'Cloud',
        unified: '2601-FE0F',
        keywords: ['weather', 'sky'],
        shortName: 'cloud'
      },
      {
        name: 'Sun Behind Cloud',
        unified: '26C5',
        keywords: ['weather', 'nature', 'cloudy', 'morning', 'fall', 'spring'],
        shortName: 'partly_sunny'
      },
      {
        name: 'Thunder Cloud and Rain',
        unified: '26C8-FE0F',
        shortName: 'thunder_cloud_and_rain'
      },
      {
        name: 'Mostly Sunny',
        unified: '1F324-FE0F',
        shortNames: ['mostly_sunny', 'sun_small_cloud'],
        shortName: 'mostly_sunny'
      },
      {
        name: 'Barely Sunny',
        unified: '1F325-FE0F',
        shortNames: ['barely_sunny', 'sun_behind_cloud'],
        shortName: 'barely_sunny'
      },
      {
        name: 'Partly Sunny Rain',
        unified: '1F326-FE0F',
        shortNames: ['partly_sunny_rain', 'sun_behind_rain_cloud'],
        shortName: 'partly_sunny_rain'
      },
      {
        name: 'Rain Cloud',
        unified: '1F327-FE0F',
        shortName: 'rain_cloud'
      },
      {
        name: 'Snow Cloud',
        unified: '1F328-FE0F',
        shortName: 'snow_cloud'
      },
      {
        name: 'Lightning',
        unified: '1F329-FE0F',
        shortNames: ['lightning', 'lightning_cloud'],
        shortName: 'lightning'
      },
      {
        name: 'Tornado',
        unified: '1F32A-FE0F',
        keywords: ['weather', 'cyclone', 'twister'],
        shortNames: ['tornado', 'tornado_cloud'],
        shortName: 'tornado'
      },
      {
        name: 'Fog',
        unified: '1F32B-FE0F',
        keywords: ['weather'],
        shortName: 'fog'
      },
      {
        name: 'Wind Blowing Face',
        unified: '1F32C-FE0F',
        shortName: 'wind_blowing_face'
      },
      {
        name: 'Cyclone',
        unified: '1F300',
        keywords: [
          'weather',
          'swirl',
          'blue',
          'cloud',
          'vortex',
          'spiral',
          'whirlpool',
          'spin',
          'tornado',
          'hurricane',
          'typhoon'
        ],
        shortName: 'cyclone'
      },
      {
        name: 'Rainbow',
        unified: '1F308',
        keywords: ['nature', 'happy', 'unicorn_face', 'photo', 'sky', 'spring'],
        shortName: 'rainbow'
      },
      {
        name: 'Closed Umbrella',
        unified: '1F302',
        keywords: ['weather', 'rain', 'drizzle'],
        shortName: 'closed_umbrella'
      },
      {
        name: 'Umbrella',
        unified: '2602-FE0F',
        keywords: ['rainy', 'weather', 'spring'],
        shortName: 'umbrella'
      },
      {
        name: 'Umbrella with Rain Drops',
        unified: '2614',
        shortName: 'umbrella_with_rain_drops'
      },
      {
        name: 'Umbrella on Ground',
        unified: '26F1-FE0F',
        shortName: 'umbrella_on_ground'
      },
      {
        name: 'High Voltage Sign',
        unified: '26A1',
        keywords: ['thunder', 'weather', 'lightning bolt', 'fast'],
        shortName: 'zap'
      },
      {
        name: 'Snowflake',
        unified: '2744-FE0F',
        keywords: ['winter', 'season', 'cold', 'weather', 'christmas', 'xmas'],
        shortName: 'snowflake'
      },
      {
        name: 'Snowman',
        unified: '2603-FE0F',
        keywords: ['winter', 'season', 'cold', 'weather', 'christmas', 'xmas', 'frozen', 'without_snow'],
        shortName: 'snowman'
      },
      {
        name: 'Snowman Without Snow',
        unified: '26C4',
        shortName: 'snowman_without_snow'
      },
      {
        name: 'Comet',
        unified: '2604-FE0F',
        keywords: ['space'],
        shortName: 'comet'
      },
      {
        name: 'Fire',
        unified: '1F525',
        keywords: ['hot', 'cook', 'flame'],
        shortName: 'fire'
      },
      {
        name: 'Droplet',
        unified: '1F4A7',
        keywords: ['water', 'drip', 'faucet', 'spring'],
        shortName: 'droplet'
      },
      {
        name: 'Water Wave',
        unified: '1F30A',
        keywords: ['sea', 'water', 'wave', 'nature', 'tsunami', 'disaster'],
        shortName: 'ocean'
      }
    ]
  },
  {
    id: 'objects',
    name: 'Objects',
    emojis: [
      {
        name: 'Eyeglasses',
        unified: '1F453',
        keywords: ['fashion', 'accessories', 'eyesight', 'nerdy', 'dork', 'geek'],
        shortName: 'eyeglasses'
      },
      {
        name: 'Dark Sunglasses',
        unified: '1F576-FE0F',
        keywords: ['face', 'cool', 'accessories'],
        shortName: 'dark_sunglasses'
      },
      {
        name: 'Goggles',
        unified: '1F97D',
        keywords: ['eyes', 'protection', 'safety'],
        shortName: 'goggles'
      },
      {
        name: 'Lab Coat',
        unified: '1F97C',
        shortName: 'lab_coat'
      },
      {
        name: 'Safety Vest',
        unified: '1F9BA',
        shortName: 'safety_vest'
      },
      {
        name: 'Necktie',
        unified: '1F454',
        keywords: ['shirt', 'suitup', 'formal', 'fashion', 'cloth', 'business'],
        shortName: 'necktie'
      },
      {
        name: 'T-Shirt',
        unified: '1F455',
        shortNames: ['shirt', 'tshirt'],
        shortName: 'shirt'
      },
      {
        name: 'Jeans',
        unified: '1F456',
        keywords: ['fashion', 'shopping'],
        shortName: 'jeans'
      },
      {
        name: 'Scarf',
        unified: '1F9E3',
        keywords: ['neck', 'winter', 'clothes'],
        shortName: 'scarf'
      },
      {
        name: 'Gloves',
        unified: '1F9E4',
        keywords: ['hands', 'winter', 'clothes'],
        shortName: 'gloves'
      },
      {
        name: 'Coat',
        unified: '1F9E5',
        keywords: ['jacket'],
        shortName: 'coat'
      },
      {
        name: 'Socks',
        unified: '1F9E6',
        keywords: ['stockings', 'clothes'],
        shortName: 'socks'
      },
      {
        name: 'Dress',
        unified: '1F457',
        keywords: ['clothes', 'fashion', 'shopping'],
        shortName: 'dress'
      },
      {
        name: 'Kimono',
        unified: '1F458',
        keywords: ['dress', 'fashion', 'women', 'female', 'japanese'],
        shortName: 'kimono'
      },
      {
        name: 'Sari',
        unified: '1F97B',
        shortName: 'sari'
      },
      {
        name: 'One-Piece Swimsuit',
        unified: '1FA71',
        shortName: 'one-piece_swimsuit'
      },
      {
        name: 'Briefs',
        unified: '1FA72',
        shortName: 'briefs'
      },
      {
        name: 'Shorts',
        unified: '1FA73',
        shortName: 'shorts'
      },
      {
        name: 'Bikini',
        unified: '1F459',
        keywords: ['swimming', 'female', 'woman', 'girl', 'fashion', 'beach', 'summer'],
        shortName: 'bikini'
      },
      {
        name: 'Womans Clothes',
        unified: '1F45A',
        keywords: ['fashion', 'shopping_bags', 'female'],
        shortName: 'womans_clothes'
      },
      {
        name: 'Purse',
        unified: '1F45B',
        keywords: ['fashion', 'accessories', 'money', 'sales', 'shopping'],
        shortName: 'purse'
      },
      {
        name: 'Handbag',
        unified: '1F45C',
        keywords: ['fashion', 'accessory', 'accessories', 'shopping'],
        shortName: 'handbag'
      },
      {
        name: 'Pouch',
        unified: '1F45D',
        keywords: ['bag', 'accessories', 'shopping'],
        shortName: 'pouch'
      },
      {
        name: 'Shopping Bags',
        unified: '1F6CD-FE0F',
        shortName: 'shopping_bags'
      },
      {
        name: 'School Satchel',
        unified: '1F392',
        keywords: ['student', 'education', 'bag', 'backpack'],
        shortName: 'school_satchel'
      },
      {
        name: 'Mans Shoe',
        unified: '1F45E',
        keywords: ['fashion', 'male'],
        shortNames: ['mans_shoe', 'shoe'],
        shortName: 'mans_shoe'
      },
      {
        name: 'Athletic Shoe',
        unified: '1F45F',
        keywords: ['shoes', 'sports', 'sneakers'],
        shortName: 'athletic_shoe'
      },
      {
        name: 'Hiking Boot',
        unified: '1F97E',
        keywords: ['backpacking', 'camping', 'hiking'],
        shortName: 'hiking_boot'
      },
      {
        name: 'Flat Shoe',
        unified: '1F97F',
        shortName: 'womans_flat_shoe'
      },
      {
        name: 'High-Heeled Shoe',
        unified: '1F460',
        keywords: ['fashion', 'shoes', 'female', 'pumps', 'stiletto'],
        shortName: 'high_heel'
      },
      {
        name: 'Womans Sandal',
        unified: '1F461',
        keywords: ['shoes', 'fashion', 'flip flops'],
        shortName: 'sandal'
      },
      {
        name: 'Ballet Shoes',
        unified: '1FA70',
        shortName: 'ballet_shoes'
      },
      {
        name: 'Womans Boots',
        unified: '1F462',
        keywords: ['shoes', 'fashion'],
        shortName: 'boot'
      },
      {
        name: 'Crown',
        unified: '1F451',
        keywords: ['king', 'kod', 'leader', 'royalty', 'lord'],
        shortName: 'crown'
      },
      {
        name: 'Womans Hat',
        unified: '1F452',
        keywords: ['fashion', 'accessories', 'female', 'lady', 'spring'],
        shortName: 'womans_hat'
      },
      {
        name: 'Top Hat',
        unified: '1F3A9',
        keywords: ['magic', 'gentleman', 'classy', 'circus'],
        shortName: 'tophat'
      },
      {
        name: 'Graduation Cap',
        unified: '1F393',
        keywords: [
          'school',
          'college',
          'degree',
          'university',
          'graduation',
          'cap',
          'hat',
          'legal',
          'learn',
          'education'
        ],
        shortName: 'mortar_board'
      },
      {
        name: 'Billed Cap',
        unified: '1F9E2',
        shortName: 'billed_cap'
      },
      {
        name: 'Helmet with White Cross',
        unified: '26D1-FE0F',
        shortName: 'helmet_with_white_cross'
      },
      {
        name: 'Prayer Beads',
        unified: '1F4FF',
        keywords: ['dhikr', 'religious'],
        shortName: 'prayer_beads'
      },
      {
        name: 'Lipstick',
        unified: '1F484',
        keywords: ['female', 'girl', 'fashion', 'woman'],
        shortName: 'lipstick'
      },
      {
        name: 'Ring',
        unified: '1F48D',
        keywords: [
          'wedding',
          'propose',
          'marriage',
          'valentines',
          'diamond',
          'fashion',
          'jewelry',
          'gem',
          'engagement'
        ],
        shortName: 'ring'
      },
      {
        name: 'Gem Stone',
        unified: '1F48E',
        keywords: ['blue', 'ruby', 'diamond', 'jewelry'],
        shortName: 'gem'
      },
      {
        name: 'Speaker with Cancellation Stroke',
        unified: '1F507',
        keywords: ['sound', 'volume', 'silence', 'quiet'],
        shortName: 'mute'
      },
      {
        name: 'Speaker',
        unified: '1F508',
        keywords: ['sound', 'volume', 'silence', 'broadcast'],
        shortName: 'speaker'
      },
      {
        name: 'Speaker with One Sound Wave',
        unified: '1F509',
        keywords: ['volume', 'speaker', 'broadcast'],
        shortName: 'sound'
      },
      {
        name: 'Speaker with Three Sound Waves',
        unified: '1F50A',
        keywords: ['volume', 'noise', 'noisy', 'speaker', 'broadcast'],
        shortName: 'loud_sound'
      },
      {
        name: 'Public Address Loudspeaker',
        unified: '1F4E2',
        keywords: ['volume', 'sound'],
        shortName: 'loudspeaker'
      },
      {
        name: 'Cheering Megaphone',
        unified: '1F4E3',
        keywords: ['sound', 'speaker', 'volume'],
        shortName: 'mega'
      },
      {
        name: 'Postal Horn',
        unified: '1F4EF',
        keywords: ['instrument', 'music'],
        shortName: 'postal_horn'
      },
      {
        name: 'Bell',
        unified: '1F514',
        keywords: ['sound', 'notification', 'christmas', 'xmas', 'chime'],
        shortName: 'bell'
      },
      {
        name: 'Bell with Cancellation Stroke',
        unified: '1F515',
        keywords: ['sound', 'volume', 'mute', 'quiet', 'silent'],
        shortName: 'no_bell'
      },
      {
        name: 'Musical Score',
        unified: '1F3BC',
        keywords: ['treble', 'clef', 'compose'],
        shortName: 'musical_score'
      },
      {
        name: 'Musical Note',
        unified: '1F3B5',
        keywords: ['score', 'tone', 'sound'],
        shortName: 'musical_note'
      },
      {
        name: 'Multiple Musical Notes',
        unified: '1F3B6',
        keywords: ['music', 'score'],
        shortName: 'notes'
      },
      {
        name: 'Studio Microphone',
        unified: '1F399-FE0F',
        keywords: ['sing', 'recording', 'artist', 'talkshow'],
        shortName: 'studio_microphone'
      },
      {
        name: 'Level Slider',
        unified: '1F39A-FE0F',
        keywords: ['scale'],
        shortName: 'level_slider'
      },
      {
        name: 'Control Knobs',
        unified: '1F39B-FE0F',
        keywords: ['dial'],
        shortName: 'control_knobs'
      },
      {
        name: 'Microphone',
        unified: '1F3A4',
        keywords: ['sound', 'music', 'PA', 'sing', 'talkshow'],
        shortName: 'microphone'
      },
      {
        name: 'Headphone',
        unified: '1F3A7',
        keywords: ['music', 'score', 'gadgets'],
        shortName: 'headphones'
      },
      {
        name: 'Radio',
        unified: '1F4FB',
        keywords: ['communication', 'music', 'podcast', 'program'],
        shortName: 'radio'
      },
      {
        name: 'Saxophone',
        unified: '1F3B7',
        keywords: ['music', 'instrument', 'jazz', 'blues'],
        shortName: 'saxophone'
      },
      {
        name: 'Guitar',
        unified: '1F3B8',
        keywords: ['music', 'instrument'],
        shortName: 'guitar'
      },
      {
        name: 'Musical Keyboard',
        unified: '1F3B9',
        keywords: ['piano', 'instrument', 'compose'],
        shortName: 'musical_keyboard'
      },
      {
        name: 'Trumpet',
        unified: '1F3BA',
        keywords: ['music', 'brass'],
        shortName: 'trumpet'
      },
      {
        name: 'Violin',
        unified: '1F3BB',
        keywords: ['music', 'instrument', 'orchestra', 'symphony'],
        shortName: 'violin'
      },
      {
        name: 'Banjo',
        unified: '1FA95',
        shortName: 'banjo'
      },
      {
        name: 'Drum with Drumsticks',
        unified: '1F941',
        shortName: 'drum_with_drumsticks'
      },
      {
        name: 'Mobile Phone',
        unified: '1F4F1',
        keywords: ['technology', 'apple', 'gadgets', 'dial'],
        shortName: 'iphone'
      },
      {
        name: 'Mobile Phone with Rightwards Arrow at Left',
        unified: '1F4F2',
        keywords: ['iphone', 'incoming'],
        shortName: 'calling'
      },
      {
        name: 'Black Telephone',
        unified: '260E-FE0F',
        keywords: ['technology', 'communication', 'dial', 'telephone'],
        shortNames: ['phone', 'telephone'],
        shortName: 'phone'
      },
      {
        name: 'Telephone Receiver',
        unified: '1F4DE',
        keywords: ['technology', 'communication', 'dial'],
        shortName: 'telephone_receiver'
      },
      {
        name: 'Pager',
        unified: '1F4DF',
        keywords: ['bbcall', 'oldschool', '90s'],
        shortName: 'pager'
      },
      {
        name: 'Fax Machine',
        unified: '1F4E0',
        keywords: ['communication', 'technology'],
        shortName: 'fax'
      },
      {
        name: 'Battery',
        unified: '1F50B',
        keywords: ['power', 'energy', 'sustain'],
        shortName: 'battery'
      },
      {
        name: 'Electric Plug',
        unified: '1F50C',
        keywords: ['charger', 'power'],
        shortName: 'electric_plug'
      },
      {
        name: 'Personal Computer',
        unified: '1F4BB',
        keywords: ['technology', 'laptop', 'screen', 'display', 'monitor'],
        shortName: 'computer'
      },
      {
        name: 'Desktop Computer',
        unified: '1F5A5-FE0F',
        keywords: ['technology', 'computing', 'screen'],
        shortName: 'desktop_computer'
      },
      {
        name: 'Printer',
        unified: '1F5A8-FE0F',
        keywords: ['paper', 'ink'],
        shortName: 'printer'
      },
      {
        name: 'Keyboard',
        unified: '2328-FE0F',
        keywords: ['technology', 'computer', 'type', 'input', 'text'],
        shortName: 'keyboard'
      },
      {
        name: 'Three Button Mouse',
        unified: '1F5B1-FE0F',
        shortName: 'three_button_mouse'
      },
      {
        name: 'Trackball',
        unified: '1F5B2-FE0F',
        keywords: ['technology', 'trackpad'],
        shortName: 'trackball'
      },
      {
        name: 'Minidisc',
        unified: '1F4BD',
        keywords: ['technology', 'record', 'data', 'disk', '90s'],
        shortName: 'minidisc'
      },
      {
        name: 'Floppy Disk',
        unified: '1F4BE',
        keywords: ['oldschool', 'technology', 'save', '90s', '80s'],
        shortName: 'floppy_disk'
      },
      {
        name: 'Optical Disc',
        unified: '1F4BF',
        keywords: ['technology', 'dvd', 'disk', 'disc', '90s'],
        shortName: 'cd'
      },
      {
        name: 'Dvd',
        unified: '1F4C0',
        keywords: ['cd', 'disk', 'disc'],
        shortName: 'dvd'
      },
      {
        name: 'Abacus',
        unified: '1F9EE',
        keywords: ['calculation'],
        shortName: 'abacus'
      },
      {
        name: 'Movie Camera',
        unified: '1F3A5',
        keywords: ['film', 'record'],
        shortName: 'movie_camera'
      },
      {
        name: 'Film Frames',
        unified: '1F39E-FE0F',
        shortName: 'film_frames'
      },
      {
        name: 'Film Projector',
        unified: '1F4FD-FE0F',
        keywords: ['video', 'tape', 'record', 'movie'],
        shortName: 'film_projector'
      },
      {
        name: 'Clapper Board',
        unified: '1F3AC',
        keywords: ['movie', 'film', 'record'],
        shortName: 'clapper'
      },
      {
        name: 'Television',
        unified: '1F4FA',
        keywords: ['technology', 'program', 'oldschool', 'show', 'television'],
        shortName: 'tv'
      },
      {
        name: 'Camera',
        unified: '1F4F7',
        keywords: ['gadgets', 'photography'],
        shortName: 'camera'
      },
      {
        name: 'Camera with Flash',
        unified: '1F4F8',
        shortName: 'camera_with_flash'
      },
      {
        name: 'Video Camera',
        unified: '1F4F9',
        keywords: ['film', 'record'],
        shortName: 'video_camera'
      },
      {
        name: 'Videocassette',
        unified: '1F4FC',
        keywords: ['record', 'video', 'oldschool', '90s', '80s'],
        shortName: 'vhs'
      },
      {
        name: 'Left-Pointing Magnifying Glass',
        unified: '1F50D',
        keywords: ['search', 'zoom', 'find', 'detective'],
        shortName: 'mag'
      },
      {
        name: 'Right-Pointing Magnifying Glass',
        unified: '1F50E',
        keywords: ['search', 'zoom', 'find', 'detective'],
        shortName: 'mag_right'
      },
      {
        name: 'Candle',
        unified: '1F56F-FE0F',
        keywords: ['fire', 'wax'],
        shortName: 'candle'
      },
      {
        name: 'Electric Light Bulb',
        unified: '1F4A1',
        keywords: ['light', 'electricity', 'idea'],
        shortName: 'bulb'
      },
      {
        name: 'Electric Torch',
        unified: '1F526',
        keywords: ['dark', 'camping', 'sight', 'night'],
        shortName: 'flashlight'
      },
      {
        name: 'Izakaya Lantern',
        unified: '1F3EE',
        keywords: ['light', 'paper', 'halloween', 'spooky'],
        shortNames: ['izakaya_lantern', 'lantern'],
        shortName: 'izakaya_lantern'
      },
      {
        name: 'Diya Lamp',
        unified: '1FA94',
        shortName: 'diya_lamp'
      },
      {
        name: 'Notebook with Decorative Cover',
        unified: '1F4D4',
        keywords: ['classroom', 'notes', 'record', 'paper', 'study'],
        shortName: 'notebook_with_decorative_cover'
      },
      {
        name: 'Closed Book',
        unified: '1F4D5',
        keywords: ['read', 'library', 'knowledge', 'textbook', 'learn'],
        shortName: 'closed_book'
      },
      {
        name: 'Open Book',
        unified: '1F4D6',
        shortNames: ['book', 'open_book'],
        shortName: 'book'
      },
      {
        name: 'Green Book',
        unified: '1F4D7',
        keywords: ['read', 'library', 'knowledge', 'study'],
        shortName: 'green_book'
      },
      {
        name: 'Blue Book',
        unified: '1F4D8',
        keywords: ['read', 'library', 'knowledge', 'learn', 'study'],
        shortName: 'blue_book'
      },
      {
        name: 'Orange Book',
        unified: '1F4D9',
        keywords: ['read', 'library', 'knowledge', 'textbook', 'study'],
        shortName: 'orange_book'
      },
      {
        name: 'Books',
        unified: '1F4DA',
        keywords: ['literature', 'library', 'study'],
        shortName: 'books'
      },
      {
        name: 'Notebook',
        unified: '1F4D3',
        keywords: ['stationery', 'record', 'notes', 'paper', 'study'],
        shortName: 'notebook'
      },
      {
        name: 'Ledger',
        unified: '1F4D2',
        keywords: ['notes', 'paper'],
        shortName: 'ledger'
      },
      {
        name: 'Page with Curl',
        unified: '1F4C3',
        keywords: ['documents', 'office', 'paper'],
        shortName: 'page_with_curl'
      },
      {
        name: 'Scroll',
        unified: '1F4DC',
        keywords: ['documents', 'ancient', 'history', 'paper'],
        shortName: 'scroll'
      },
      {
        name: 'Page Facing Up',
        unified: '1F4C4',
        keywords: ['documents', 'office', 'paper', 'information'],
        shortName: 'page_facing_up'
      },
      {
        name: 'Newspaper',
        unified: '1F4F0',
        keywords: ['press', 'headline'],
        shortName: 'newspaper'
      },
      {
        name: 'Rolled Up Newspaper',
        unified: '1F5DE-FE0F',
        shortName: 'rolled_up_newspaper'
      },
      {
        name: 'Bookmark Tabs',
        unified: '1F4D1',
        keywords: ['favorite', 'save', 'order', 'tidy'],
        shortName: 'bookmark_tabs'
      },
      {
        name: 'Bookmark',
        unified: '1F516',
        keywords: ['favorite', 'label', 'save'],
        shortName: 'bookmark'
      },
      {
        name: 'Label',
        unified: '1F3F7-FE0F',
        keywords: ['sale', 'tag'],
        shortName: 'label'
      },
      {
        name: 'Money Bag',
        unified: '1F4B0',
        keywords: ['dollar', 'payment', 'coins', 'sale'],
        shortName: 'moneybag'
      },
      {
        name: 'Banknote with Yen Sign',
        unified: '1F4B4',
        keywords: ['money', 'sales', 'japanese', 'dollar', 'currency'],
        shortName: 'yen'
      },
      {
        name: 'Banknote with Dollar Sign',
        unified: '1F4B5',
        keywords: ['money', 'sales', 'bill', 'currency'],
        shortName: 'dollar'
      },
      {
        name: 'Banknote with Euro Sign',
        unified: '1F4B6',
        keywords: ['money', 'sales', 'dollar', 'currency'],
        shortName: 'euro'
      },
      {
        name: 'Banknote with Pound Sign',
        unified: '1F4B7',
        keywords: ['british', 'sterling', 'money', 'sales', 'bills', 'uk', 'england', 'currency'],
        shortName: 'pound'
      },
      {
        name: 'Money with Wings',
        unified: '1F4B8',
        keywords: ['dollar', 'bills', 'payment', 'sale'],
        shortName: 'money_with_wings'
      },
      {
        name: 'Credit Card',
        unified: '1F4B3',
        keywords: ['money', 'sales', 'dollar', 'bill', 'payment', 'shopping'],
        shortName: 'credit_card'
      },
      {
        name: 'Receipt',
        unified: '1F9FE',
        keywords: ['accounting', 'expenses'],
        shortName: 'receipt'
      },
      {
        name: 'Chart with Upwards Trend and Yen Sign',
        unified: '1F4B9',
        keywords: ['green-square', 'graph', 'presentation', 'stats'],
        shortName: 'chart'
      },
      {
        name: 'Currency Exchange',
        unified: '1F4B1',
        keywords: ['money', 'sales', 'dollar', 'travel'],
        shortName: 'currency_exchange'
      },
      {
        name: 'Heavy Dollar Sign',
        unified: '1F4B2',
        keywords: ['money', 'sales', 'payment', 'currency', 'buck'],
        shortName: 'heavy_dollar_sign'
      },
      {
        name: 'Envelope',
        unified: '2709-FE0F',
        keywords: ['letter', 'postal', 'inbox', 'communication'],
        shortNames: ['email', 'envelope'],
        shortName: 'email'
      },
      {
        name: 'E-Mail Symbol',
        unified: '1F4E7',
        keywords: ['communication', 'inbox'],
        shortName: 'e-mail'
      },
      {
        name: 'Incoming Envelope',
        unified: '1F4E8',
        keywords: ['email', 'inbox'],
        shortName: 'incoming_envelope'
      },
      {
        name: 'Envelope with Downwards Arrow Above',
        unified: '1F4E9',
        keywords: ['email', 'communication'],
        shortName: 'envelope_with_arrow'
      },
      {
        name: 'Outbox Tray',
        unified: '1F4E4',
        keywords: ['inbox', 'email'],
        shortName: 'outbox_tray'
      },
      {
        name: 'Inbox Tray',
        unified: '1F4E5',
        keywords: ['email', 'documents'],
        shortName: 'inbox_tray'
      },
      {
        name: 'Package',
        unified: '1F4E6',
        keywords: ['mail', 'gift', 'cardboard', 'box', 'moving'],
        shortName: 'package'
      },
      {
        name: 'Closed Mailbox with Raised Flag',
        unified: '1F4EB',
        keywords: ['email', 'inbox', 'communication'],
        shortName: 'mailbox'
      },
      {
        name: 'Closed Mailbox with Lowered Flag',
        unified: '1F4EA',
        keywords: ['email', 'communication', 'inbox'],
        shortName: 'mailbox_closed'
      },
      {
        name: 'Open Mailbox with Raised Flag',
        unified: '1F4EC',
        keywords: ['email', 'inbox', 'communication'],
        shortName: 'mailbox_with_mail'
      },
      {
        name: 'Open Mailbox with Lowered Flag',
        unified: '1F4ED',
        keywords: ['email', 'inbox'],
        shortName: 'mailbox_with_no_mail'
      },
      {
        name: 'Postbox',
        unified: '1F4EE',
        keywords: ['email', 'letter', 'envelope'],
        shortName: 'postbox'
      },
      {
        name: 'Ballot Box with Ballot',
        unified: '1F5F3-FE0F',
        shortName: 'ballot_box_with_ballot'
      },
      {
        name: 'Pencil',
        unified: '270F-FE0F',
        keywords: ['stationery', 'write', 'paper', 'writing', 'school', 'study'],
        shortName: 'pencil2'
      },
      {
        name: 'Black Nib',
        unified: '2712-FE0F',
        keywords: ['pen', 'stationery', 'writing', 'write'],
        shortName: 'black_nib'
      },
      {
        name: 'Lower Left Fountain Pen',
        unified: '1F58B-FE0F',
        shortName: 'lower_left_fountain_pen'
      },
      {
        name: 'Lower Left Ballpoint Pen',
        unified: '1F58A-FE0F',
        shortName: 'lower_left_ballpoint_pen'
      },
      {
        name: 'Lower Left Paintbrush',
        unified: '1F58C-FE0F',
        shortName: 'lower_left_paintbrush'
      },
      {
        name: 'Lower Left Crayon',
        unified: '1F58D-FE0F',
        shortName: 'lower_left_crayon'
      },
      {
        name: 'Memo',
        unified: '1F4DD',
        keywords: [
          'write',
          'documents',
          'stationery',
          'pencil',
          'paper',
          'writing',
          'legal',
          'exam',
          'quiz',
          'test',
          'study',
          'compose'
        ],
        shortNames: ['memo', 'pencil'],
        shortName: 'memo'
      },
      {
        name: 'Briefcase',
        unified: '1F4BC',
        keywords: ['business', 'documents', 'work', 'law', 'legal', 'job', 'career'],
        shortName: 'briefcase'
      },
      {
        name: 'File Folder',
        unified: '1F4C1',
        keywords: ['documents', 'business', 'office'],
        shortName: 'file_folder'
      },
      {
        name: 'Open File Folder',
        unified: '1F4C2',
        keywords: ['documents', 'load'],
        shortName: 'open_file_folder'
      },
      {
        name: 'Card Index Dividers',
        unified: '1F5C2-FE0F',
        keywords: ['organizing', 'business', 'stationery'],
        shortName: 'card_index_dividers'
      },
      {
        name: 'Calendar',
        unified: '1F4C5',
        keywords: ['calendar', 'schedule'],
        shortName: 'date'
      },
      {
        name: 'Tear-off Calendar',
        unified: '1F4C6',
        keywords: ['schedule', 'date', 'planning'],
        shortName: 'calendar'
      },
      {
        name: 'Spiral Note Pad',
        unified: '1F5D2-FE0F',
        shortName: 'spiral_note_pad'
      },
      {
        name: 'Spiral Calendar Pad',
        unified: '1F5D3-FE0F',
        shortName: 'spiral_calendar_pad'
      },
      {
        name: 'Card Index',
        unified: '1F4C7',
        keywords: ['business', 'stationery'],
        shortName: 'card_index'
      },
      {
        name: 'Chart with Upwards Trend',
        unified: '1F4C8',
        keywords: [
          'graph',
          'presentation',
          'stats',
          'recovery',
          'business',
          'economics',
          'money',
          'sales',
          'good',
          'success'
        ],
        shortName: 'chart_with_upwards_trend'
      },
      {
        name: 'Chart with Downwards Trend',
        unified: '1F4C9',
        keywords: [
          'graph',
          'presentation',
          'stats',
          'recession',
          'business',
          'economics',
          'money',
          'sales',
          'bad',
          'failure'
        ],
        shortName: 'chart_with_downwards_trend'
      },
      {
        name: 'Bar Chart',
        unified: '1F4CA',
        keywords: ['graph', 'presentation', 'stats'],
        shortName: 'bar_chart'
      },
      {
        name: 'Clipboard',
        unified: '1F4CB',
        keywords: ['stationery', 'documents'],
        shortName: 'clipboard'
      },
      {
        name: 'Pushpin',
        unified: '1F4CC',
        keywords: ['stationery', 'mark', 'here'],
        shortName: 'pushpin'
      },
      {
        name: 'Round Pushpin',
        unified: '1F4CD',
        keywords: ['stationery', 'location', 'map', 'here'],
        shortName: 'round_pushpin'
      },
      {
        name: 'Paperclip',
        unified: '1F4CE',
        keywords: ['documents', 'stationery'],
        shortName: 'paperclip'
      },
      {
        name: 'Linked Paperclips',
        unified: '1F587-FE0F',
        shortName: 'linked_paperclips'
      },
      {
        name: 'Straight Ruler',
        unified: '1F4CF',
        keywords: ['stationery', 'calculate', 'length', 'math', 'school', 'drawing', 'architect', 'sketch'],
        shortName: 'straight_ruler'
      },
      {
        name: 'Triangular Ruler',
        unified: '1F4D0',
        keywords: ['stationery', 'math', 'architect', 'sketch'],
        shortName: 'triangular_ruler'
      },
      {
        name: 'Black Scissors',
        unified: '2702-FE0F',
        keywords: ['stationery', 'cut'],
        shortName: 'scissors'
      },
      {
        name: 'Card File Box',
        unified: '1F5C3-FE0F',
        keywords: ['business', 'stationery'],
        shortName: 'card_file_box'
      },
      {
        name: 'File Cabinet',
        unified: '1F5C4-FE0F',
        keywords: ['filing', 'organizing'],
        shortName: 'file_cabinet'
      },
      {
        name: 'Wastebasket',
        unified: '1F5D1-FE0F',
        keywords: ['bin', 'trash', 'rubbish', 'garbage', 'toss'],
        shortName: 'wastebasket'
      },
      {
        name: 'Lock',
        unified: '1F512',
        keywords: ['security', 'password', 'padlock'],
        shortName: 'lock'
      },
      {
        name: 'Open Lock',
        unified: '1F513',
        keywords: ['privacy', 'security'],
        shortName: 'unlock'
      },
      {
        name: 'Lock with Ink Pen',
        unified: '1F50F',
        keywords: ['security', 'secret'],
        shortName: 'lock_with_ink_pen'
      },
      {
        name: 'Closed Lock with Key',
        unified: '1F510',
        keywords: ['security', 'privacy'],
        shortName: 'closed_lock_with_key'
      },
      {
        name: 'Key',
        unified: '1F511',
        keywords: ['lock', 'door', 'password'],
        shortName: 'key'
      },
      {
        name: 'Old Key',
        unified: '1F5DD-FE0F',
        keywords: ['lock', 'door', 'password'],
        shortName: 'old_key'
      },
      {
        name: 'Hammer',
        unified: '1F528',
        keywords: ['tools', 'build', 'create'],
        shortName: 'hammer'
      },
      {
        name: 'Axe',
        unified: '1FA93',
        shortName: 'axe'
      },
      {
        name: 'Pick',
        unified: '26CF-FE0F',
        keywords: ['tools', 'dig'],
        shortName: 'pick'
      },
      {
        name: 'Hammer and Pick',
        unified: '2692-FE0F',
        keywords: ['tools', 'build', 'create'],
        shortName: 'hammer_and_pick'
      },
      {
        name: 'Hammer and Wrench',
        unified: '1F6E0-FE0F',
        keywords: ['tools', 'build', 'create'],
        shortName: 'hammer_and_wrench'
      },
      {
        name: 'Dagger Knife',
        unified: '1F5E1-FE0F',
        shortName: 'dagger_knife'
      },
      {
        name: 'Crossed Swords',
        unified: '2694-FE0F',
        keywords: ['weapon'],
        shortName: 'crossed_swords'
      },
      {
        name: 'Pistol',
        unified: '1F52B',
        keywords: ['violence', 'weapon', 'pistol', 'revolver'],
        shortName: 'gun'
      },
      {
        name: 'Bow and Arrow',
        unified: '1F3F9',
        keywords: ['sports'],
        shortName: 'bow_and_arrow'
      },
      {
        name: 'Shield',
        unified: '1F6E1-FE0F',
        keywords: ['protection', 'security'],
        shortName: 'shield'
      },
      {
        name: 'Wrench',
        unified: '1F527',
        keywords: ['tools', 'diy', 'ikea', 'fix', 'maintainer'],
        shortName: 'wrench'
      },
      {
        name: 'Nut and Bolt',
        unified: '1F529',
        keywords: ['handy', 'tools', 'fix'],
        shortName: 'nut_and_bolt'
      },
      {
        name: 'Gear',
        unified: '2699-FE0F',
        keywords: ['cog'],
        shortName: 'gear'
      },
      {
        name: 'Compression',
        unified: '1F5DC-FE0F',
        shortName: 'compression'
      },
      {
        name: 'Scales',
        unified: '2696-FE0F',
        shortName: 'scales'
      },
      {
        name: 'Probing Cane',
        unified: '1F9AF',
        shortName: 'probing_cane'
      },
      {
        name: 'Link Symbol',
        unified: '1F517',
        keywords: ['rings', 'url'],
        shortName: 'link'
      },
      {
        name: 'Chains',
        unified: '26D3-FE0F',
        keywords: ['lock', 'arrest'],
        shortName: 'chains'
      },
      {
        name: 'Toolbox',
        unified: '1F9F0',
        keywords: ['tools', 'diy', 'fix', 'maintainer', 'mechanic'],
        shortName: 'toolbox'
      },
      {
        name: 'Magnet',
        unified: '1F9F2',
        keywords: ['attraction', 'magnetic'],
        shortName: 'magnet'
      },
      {
        name: 'Alembic',
        unified: '2697-FE0F',
        keywords: ['distilling', 'science', 'experiment', 'chemistry'],
        shortName: 'alembic'
      },
      {
        name: 'Test Tube',
        unified: '1F9EA',
        keywords: ['chemistry', 'experiment', 'lab', 'science'],
        shortName: 'test_tube'
      },
      {
        name: 'Petri Dish',
        unified: '1F9EB',
        keywords: ['bacteria', 'biology', 'culture', 'lab'],
        shortName: 'petri_dish'
      },
      {
        name: 'Dna Double Helix',
        unified: '1F9EC',
        keywords: ['biologist', 'genetics', 'life'],
        shortName: 'dna'
      },
      {
        name: 'Microscope',
        unified: '1F52C',
        keywords: ['laboratory', 'experiment', 'zoomin', 'science', 'study'],
        shortName: 'microscope'
      },
      {
        name: 'Telescope',
        unified: '1F52D',
        keywords: ['stars', 'space', 'zoom', 'science', 'astronomy'],
        shortName: 'telescope'
      },
      {
        name: 'Satellite Antenna',
        unified: '1F4E1',
        shortName: 'satellite_antenna'
      },
      {
        name: 'Syringe',
        unified: '1F489',
        keywords: ['health', 'hospital', 'drugs', 'blood', 'medicine', 'needle', 'doctor', 'nurse'],
        shortName: 'syringe'
      },
      {
        name: 'Drop of Blood',
        unified: '1FA78',
        shortName: 'drop_of_blood'
      },
      {
        name: 'Pill',
        unified: '1F48A',
        keywords: ['health', 'medicine', 'doctor', 'pharmacy', 'drug'],
        shortName: 'pill'
      },
      {
        name: 'Adhesive Bandage',
        unified: '1FA79',
        shortName: 'adhesive_bandage'
      },
      {
        name: 'Stethoscope',
        unified: '1FA7A',
        shortName: 'stethoscope'
      },
      {
        name: 'Door',
        unified: '1F6AA',
        keywords: ['house', 'entry', 'exit'],
        shortName: 'door'
      },
      {
        name: 'Bed',
        unified: '1F6CF-FE0F',
        keywords: ['sleep', 'rest'],
        shortName: 'bed'
      },
      {
        name: 'Couch and Lamp',
        unified: '1F6CB-FE0F',
        keywords: ['read', 'chill'],
        shortName: 'couch_and_lamp'
      },
      {
        name: 'Chair',
        unified: '1FA91',
        shortName: 'chair'
      },
      {
        name: 'Toilet',
        unified: '1F6BD',
        keywords: ['restroom', 'wc', 'washroom', 'bathroom', 'potty'],
        shortName: 'toilet'
      },
      {
        name: 'Shower',
        unified: '1F6BF',
        keywords: ['clean', 'water', 'bathroom'],
        shortName: 'shower'
      },
      {
        name: 'Bathtub',
        unified: '1F6C1',
        keywords: ['clean', 'shower', 'bathroom'],
        shortName: 'bathtub'
      },
      {
        name: 'Razor',
        unified: '1FA92',
        shortName: 'razor'
      },
      {
        name: 'Lotion Bottle',
        unified: '1F9F4',
        keywords: ['moisturizer', 'sunscreen'],
        shortName: 'lotion_bottle'
      },
      {
        name: 'Safety Pin',
        unified: '1F9F7',
        keywords: ['diaper'],
        shortName: 'safety_pin'
      },
      {
        name: 'Broom',
        unified: '1F9F9',
        keywords: ['cleaning', 'sweeping', 'witch'],
        shortName: 'broom'
      },
      {
        name: 'Basket',
        unified: '1F9FA',
        keywords: ['laundry'],
        shortName: 'basket'
      },
      {
        name: 'Roll of Paper',
        unified: '1F9FB',
        shortName: 'roll_of_paper'
      },
      {
        name: 'Bar of Soap',
        unified: '1F9FC',
        keywords: ['bar', 'bathing', 'cleaning', 'lather'],
        shortName: 'soap'
      },
      {
        name: 'Sponge',
        unified: '1F9FD',
        keywords: ['absorbing', 'cleaning', 'porous'],
        shortName: 'sponge'
      },
      {
        name: 'Fire Extinguisher',
        unified: '1F9EF',
        keywords: ['quench'],
        shortName: 'fire_extinguisher'
      },
      {
        name: 'Shopping Trolley',
        unified: '1F6D2',
        shortName: 'shopping_trolley'
      },
      {
        name: 'Smoking Symbol',
        unified: '1F6AC',
        keywords: ['kills', 'tobacco', 'cigarette', 'joint', 'smoke'],
        shortName: 'smoking'
      },
      {
        name: 'Coffin',
        unified: '26B0-FE0F',
        keywords: ['vampire', 'dead', 'die', 'death', 'rip', 'graveyard', 'cemetery', 'casket', 'funeral', 'box'],
        shortName: 'coffin'
      },
      {
        name: 'Funeral Urn',
        unified: '26B1-FE0F',
        keywords: ['dead', 'die', 'death', 'rip', 'ashes'],
        shortName: 'funeral_urn'
      },
      {
        name: 'Moyai',
        unified: '1F5FF',
        keywords: ['rock', 'easter island', 'moai'],
        shortName: 'moyai'
      }
    ]
  },
  {
    id: 'symbols',
    name: 'Symbols',
    emojis: [
      {
        name: 'Automated Teller Machine',
        unified: '1F3E7',
        keywords: ['money', 'sales', 'cash', 'blue-square', 'payment', 'bank'],
        shortName: 'atm'
      },
      {
        name: 'Put Litter in Its Place Symbol',
        unified: '1F6AE',
        keywords: ['blue-square', 'sign', 'human', 'info'],
        shortName: 'put_litter_in_its_place'
      },
      {
        name: 'Potable Water Symbol',
        unified: '1F6B0',
        keywords: ['blue-square', 'liquid', 'restroom', 'cleaning', 'faucet'],
        shortName: 'potable_water'
      },
      {
        name: 'Wheelchair Symbol',
        unified: '267F',
        keywords: ['blue-square', 'disabled', 'a11y', 'accessibility'],
        shortName: 'wheelchair'
      },
      {
        name: 'Mens Symbol',
        unified: '1F6B9',
        keywords: ['toilet', 'restroom', 'wc', 'blue-square', 'gender', 'male'],
        shortName: 'mens'
      },
      {
        name: 'Womens Symbol',
        unified: '1F6BA',
        keywords: ['purple-square', 'woman', 'female', 'toilet', 'loo', 'restroom', 'gender'],
        shortName: 'womens'
      },
      {
        name: 'Restroom',
        unified: '1F6BB',
        keywords: ['blue-square', 'toilet', 'refresh', 'wc', 'gender'],
        shortName: 'restroom'
      },
      {
        name: 'Baby Symbol',
        unified: '1F6BC',
        keywords: ['orange-square', 'child'],
        shortName: 'baby_symbol'
      },
      {
        name: 'Water Closet',
        unified: '1F6BE',
        keywords: ['toilet', 'restroom', 'blue-square'],
        shortName: 'wc'
      },
      {
        name: 'Passport Control',
        unified: '1F6C2',
        keywords: ['custom', 'blue-square'],
        shortName: 'passport_control'
      },
      {
        name: 'Customs',
        unified: '1F6C3',
        keywords: ['passport', 'border', 'blue-square'],
        shortName: 'customs'
      },
      {
        name: 'Baggage Claim',
        unified: '1F6C4',
        keywords: ['blue-square', 'airport', 'transport'],
        shortName: 'baggage_claim'
      },
      {
        name: 'Left Luggage',
        unified: '1F6C5',
        keywords: ['blue-square', 'travel'],
        shortName: 'left_luggage'
      },
      {
        name: 'Warning Sign',
        unified: '26A0-FE0F',
        keywords: ['exclamation', 'wip', 'alert', 'error', 'problem', 'issue'],
        shortName: 'warning'
      },
      {
        name: 'Children Crossing',
        unified: '1F6B8',
        keywords: ['school', 'warning', 'danger', 'sign', 'driving', 'yellow-diamond'],
        shortName: 'children_crossing'
      },
      {
        name: 'No Entry',
        unified: '26D4',
        keywords: ['limit', 'security', 'privacy', 'bad', 'denied', 'stop', 'circle'],
        shortName: 'no_entry'
      },
      {
        name: 'No Entry Sign',
        unified: '1F6AB',
        keywords: ['forbid', 'stop', 'limit', 'denied', 'disallow', 'circle'],
        shortName: 'no_entry_sign'
      },
      {
        name: 'No Bicycles',
        unified: '1F6B3',
        keywords: ['cyclist', 'prohibited', 'circle'],
        shortName: 'no_bicycles'
      },
      {
        name: 'No Smoking Symbol',
        unified: '1F6AD',
        keywords: ['cigarette', 'blue-square', 'smell', 'smoke'],
        shortName: 'no_smoking'
      },
      {
        name: 'Do Not Litter Symbol',
        unified: '1F6AF',
        keywords: ['trash', 'bin', 'garbage', 'circle'],
        shortName: 'do_not_litter'
      },
      {
        name: 'Non-Potable Water Symbol',
        unified: '1F6B1',
        keywords: ['drink', 'faucet', 'tap', 'circle'],
        shortName: 'non-potable_water'
      },
      {
        name: 'No Pedestrians',
        unified: '1F6B7',
        keywords: ['rules', 'crossing', 'walking', 'circle'],
        shortName: 'no_pedestrians'
      },
      {
        name: 'No Mobile Phones',
        unified: '1F4F5',
        keywords: ['iphone', 'mute', 'circle'],
        shortName: 'no_mobile_phones'
      },
      {
        name: 'No One Under Eighteen Symbol',
        unified: '1F51E',
        keywords: ['18', 'drink', 'pub', 'night', 'minor', 'circle'],
        shortName: 'underage'
      },
      {
        name: 'Radioactive Sign',
        unified: '2622-FE0F',
        shortName: 'radioactive_sign'
      },
      {
        name: 'Biohazard Sign',
        unified: '2623-FE0F',
        shortName: 'biohazard_sign'
      },
      {
        name: 'Upwards Black Arrow',
        unified: '2B06-FE0F',
        keywords: ['blue-square', 'continue', 'top', 'direction'],
        shortName: 'arrow_up'
      },
      {
        name: 'North East Arrow',
        unified: '2197-FE0F',
        keywords: ['blue-square', 'point', 'direction', 'diagonal', 'northeast'],
        shortName: 'arrow_upper_right'
      },
      {
        name: 'Black Rightwards Arrow',
        unified: '27A1-FE0F',
        keywords: ['blue-square', 'next'],
        shortName: 'arrow_right'
      },
      {
        name: 'South East Arrow',
        unified: '2198-FE0F',
        keywords: ['blue-square', 'direction', 'diagonal', 'southeast'],
        shortName: 'arrow_lower_right'
      },
      {
        name: 'Downwards Black Arrow',
        unified: '2B07-FE0F',
        keywords: ['blue-square', 'direction', 'bottom'],
        shortName: 'arrow_down'
      },
      {
        name: 'South West Arrow',
        unified: '2199-FE0F',
        keywords: ['blue-square', 'direction', 'diagonal', 'southwest'],
        shortName: 'arrow_lower_left'
      },
      {
        name: 'Leftwards Black Arrow',
        unified: '2B05-FE0F',
        keywords: ['blue-square', 'previous', 'back'],
        shortName: 'arrow_left'
      },
      {
        name: 'North West Arrow',
        unified: '2196-FE0F',
        keywords: ['blue-square', 'point', 'direction', 'diagonal', 'northwest'],
        shortName: 'arrow_upper_left'
      },
      {
        name: 'Up Down Arrow',
        unified: '2195-FE0F',
        keywords: ['blue-square', 'direction', 'way', 'vertical'],
        shortName: 'arrow_up_down'
      },
      {
        name: 'Left Right Arrow',
        unified: '2194-FE0F',
        keywords: ['shape', 'direction', 'horizontal', 'sideways'],
        shortName: 'left_right_arrow'
      },
      {
        name: 'Leftwards Arrow with Hook',
        unified: '21A9-FE0F',
        keywords: ['back', 'return', 'blue-square', 'undo', 'enter'],
        shortName: 'leftwards_arrow_with_hook'
      },
      {
        name: 'Rightwards Arrow with Hook',
        unified: '21AA-FE0F',
        keywords: ['blue-square', 'return', 'rotate', 'direction'],
        shortName: 'arrow_right_hook'
      },
      {
        name: 'Arrow Pointing Rightwards Then Curving Upwards',
        unified: '2934-FE0F',
        keywords: ['blue-square', 'direction', 'top'],
        shortName: 'arrow_heading_up'
      },
      {
        name: 'Arrow Pointing Rightwards Then Curving Downwards',
        unified: '2935-FE0F',
        keywords: ['blue-square', 'direction', 'bottom'],
        shortName: 'arrow_heading_down'
      },
      {
        name: 'Clockwise Downwards and Upwards Open Circle Arrows',
        unified: '1F503',
        keywords: ['sync', 'cycle', 'round', 'repeat'],
        shortName: 'arrows_clockwise'
      },
      {
        name: 'Anticlockwise Downwards and Upwards Open Circle Arrows',
        unified: '1F504',
        keywords: ['blue-square', 'sync', 'cycle'],
        shortName: 'arrows_counterclockwise'
      },
      {
        name: 'Back with Leftwards Arrow Above',
        unified: '1F519',
        keywords: ['arrow', 'words', 'return'],
        shortName: 'back'
      },
      {
        name: 'End with Leftwards Arrow Above',
        unified: '1F51A',
        keywords: ['words', 'arrow'],
        shortName: 'end'
      },
      {
        name: 'On with Exclamation Mark with Left Right Arrow Above',
        unified: '1F51B',
        keywords: ['arrow', 'words'],
        shortName: 'on'
      },
      {
        name: 'Soon with Rightwards Arrow Above',
        unified: '1F51C',
        keywords: ['arrow', 'words'],
        shortName: 'soon'
      },
      {
        name: 'Top with Upwards Arrow Above',
        unified: '1F51D',
        keywords: ['words', 'blue-square'],
        shortName: 'top'
      },
      {
        name: 'Place of Worship',
        unified: '1F6D0',
        keywords: ['religion', 'church', 'temple', 'prayer'],
        shortName: 'place_of_worship'
      },
      {
        name: 'Atom Symbol',
        unified: '269B-FE0F',
        keywords: ['science', 'physics', 'chemistry'],
        shortName: 'atom_symbol'
      },
      {
        name: 'Om Symbol',
        unified: '1F549-FE0F',
        shortName: 'om_symbol'
      },
      {
        name: 'Star of David',
        unified: '2721-FE0F',
        keywords: ['judaism'],
        shortName: 'star_of_david'
      },
      {
        name: 'Wheel of Dharma',
        unified: '2638-FE0F',
        keywords: ['hinduism', 'buddhism', 'sikhism', 'jainism'],
        shortName: 'wheel_of_dharma'
      },
      {
        name: 'Yin Yang',
        unified: '262F-FE0F',
        keywords: ['balance'],
        shortName: 'yin_yang'
      },
      {
        name: 'Latin Cross',
        unified: '271D-FE0F',
        keywords: ['christianity'],
        shortName: 'latin_cross'
      },
      {
        name: 'Orthodox Cross',
        unified: '2626-FE0F',
        keywords: ['suppedaneum', 'religion'],
        shortName: 'orthodox_cross'
      },
      {
        name: 'Star and Crescent',
        unified: '262A-FE0F',
        keywords: ['islam'],
        shortName: 'star_and_crescent'
      },
      {
        name: 'Peace Symbol',
        unified: '262E-FE0F',
        keywords: ['hippie'],
        shortName: 'peace_symbol'
      },
      {
        name: 'Menorah with Nine Branches',
        unified: '1F54E',
        shortName: 'menorah_with_nine_branches'
      },
      {
        name: 'Six Pointed Star with Middle Dot',
        unified: '1F52F',
        keywords: ['purple-square', 'religion', 'jewish', 'hexagram'],
        shortName: 'six_pointed_star'
      },
      {
        name: 'Aries',
        unified: '2648',
        keywords: ['sign', 'purple-square', 'zodiac', 'astrology'],
        shortName: 'aries'
      },
      {
        name: 'Taurus',
        unified: '2649',
        keywords: ['purple-square', 'sign', 'zodiac', 'astrology'],
        shortName: 'taurus'
      },
      {
        name: 'Gemini',
        unified: '264A',
        keywords: ['sign', 'zodiac', 'purple-square', 'astrology'],
        shortName: 'gemini'
      },
      {
        name: 'Cancer',
        unified: '264B',
        keywords: ['sign', 'zodiac', 'purple-square', 'astrology'],
        shortName: 'cancer'
      },
      {
        name: 'Leo',
        unified: '264C',
        keywords: ['sign', 'purple-square', 'zodiac', 'astrology'],
        shortName: 'leo'
      },
      {
        name: 'Virgo',
        unified: '264D',
        keywords: ['sign', 'zodiac', 'purple-square', 'astrology'],
        shortName: 'virgo'
      },
      {
        name: 'Libra',
        unified: '264E',
        keywords: ['sign', 'purple-square', 'zodiac', 'astrology'],
        shortName: 'libra'
      },
      {
        name: 'Scorpius',
        unified: '264F',
        keywords: ['sign', 'zodiac', 'purple-square', 'astrology', 'scorpio'],
        shortName: 'scorpius'
      },
      {
        name: 'Sagittarius',
        unified: '2650',
        keywords: ['sign', 'zodiac', 'purple-square', 'astrology'],
        shortName: 'sagittarius'
      },
      {
        name: 'Capricorn',
        unified: '2651',
        keywords: ['sign', 'zodiac', 'purple-square', 'astrology'],
        shortName: 'capricorn'
      },
      {
        name: 'Aquarius',
        unified: '2652',
        keywords: ['sign', 'purple-square', 'zodiac', 'astrology'],
        shortName: 'aquarius'
      },
      {
        name: 'Pisces',
        unified: '2653',
        keywords: ['purple-square', 'sign', 'zodiac', 'astrology'],
        shortName: 'pisces'
      },
      {
        name: 'Ophiuchus',
        unified: '26CE',
        keywords: ['sign', 'purple-square', 'constellation', 'astrology'],
        shortName: 'ophiuchus'
      },
      {
        name: 'Twisted Rightwards Arrows',
        unified: '1F500',
        keywords: ['blue-square', 'shuffle', 'music', 'random'],
        shortName: 'twisted_rightwards_arrows'
      },
      {
        name: 'Clockwise Rightwards and Leftwards Open Circle Arrows',
        unified: '1F501',
        keywords: ['loop', 'record'],
        shortName: 'repeat'
      },
      {
        name: 'Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay',
        unified: '1F502',
        keywords: ['blue-square', 'loop'],
        shortName: 'repeat_one'
      },
      {
        name: 'Black Right-Pointing Triangle',
        unified: '25B6-FE0F',
        keywords: ['blue-square', 'right', 'direction', 'play'],
        shortName: 'arrow_forward'
      },
      {
        name: 'Black Right-Pointing Double Triangle',
        unified: '23E9',
        keywords: ['blue-square', 'play', 'speed', 'continue'],
        shortName: 'fast_forward'
      },
      {
        name: 'Black Right Pointing Double Triangle with Vertical Bar',
        unified: '23ED-FE0F',
        shortName: 'black_right_pointing_double_triangle_with_vertical_bar'
      },
      {
        name: 'Black Right Pointing Triangle with Double Vertical Bar',
        unified: '23EF-FE0F',
        shortName: 'black_right_pointing_triangle_with_double_vertical_bar'
      },
      {
        name: 'Black Left-Pointing Triangle',
        unified: '25C0-FE0F',
        keywords: ['blue-square', 'left', 'direction'],
        shortName: 'arrow_backward'
      },
      {
        name: 'Black Left-Pointing Double Triangle',
        unified: '23EA',
        keywords: ['play', 'blue-square'],
        shortName: 'rewind'
      },
      {
        name: 'Black Left Pointing Double Triangle with Vertical Bar',
        unified: '23EE-FE0F',
        shortName: 'black_left_pointing_double_triangle_with_vertical_bar'
      },
      {
        name: 'Up-Pointing Small Red Triangle',
        unified: '1F53C',
        keywords: ['blue-square', 'triangle', 'direction', 'point', 'forward', 'top'],
        shortName: 'arrow_up_small'
      },
      {
        name: 'Black Up-Pointing Double Triangle',
        unified: '23EB',
        keywords: ['blue-square', 'direction', 'top'],
        shortName: 'arrow_double_up'
      },
      {
        name: 'Down-Pointing Small Red Triangle',
        unified: '1F53D',
        keywords: ['blue-square', 'direction', 'bottom'],
        shortName: 'arrow_down_small'
      },
      {
        name: 'Black Down-Pointing Double Triangle',
        unified: '23EC',
        keywords: ['blue-square', 'direction', 'bottom'],
        shortName: 'arrow_double_down'
      },
      {
        name: 'Double Vertical Bar',
        unified: '23F8-FE0F',
        shortName: 'double_vertical_bar'
      },
      {
        name: 'Black Square for Stop',
        unified: '23F9-FE0F',
        shortName: 'black_square_for_stop'
      },
      {
        name: 'Black Circle for Record',
        unified: '23FA-FE0F',
        shortName: 'black_circle_for_record'
      },
      {
        name: 'Eject',
        unified: '23CF-FE0F',
        shortName: 'eject'
      },
      {
        name: 'Cinema',
        unified: '1F3A6',
        keywords: ['blue-square', 'record', 'film', 'movie', 'curtain', 'stage', 'theater'],
        shortName: 'cinema'
      },
      {
        name: 'Low Brightness Symbol',
        unified: '1F505',
        keywords: ['sun', 'afternoon', 'warm', 'summer'],
        shortName: 'low_brightness'
      },
      {
        name: 'High Brightness Symbol',
        unified: '1F506',
        keywords: ['sun', 'light'],
        shortName: 'high_brightness'
      },
      {
        name: 'Antenna with Bars',
        unified: '1F4F6',
        keywords: ['blue-square', 'reception', 'phone', 'internet', 'connection', 'wifi', 'bluetooth', 'bars'],
        shortName: 'signal_strength'
      },
      {
        name: 'Vibration Mode',
        unified: '1F4F3',
        keywords: ['orange-square', 'phone'],
        shortName: 'vibration_mode'
      },
      {
        name: 'Mobile Phone off',
        unified: '1F4F4',
        keywords: ['mute', 'orange-square', 'silence', 'quiet'],
        shortName: 'mobile_phone_off'
      },
      {
        name: 'Female Sign',
        unified: '2640-FE0F',
        shortName: 'female_sign'
      },
      {
        name: 'Male Sign',
        unified: '2642-FE0F',
        shortName: 'male_sign'
      },
      {
        name: 'Medical Symbol',
        unified: '2695-FE0F',
        shortNames: ['medical_symbol', 'staff_of_aesculapius'],
        shortName: 'medical_symbol'
      },
      {
        name: 'Infinity',
        unified: '267E-FE0F',
        keywords: ['forever'],
        shortName: 'infinity'
      },
      {
        name: 'Black Universal Recycling Symbol',
        unified: '267B-FE0F',
        keywords: ['arrow', 'environment', 'garbage', 'trash'],
        shortName: 'recycle'
      },
      {
        name: 'Fleur De Lis',
        unified: '269C-FE0F',
        keywords: ['decorative', 'scout'],
        shortName: 'fleur_de_lis'
      },
      {
        name: 'Trident Emblem',
        unified: '1F531',
        keywords: ['weapon', 'spear'],
        shortName: 'trident'
      },
      {
        name: 'Name Badge',
        unified: '1F4DB',
        keywords: ['fire', 'forbid'],
        shortName: 'name_badge'
      },
      {
        name: 'Japanese Symbol for Beginner',
        unified: '1F530',
        keywords: ['badge', 'shield'],
        shortName: 'beginner'
      },
      {
        name: 'Heavy Large Circle',
        unified: '2B55',
        keywords: ['circle', 'round'],
        shortName: 'o'
      },
      {
        name: 'White Heavy Check Mark',
        unified: '2705',
        keywords: ['green-square', 'ok', 'agree', 'vote', 'election', 'answer', 'tick'],
        shortName: 'white_check_mark'
      },
      {
        name: 'Ballot Box with Check',
        unified: '2611-FE0F',
        keywords: ['ok', 'agree', 'confirm', 'black-square', 'vote', 'election', 'yes', 'tick'],
        shortName: 'ballot_box_with_check'
      },
      {
        name: 'Heavy Check Mark',
        unified: '2714-FE0F',
        keywords: ['ok', 'nike', 'answer', 'yes', 'tick'],
        shortName: 'heavy_check_mark'
      },
      {
        name: 'Heavy Multiplication X',
        unified: '2716-FE0F',
        keywords: ['math', 'calculation'],
        shortName: 'heavy_multiplication_x'
      },
      {
        name: 'Cross Mark',
        unified: '274C',
        keywords: ['no', 'delete', 'remove', 'cancel', 'red'],
        shortName: 'x'
      },
      {
        name: 'Negative Squared Cross Mark',
        unified: '274E',
        keywords: ['x', 'green-square', 'no', 'deny'],
        shortName: 'negative_squared_cross_mark'
      },
      {
        name: 'Heavy Plus Sign',
        unified: '2795',
        keywords: ['math', 'calculation', 'addition', 'more', 'increase'],
        shortName: 'heavy_plus_sign'
      },
      {
        name: 'Heavy Minus Sign',
        unified: '2796',
        keywords: ['math', 'calculation', 'subtract', 'less'],
        shortName: 'heavy_minus_sign'
      },
      {
        name: 'Heavy Division Sign',
        unified: '2797',
        keywords: ['divide', 'math', 'calculation'],
        shortName: 'heavy_division_sign'
      },
      {
        name: 'Curly Loop',
        unified: '27B0',
        keywords: ['scribble', 'draw', 'shape', 'squiggle'],
        shortName: 'curly_loop'
      },
      {
        name: 'Double Curly Loop',
        unified: '27BF',
        keywords: ['tape', 'cassette'],
        shortName: 'loop'
      },
      {
        name: 'Part Alternation Mark',
        unified: '303D-FE0F',
        keywords: ['graph', 'presentation', 'stats', 'business', 'economics', 'bad'],
        shortName: 'part_alternation_mark'
      },
      {
        name: 'Eight Spoked Asterisk',
        unified: '2733-FE0F',
        keywords: ['star', 'sparkle', 'green-square'],
        shortName: 'eight_spoked_asterisk'
      },
      {
        name: 'Eight Pointed Black Star',
        unified: '2734-FE0F',
        keywords: ['orange-square', 'shape', 'polygon'],
        shortName: 'eight_pointed_black_star'
      },
      {
        name: 'Sparkle',
        unified: '2747-FE0F',
        keywords: ['stars', 'green-square', 'awesome', 'good', 'fireworks'],
        shortName: 'sparkle'
      },
      {
        name: 'Black Question Mark Ornament',
        unified: '2753',
        keywords: ['doubt', 'confused'],
        shortName: 'question'
      },
      {
        name: 'White Question Mark Ornament',
        unified: '2754',
        keywords: ['doubts', 'gray', 'huh', 'confused'],
        shortName: 'grey_question'
      },
      {
        name: 'White Exclamation Mark Ornament',
        unified: '2755',
        keywords: ['surprise', 'punctuation', 'gray', 'wow', 'warning'],
        shortName: 'grey_exclamation'
      },
      {
        name: 'Heavy Exclamation Mark Symbol',
        unified: '2757',
        keywords: ['heavy_exclamation_mark', 'danger', 'surprise', 'punctuation', 'wow', 'warning'],
        shortNames: ['exclamation', 'heavy_exclamation_mark'],
        shortName: 'exclamation'
      },
      {
        name: 'Wavy Dash',
        unified: '3030-FE0F',
        keywords: ['draw', 'line', 'moustache', 'mustache', 'squiggle', 'scribble'],
        shortName: 'wavy_dash'
      },
      {
        name: 'Copyright Sign',
        unified: '00A9-FE0F',
        keywords: ['ip', 'license', 'circle', 'law', 'legal'],
        shortName: 'copyright'
      },
      {
        name: 'Registered Sign',
        unified: '00AE-FE0F',
        keywords: ['alphabet', 'circle'],
        shortName: 'registered'
      },
      {
        name: 'Trade Mark Sign',
        unified: '2122-FE0F',
        keywords: ['trademark', 'brand', 'law', 'legal'],
        shortName: 'tm'
      },
      {
        name: 'Hash Key',
        unified: '0023-FE0F-20E3',
        keywords: ['symbol', 'blue-square', 'twitter'],
        shortName: 'hash'
      },
      {
        name: 'Keycap Star',
        unified: '002A-FE0F-20E3',
        shortName: 'keycap_star'
      },
      {
        name: 'Keycap 0',
        unified: '0030-FE0F-20E3',
        keywords: ['0', 'numbers', 'blue-square', 'null'],
        shortName: 'zero'
      },
      {
        name: 'Keycap 1',
        unified: '0031-FE0F-20E3',
        keywords: ['blue-square', 'numbers', '1'],
        shortName: 'one'
      },
      {
        name: 'Keycap 2',
        unified: '0032-FE0F-20E3',
        keywords: ['numbers', '2', 'prime', 'blue-square'],
        shortName: 'two'
      },
      {
        name: 'Keycap 3',
        unified: '0033-FE0F-20E3',
        keywords: ['3', 'numbers', 'prime', 'blue-square'],
        shortName: 'three'
      },
      {
        name: 'Keycap 4',
        unified: '0034-FE0F-20E3',
        keywords: ['4', 'numbers', 'blue-square'],
        shortName: 'four'
      },
      {
        name: 'Keycap 5',
        unified: '0035-FE0F-20E3',
        keywords: ['5', 'numbers', 'blue-square', 'prime'],
        shortName: 'five'
      },
      {
        name: 'Keycap 6',
        unified: '0036-FE0F-20E3',
        keywords: ['6', 'numbers', 'blue-square'],
        shortName: 'six'
      },
      {
        name: 'Keycap 7',
        unified: '0037-FE0F-20E3',
        keywords: ['7', 'numbers', 'blue-square', 'prime'],
        shortName: 'seven'
      },
      {
        name: 'Keycap 8',
        unified: '0038-FE0F-20E3',
        keywords: ['8', 'blue-square', 'numbers'],
        shortName: 'eight'
      },
      {
        name: 'Keycap 9',
        unified: '0039-FE0F-20E3',
        keywords: ['blue-square', 'numbers', '9'],
        shortName: 'nine'
      },
      {
        name: 'Keycap Ten',
        unified: '1F51F',
        keywords: ['numbers', '10', 'blue-square'],
        shortName: 'keycap_ten'
      },
      {
        name: 'Input Symbol for Latin Capital Letters',
        unified: '1F520',
        keywords: ['alphabet', 'words', 'blue-square'],
        shortName: 'capital_abcd'
      },
      {
        name: 'Input Symbol for Latin Small Letters',
        unified: '1F521',
        keywords: ['blue-square', 'alphabet'],
        shortName: 'abcd'
      },
      {
        name: 'Input Symbol for Numbers',
        unified: '1F522',
        keywords: ['numbers', 'blue-square'],
        shortName: '1234'
      },
      {
        name: 'Input Symbol for Symbols',
        unified: '1F523',
        keywords: ['blue-square', 'music', 'note', 'ampersand', 'percent', 'glyphs', 'characters'],
        shortName: 'symbols'
      },
      {
        name: 'Input Symbol for Latin Letters',
        unified: '1F524',
        keywords: ['blue-square', 'alphabet'],
        shortName: 'abc'
      },
      {
        name: 'Negative Squared Latin Capital Letter a',
        unified: '1F170-FE0F',
        keywords: ['red-square', 'alphabet', 'letter'],
        shortName: 'a'
      },
      {
        name: 'Negative Squared Ab',
        unified: '1F18E',
        keywords: ['red-square', 'alphabet'],
        shortName: 'ab'
      },
      {
        name: 'Negative Squared Latin Capital Letter B',
        unified: '1F171-FE0F',
        keywords: ['red-square', 'alphabet', 'letter'],
        shortName: 'b'
      },
      {
        name: 'Squared Cl',
        unified: '1F191',
        keywords: ['alphabet', 'words', 'red-square'],
        shortName: 'cl'
      },
      {
        name: 'Squared Cool',
        unified: '1F192',
        keywords: ['words', 'blue-square'],
        shortName: 'cool'
      },
      {
        name: 'Squared Free',
        unified: '1F193',
        keywords: ['blue-square', 'words'],
        shortName: 'free'
      },
      {
        name: 'Information Source',
        unified: '2139-FE0F',
        keywords: ['blue-square', 'alphabet', 'letter'],
        shortName: 'information_source'
      },
      {
        name: 'Squared Id',
        unified: '1F194',
        keywords: ['purple-square', 'words'],
        shortName: 'id'
      },
      {
        name: 'Circled Latin Capital Letter M',
        unified: '24C2-FE0F',
        keywords: ['alphabet', 'blue-circle', 'letter'],
        shortName: 'm'
      },
      {
        name: 'Squared New',
        unified: '1F195',
        keywords: ['blue-square', 'words', 'start'],
        shortName: 'new'
      },
      {
        name: 'Squared Ng',
        unified: '1F196',
        keywords: ['blue-square', 'words', 'shape', 'icon'],
        shortName: 'ng'
      },
      {
        name: 'Negative Squared Latin Capital Letter O',
        unified: '1F17E-FE0F',
        keywords: ['alphabet', 'red-square', 'letter'],
        shortName: 'o2'
      },
      {
        name: 'Squared Ok',
        unified: '1F197',
        keywords: ['good', 'agree', 'yes', 'blue-square'],
        shortName: 'ok'
      },
      {
        name: 'Negative Squared Latin Capital Letter P',
        unified: '1F17F-FE0F',
        keywords: ['cars', 'blue-square', 'alphabet', 'letter'],
        shortName: 'parking'
      },
      {
        name: 'Squared Sos',
        unified: '1F198',
        keywords: ['help', 'red-square', 'words', 'emergency', '911'],
        shortName: 'sos'
      },
      {
        name: 'Squared Up with Exclamation Mark',
        unified: '1F199',
        keywords: ['blue-square', 'above', 'high'],
        shortName: 'up'
      },
      {
        name: 'Squared Vs',
        unified: '1F19A',
        keywords: ['words', 'orange-square'],
        shortName: 'vs'
      },
      {
        name: 'Squared Katakana Koko',
        unified: '1F201',
        keywords: ['blue-square', 'here', 'katakana', 'japanese', 'destination'],
        shortName: 'koko'
      },
      {
        name: 'Squared Katakana Sa',
        unified: '1F202-FE0F',
        keywords: ['japanese', 'blue-square', 'katakana'],
        shortName: 'sa'
      },
      {
        name: 'Squared Cjk Unified Ideograph-6708',
        unified: '1F237-FE0F',
        keywords: ['chinese', 'month', 'moon', 'japanese', 'orange-square', 'kanji'],
        shortName: 'u6708'
      },
      {
        name: 'Squared Cjk Unified Ideograph-6709',
        unified: '1F236',
        keywords: ['orange-square', 'chinese', 'have', 'kanji'],
        shortName: 'u6709'
      },
      {
        name: 'Squared Cjk Unified Ideograph-6307',
        unified: '1F22F',
        keywords: ['chinese', 'point', 'green-square', 'kanji'],
        shortName: 'u6307'
      },
      {
        name: 'Circled Ideograph Advantage',
        unified: '1F250',
        keywords: ['chinese', 'kanji', 'obtain', 'get', 'circle'],
        shortName: 'ideograph_advantage'
      },
      {
        name: 'Squared Cjk Unified Ideograph-5272',
        unified: '1F239',
        keywords: ['cut', 'divide', 'chinese', 'kanji', 'pink-square'],
        shortName: 'u5272'
      },
      {
        name: 'Squared Cjk Unified Ideograph-7121',
        unified: '1F21A',
        keywords: ['nothing', 'chinese', 'kanji', 'japanese', 'orange-square'],
        shortName: 'u7121'
      },
      {
        name: 'Squared Cjk Unified Ideograph-7981',
        unified: '1F232',
        keywords: ['kanji', 'japanese', 'chinese', 'forbidden', 'limit', 'restricted', 'red-square'],
        shortName: 'u7981'
      },
      {
        name: 'Circled Ideograph Accept',
        unified: '1F251',
        keywords: ['ok', 'good', 'chinese', 'kanji', 'agree', 'yes', 'orange-circle'],
        shortName: 'accept'
      },
      {
        name: 'Squared Cjk Unified Ideograph-7533',
        unified: '1F238',
        keywords: ['chinese', 'japanese', 'kanji', 'orange-square'],
        shortName: 'u7533'
      },
      {
        name: 'Squared Cjk Unified Ideograph-5408',
        unified: '1F234',
        keywords: ['japanese', 'chinese', 'join', 'kanji', 'red-square'],
        shortName: 'u5408'
      },
      {
        name: 'Squared Cjk Unified Ideograph-7a7a',
        unified: '1F233',
        keywords: ['kanji', 'japanese', 'chinese', 'empty', 'sky', 'blue-square'],
        shortName: 'u7a7a'
      },
      {
        name: 'Circled Ideograph Congratulation',
        unified: '3297-FE0F',
        keywords: ['chinese', 'kanji', 'japanese', 'red-circle'],
        shortName: 'congratulations'
      },
      {
        name: 'Circled Ideograph Secret',
        unified: '3299-FE0F',
        keywords: ['privacy', 'chinese', 'sshh', 'kanji', 'red-circle'],
        shortName: 'secret'
      },
      {
        name: 'Squared Cjk Unified Ideograph-55b6',
        unified: '1F23A',
        keywords: ['japanese', 'opening hours', 'orange-square'],
        shortName: 'u55b6'
      },
      {
        name: 'Squared Cjk Unified Ideograph-6e80',
        unified: '1F235',
        keywords: ['full', 'chinese', 'japanese', 'red-square', 'kanji'],
        shortName: 'u6e80'
      },
      {
        name: 'Large Red Circle',
        unified: '1F534',
        keywords: ['shape', 'error', 'danger'],
        shortName: 'red_circle'
      },
      {
        name: 'Large Orange Circle',
        unified: '1F7E0',
        shortName: 'large_orange_circle'
      },
      {
        name: 'Large Yellow Circle',
        unified: '1F7E1',
        shortName: 'large_yellow_circle'
      },
      {
        name: 'Large Green Circle',
        unified: '1F7E2',
        shortName: 'large_green_circle'
      },
      {
        name: 'Large Blue Circle',
        unified: '1F535',
        keywords: ['shape', 'icon', 'button'],
        shortName: 'large_blue_circle'
      },
      {
        name: 'Large Purple Circle',
        unified: '1F7E3',
        shortName: 'large_purple_circle'
      },
      {
        name: 'Large Brown Circle',
        unified: '1F7E4',
        shortName: 'large_brown_circle'
      },
      {
        name: 'Medium Black Circle',
        unified: '26AB',
        keywords: ['shape', 'button', 'round'],
        shortName: 'black_circle'
      },
      {
        name: 'Medium White Circle',
        unified: '26AA',
        keywords: ['shape', 'round'],
        shortName: 'white_circle'
      },
      {
        name: 'Large Red Square',
        unified: '1F7E5',
        shortName: 'large_red_square'
      },
      {
        name: 'Large Orange Square',
        unified: '1F7E7',
        shortName: 'large_orange_square'
      },
      {
        name: 'Large Yellow Square',
        unified: '1F7E8',
        shortName: 'large_yellow_square'
      },
      {
        name: 'Large Green Square',
        unified: '1F7E9',
        shortName: 'large_green_square'
      },
      {
        name: 'Large Blue Square',
        unified: '1F7E6',
        shortName: 'large_blue_square'
      },
      {
        name: 'Large Purple Square',
        unified: '1F7EA',
        shortName: 'large_purple_square'
      },
      {
        name: 'Large Brown Square',
        unified: '1F7EB',
        shortName: 'large_brown_square'
      },
      {
        name: 'Black Large Square',
        unified: '2B1B',
        keywords: ['shape', 'icon', 'button'],
        shortName: 'black_large_square'
      },
      {
        name: 'White Large Square',
        unified: '2B1C',
        keywords: ['shape', 'icon', 'stone', 'button'],
        shortName: 'white_large_square'
      },
      {
        name: 'Black Medium Square',
        unified: '25FC-FE0F',
        keywords: ['shape', 'button', 'icon'],
        shortName: 'black_medium_square'
      },
      {
        name: 'White Medium Square',
        unified: '25FB-FE0F',
        keywords: ['shape', 'stone', 'icon'],
        shortName: 'white_medium_square'
      },
      {
        name: 'Black Medium Small Square',
        unified: '25FE',
        keywords: ['icon', 'shape', 'button'],
        shortName: 'black_medium_small_square'
      },
      {
        name: 'White Medium Small Square',
        unified: '25FD',
        keywords: ['shape', 'stone', 'icon', 'button'],
        shortName: 'white_medium_small_square'
      },
      {
        name: 'Black Small Square',
        unified: '25AA-FE0F',
        keywords: ['shape', 'icon'],
        shortName: 'black_small_square'
      },
      {
        name: 'White Small Square',
        unified: '25AB-FE0F',
        keywords: ['shape', 'icon'],
        shortName: 'white_small_square'
      },
      {
        name: 'Large Orange Diamond',
        unified: '1F536',
        keywords: ['shape', 'jewel', 'gem'],
        shortName: 'large_orange_diamond'
      },
      {
        name: 'Large Blue Diamond',
        unified: '1F537',
        keywords: ['shape', 'jewel', 'gem'],
        shortName: 'large_blue_diamond'
      },
      {
        name: 'Small Orange Diamond',
        unified: '1F538',
        keywords: ['shape', 'jewel', 'gem'],
        shortName: 'small_orange_diamond'
      },
      {
        name: 'Small Blue Diamond',
        unified: '1F539',
        keywords: ['shape', 'jewel', 'gem'],
        shortName: 'small_blue_diamond'
      },
      {
        name: 'Up-Pointing Red Triangle',
        unified: '1F53A',
        keywords: ['shape', 'direction', 'up', 'top'],
        shortName: 'small_red_triangle'
      },
      {
        name: 'Down-Pointing Red Triangle',
        unified: '1F53B',
        keywords: ['shape', 'direction', 'bottom'],
        shortName: 'small_red_triangle_down'
      },
      {
        name: 'Diamond Shape with a Dot Inside',
        unified: '1F4A0',
        keywords: ['jewel', 'blue', 'gem', 'crystal', 'fancy'],
        shortName: 'diamond_shape_with_a_dot_inside'
      },
      {
        name: 'Radio Button',
        unified: '1F518',
        keywords: ['input', 'old', 'music', 'circle'],
        shortName: 'radio_button'
      },
      {
        name: 'White Square Button',
        unified: '1F533',
        keywords: ['shape', 'input'],
        shortName: 'white_square_button'
      },
      {
        name: 'Black Square Button',
        unified: '1F532',
        keywords: ['shape', 'input', 'frame'],
        shortName: 'black_square_button'
      }
    ]
  },
  {
    id: 'flags',
    name: 'Flags',
    emojis: [
      {
        name: 'Ascension Island Flag',
        unified: '1F1E6-1F1E8',
        shortName: 'flag-ac'
      },
      {
        name: 'Andorra Flag',
        unified: '1F1E6-1F1E9',
        shortName: 'flag-ad'
      },
      {
        name: 'United Arab Emirates Flag',
        unified: '1F1E6-1F1EA',
        shortName: 'flag-ae'
      },
      {
        name: 'Afghanistan Flag',
        unified: '1F1E6-1F1EB',
        shortName: 'flag-af'
      },
      {
        name: 'Antigua & Barbuda Flag',
        unified: '1F1E6-1F1EC',
        shortName: 'flag-ag'
      },
      {
        name: 'Anguilla Flag',
        unified: '1F1E6-1F1EE',
        shortName: 'flag-ai'
      },
      {
        name: 'Albania Flag',
        unified: '1F1E6-1F1F1',
        shortName: 'flag-al'
      },
      {
        name: 'Armenia Flag',
        unified: '1F1E6-1F1F2',
        shortName: 'flag-am'
      },
      {
        name: 'Angola Flag',
        unified: '1F1E6-1F1F4',
        shortName: 'flag-ao'
      },
      {
        name: 'Antarctica Flag',
        unified: '1F1E6-1F1F6',
        shortName: 'flag-aq'
      },
      {
        name: 'Argentina Flag',
        unified: '1F1E6-1F1F7',
        shortName: 'flag-ar'
      },
      {
        name: 'American Samoa Flag',
        unified: '1F1E6-1F1F8',
        shortName: 'flag-as'
      },
      {
        name: 'Austria Flag',
        unified: '1F1E6-1F1F9',
        shortName: 'flag-at'
      },
      {
        name: 'Australia Flag',
        unified: '1F1E6-1F1FA',
        shortName: 'flag-au'
      },
      {
        name: 'Aruba Flag',
        unified: '1F1E6-1F1FC',
        shortName: 'flag-aw'
      },
      {
        name: 'Åland Islands Flag',
        unified: '1F1E6-1F1FD',
        shortName: 'flag-ax'
      },
      {
        name: 'Azerbaijan Flag',
        unified: '1F1E6-1F1FF',
        shortName: 'flag-az'
      },
      {
        name: 'Bosnia & Herzegovina Flag',
        unified: '1F1E7-1F1E6',
        shortName: 'flag-ba'
      },
      {
        name: 'Barbados Flag',
        unified: '1F1E7-1F1E7',
        shortName: 'flag-bb'
      },
      {
        name: 'Bangladesh Flag',
        unified: '1F1E7-1F1E9',
        shortName: 'flag-bd'
      },
      {
        name: 'Belgium Flag',
        unified: '1F1E7-1F1EA',
        shortName: 'flag-be'
      },
      {
        name: 'Burkina Faso Flag',
        unified: '1F1E7-1F1EB',
        shortName: 'flag-bf'
      },
      {
        name: 'Bulgaria Flag',
        unified: '1F1E7-1F1EC',
        shortName: 'flag-bg'
      },
      {
        name: 'Bahrain Flag',
        unified: '1F1E7-1F1ED',
        shortName: 'flag-bh'
      },
      {
        name: 'Burundi Flag',
        unified: '1F1E7-1F1EE',
        shortName: 'flag-bi'
      },
      {
        name: 'Benin Flag',
        unified: '1F1E7-1F1EF',
        shortName: 'flag-bj'
      },
      {
        name: 'St. Barthélemy Flag',
        unified: '1F1E7-1F1F1',
        shortName: 'flag-bl'
      },
      {
        name: 'Bermuda Flag',
        unified: '1F1E7-1F1F2',
        shortName: 'flag-bm'
      },
      {
        name: 'Brunei Flag',
        unified: '1F1E7-1F1F3',
        shortName: 'flag-bn'
      },
      {
        name: 'Bolivia Flag',
        unified: '1F1E7-1F1F4',
        shortName: 'flag-bo'
      },
      {
        name: 'Caribbean Netherlands Flag',
        unified: '1F1E7-1F1F6',
        shortName: 'flag-bq'
      },
      {
        name: 'Brazil Flag',
        unified: '1F1E7-1F1F7',
        shortName: 'flag-br'
      },
      {
        name: 'Bahamas Flag',
        unified: '1F1E7-1F1F8',
        shortName: 'flag-bs'
      },
      {
        name: 'Bhutan Flag',
        unified: '1F1E7-1F1F9',
        shortName: 'flag-bt'
      },
      {
        name: 'Bouvet Island Flag',
        unified: '1F1E7-1F1FB',
        shortName: 'flag-bv'
      },
      {
        name: 'Botswana Flag',
        unified: '1F1E7-1F1FC',
        shortName: 'flag-bw'
      },
      {
        name: 'Belarus Flag',
        unified: '1F1E7-1F1FE',
        shortName: 'flag-by'
      },
      {
        name: 'Belize Flag',
        unified: '1F1E7-1F1FF',
        shortName: 'flag-bz'
      },
      {
        name: 'Canada Flag',
        unified: '1F1E8-1F1E6',
        shortName: 'flag-ca'
      },
      {
        name: 'Cocos (keeling) Islands Flag',
        unified: '1F1E8-1F1E8',
        shortName: 'flag-cc'
      },
      {
        name: 'Congo - Kinshasa Flag',
        unified: '1F1E8-1F1E9',
        shortName: 'flag-cd'
      },
      {
        name: 'Central African Republic Flag',
        unified: '1F1E8-1F1EB',
        shortName: 'flag-cf'
      },
      {
        name: 'Congo - Brazzaville Flag',
        unified: '1F1E8-1F1EC',
        shortName: 'flag-cg'
      },
      {
        name: 'Switzerland Flag',
        unified: '1F1E8-1F1ED',
        shortName: 'flag-ch'
      },
      {
        name: 'Côte D’ivoire Flag',
        unified: '1F1E8-1F1EE',
        shortName: 'flag-ci'
      },
      {
        name: 'Cook Islands Flag',
        unified: '1F1E8-1F1F0',
        shortName: 'flag-ck'
      },
      {
        name: 'Chile Flag',
        unified: '1F1E8-1F1F1',
        shortName: 'flag-cl'
      },
      {
        name: 'Cameroon Flag',
        unified: '1F1E8-1F1F2',
        shortName: 'flag-cm'
      },
      {
        name: 'China Flag',
        unified: '1F1E8-1F1F3',
        keywords: ['china', 'chinese', 'prc', 'flag', 'country', 'nation', 'banner'],
        shortNames: ['cn', 'flag-cn'],
        shortName: 'cn'
      },
      {
        name: 'Colombia Flag',
        unified: '1F1E8-1F1F4',
        shortName: 'flag-co'
      },
      {
        name: 'Clipperton Island Flag',
        unified: '1F1E8-1F1F5',
        shortName: 'flag-cp'
      },
      {
        name: 'Costa Rica Flag',
        unified: '1F1E8-1F1F7',
        shortName: 'flag-cr'
      },
      {
        name: 'Cuba Flag',
        unified: '1F1E8-1F1FA',
        shortName: 'flag-cu'
      },
      {
        name: 'Cape Verde Flag',
        unified: '1F1E8-1F1FB',
        shortName: 'flag-cv'
      },
      {
        name: 'Curaçao Flag',
        unified: '1F1E8-1F1FC',
        shortName: 'flag-cw'
      },
      {
        name: 'Christmas Island Flag',
        unified: '1F1E8-1F1FD',
        shortName: 'flag-cx'
      },
      {
        name: 'Cyprus Flag',
        unified: '1F1E8-1F1FE',
        shortName: 'flag-cy'
      },
      {
        name: 'Czechia Flag',
        unified: '1F1E8-1F1FF',
        shortName: 'flag-cz'
      },
      {
        name: 'Germany Flag',
        unified: '1F1E9-1F1EA',
        keywords: ['german', 'nation', 'flag', 'country', 'banner'],
        shortNames: ['de', 'flag-de'],
        shortName: 'de'
      },
      {
        name: 'Diego Garcia Flag',
        unified: '1F1E9-1F1EC',
        shortName: 'flag-dg'
      },
      {
        name: 'Djibouti Flag',
        unified: '1F1E9-1F1EF',
        shortName: 'flag-dj'
      },
      {
        name: 'Denmark Flag',
        unified: '1F1E9-1F1F0',
        shortName: 'flag-dk'
      },
      {
        name: 'Dominica Flag',
        unified: '1F1E9-1F1F2',
        shortName: 'flag-dm'
      },
      {
        name: 'Dominican Republic Flag',
        unified: '1F1E9-1F1F4',
        shortName: 'flag-do'
      },
      {
        name: 'Algeria Flag',
        unified: '1F1E9-1F1FF',
        shortName: 'flag-dz'
      },
      {
        name: 'Ceuta & Melilla Flag',
        unified: '1F1EA-1F1E6',
        shortName: 'flag-ea'
      },
      {
        name: 'Ecuador Flag',
        unified: '1F1EA-1F1E8',
        shortName: 'flag-ec'
      },
      {
        name: 'Estonia Flag',
        unified: '1F1EA-1F1EA',
        shortName: 'flag-ee'
      },
      {
        name: 'Egypt Flag',
        unified: '1F1EA-1F1EC',
        shortName: 'flag-eg'
      },
      {
        name: 'Western Sahara Flag',
        unified: '1F1EA-1F1ED',
        shortName: 'flag-eh'
      },
      {
        name: 'Eritrea Flag',
        unified: '1F1EA-1F1F7',
        shortName: 'flag-er'
      },
      {
        name: 'Spain Flag',
        unified: '1F1EA-1F1F8',
        keywords: ['spain', 'flag', 'nation', 'country', 'banner'],
        shortNames: ['es', 'flag-es'],
        shortName: 'es'
      },
      {
        name: 'Ethiopia Flag',
        unified: '1F1EA-1F1F9',
        shortName: 'flag-et'
      },
      {
        name: 'European Union Flag',
        unified: '1F1EA-1F1FA',
        shortName: 'flag-eu'
      },
      {
        name: 'Finland Flag',
        unified: '1F1EB-1F1EE',
        shortName: 'flag-fi'
      },
      {
        name: 'Fiji Flag',
        unified: '1F1EB-1F1EF',
        shortName: 'flag-fj'
      },
      {
        name: 'Falkland Islands Flag',
        unified: '1F1EB-1F1F0',
        shortName: 'flag-fk'
      },
      {
        name: 'Micronesia Flag',
        unified: '1F1EB-1F1F2',
        shortName: 'flag-fm'
      },
      {
        name: 'Faroe Islands Flag',
        unified: '1F1EB-1F1F4',
        shortName: 'flag-fo'
      },
      {
        name: 'France Flag',
        unified: '1F1EB-1F1F7',
        keywords: ['banner', 'flag', 'nation', 'france', 'french', 'country'],
        shortNames: ['fr', 'flag-fr'],
        shortName: 'fr'
      },
      {
        name: 'Gabon Flag',
        unified: '1F1EC-1F1E6',
        shortName: 'flag-ga'
      },
      {
        name: 'United Kingdom Flag',
        unified: '1F1EC-1F1E7',
        shortNames: ['gb', 'uk', 'flag-gb'],
        shortName: 'gb'
      },
      {
        name: 'Grenada Flag',
        unified: '1F1EC-1F1E9',
        shortName: 'flag-gd'
      },
      {
        name: 'Georgia Flag',
        unified: '1F1EC-1F1EA',
        shortName: 'flag-ge'
      },
      {
        name: 'French Guiana Flag',
        unified: '1F1EC-1F1EB',
        shortName: 'flag-gf'
      },
      {
        name: 'Guernsey Flag',
        unified: '1F1EC-1F1EC',
        shortName: 'flag-gg'
      },
      {
        name: 'Ghana Flag',
        unified: '1F1EC-1F1ED',
        shortName: 'flag-gh'
      },
      {
        name: 'Gibraltar Flag',
        unified: '1F1EC-1F1EE',
        shortName: 'flag-gi'
      },
      {
        name: 'Greenland Flag',
        unified: '1F1EC-1F1F1',
        shortName: 'flag-gl'
      },
      {
        name: 'Gambia Flag',
        unified: '1F1EC-1F1F2',
        shortName: 'flag-gm'
      },
      {
        name: 'Guinea Flag',
        unified: '1F1EC-1F1F3',
        shortName: 'flag-gn'
      },
      {
        name: 'Guadeloupe Flag',
        unified: '1F1EC-1F1F5',
        shortName: 'flag-gp'
      },
      {
        name: 'Equatorial Guinea Flag',
        unified: '1F1EC-1F1F6',
        shortName: 'flag-gq'
      },
      {
        name: 'Greece Flag',
        unified: '1F1EC-1F1F7',
        shortName: 'flag-gr'
      },
      {
        name: 'South Georgia & South Sandwich Islands Flag',
        unified: '1F1EC-1F1F8',
        shortName: 'flag-gs'
      },
      {
        name: 'Guatemala Flag',
        unified: '1F1EC-1F1F9',
        shortName: 'flag-gt'
      },
      {
        name: 'Guam Flag',
        unified: '1F1EC-1F1FA',
        shortName: 'flag-gu'
      },
      {
        name: 'Guinea-Bissau Flag',
        unified: '1F1EC-1F1FC',
        shortName: 'flag-gw'
      },
      {
        name: 'Guyana Flag',
        unified: '1F1EC-1F1FE',
        shortName: 'flag-gy'
      },
      {
        name: 'Hong Kong Sar China Flag',
        unified: '1F1ED-1F1F0',
        shortName: 'flag-hk'
      },
      {
        name: 'Heard & Mcdonald Islands Flag',
        unified: '1F1ED-1F1F2',
        shortName: 'flag-hm'
      },
      {
        name: 'Honduras Flag',
        unified: '1F1ED-1F1F3',
        shortName: 'flag-hn'
      },
      {
        name: 'Croatia Flag',
        unified: '1F1ED-1F1F7',
        shortName: 'flag-hr'
      },
      {
        name: 'Haiti Flag',
        unified: '1F1ED-1F1F9',
        shortName: 'flag-ht'
      },
      {
        name: 'Hungary Flag',
        unified: '1F1ED-1F1FA',
        shortName: 'flag-hu'
      },
      {
        name: 'Canary Islands Flag',
        unified: '1F1EE-1F1E8',
        shortName: 'flag-ic'
      },
      {
        name: 'Indonesia Flag',
        unified: '1F1EE-1F1E9',
        shortName: 'flag-id'
      },
      {
        name: 'Ireland Flag',
        unified: '1F1EE-1F1EA',
        shortName: 'flag-ie'
      },
      {
        name: 'Israel Flag',
        unified: '1F1EE-1F1F1',
        shortName: 'flag-il'
      },
      {
        name: 'Isle of Man Flag',
        unified: '1F1EE-1F1F2',
        shortName: 'flag-im'
      },
      {
        name: 'India Flag',
        unified: '1F1EE-1F1F3',
        shortName: 'flag-in'
      },
      {
        name: 'British Indian Ocean Territory Flag',
        unified: '1F1EE-1F1F4',
        shortName: 'flag-io'
      },
      {
        name: 'Iraq Flag',
        unified: '1F1EE-1F1F6',
        shortName: 'flag-iq'
      },
      {
        name: 'Iran Flag',
        unified: '1F1EE-1F1F7',
        shortName: 'flag-ir'
      },
      {
        name: 'Iceland Flag',
        unified: '1F1EE-1F1F8',
        shortName: 'flag-is'
      },
      {
        name: 'Italy Flag',
        unified: '1F1EE-1F1F9',
        keywords: ['italy', 'flag', 'nation', 'country', 'banner'],
        shortNames: ['it', 'flag-it'],
        shortName: 'it'
      },
      {
        name: 'Jersey Flag',
        unified: '1F1EF-1F1EA',
        shortName: 'flag-je'
      },
      {
        name: 'Jamaica Flag',
        unified: '1F1EF-1F1F2',
        shortName: 'flag-jm'
      },
      {
        name: 'Jordan Flag',
        unified: '1F1EF-1F1F4',
        shortName: 'flag-jo'
      },
      {
        name: 'Japan Flag',
        unified: '1F1EF-1F1F5',
        keywords: ['japanese', 'nation', 'flag', 'country', 'banner'],
        shortNames: ['jp', 'flag-jp'],
        shortName: 'jp'
      },
      {
        name: 'Kenya Flag',
        unified: '1F1F0-1F1EA',
        shortName: 'flag-ke'
      },
      {
        name: 'Kyrgyzstan Flag',
        unified: '1F1F0-1F1EC',
        shortName: 'flag-kg'
      },
      {
        name: 'Cambodia Flag',
        unified: '1F1F0-1F1ED',
        shortName: 'flag-kh'
      },
      {
        name: 'Kiribati Flag',
        unified: '1F1F0-1F1EE',
        shortName: 'flag-ki'
      },
      {
        name: 'Comoros Flag',
        unified: '1F1F0-1F1F2',
        shortName: 'flag-km'
      },
      {
        name: 'St. Kitts & Nevis Flag',
        unified: '1F1F0-1F1F3',
        shortName: 'flag-kn'
      },
      {
        name: 'North Korea Flag',
        unified: '1F1F0-1F1F5',
        shortName: 'flag-kp'
      },
      {
        name: 'South Korea Flag',
        unified: '1F1F0-1F1F7',
        keywords: ['south', 'korea', 'nation', 'flag', 'country', 'banner'],
        shortNames: ['kr', 'flag-kr'],
        shortName: 'kr'
      },
      {
        name: 'Kuwait Flag',
        unified: '1F1F0-1F1FC',
        shortName: 'flag-kw'
      },
      {
        name: 'Cayman Islands Flag',
        unified: '1F1F0-1F1FE',
        shortName: 'flag-ky'
      },
      {
        name: 'Kazakhstan Flag',
        unified: '1F1F0-1F1FF',
        shortName: 'flag-kz'
      },
      {
        name: 'Laos Flag',
        unified: '1F1F1-1F1E6',
        shortName: 'flag-la'
      },
      {
        name: 'Lebanon Flag',
        unified: '1F1F1-1F1E7',
        shortName: 'flag-lb'
      },
      {
        name: 'St. Lucia Flag',
        unified: '1F1F1-1F1E8',
        shortName: 'flag-lc'
      },
      {
        name: 'Liechtenstein Flag',
        unified: '1F1F1-1F1EE',
        shortName: 'flag-li'
      },
      {
        name: 'Sri Lanka Flag',
        unified: '1F1F1-1F1F0',
        shortName: 'flag-lk'
      },
      {
        name: 'Liberia Flag',
        unified: '1F1F1-1F1F7',
        shortName: 'flag-lr'
      },
      {
        name: 'Lesotho Flag',
        unified: '1F1F1-1F1F8',
        shortName: 'flag-ls'
      },
      {
        name: 'Lithuania Flag',
        unified: '1F1F1-1F1F9',
        shortName: 'flag-lt'
      },
      {
        name: 'Luxembourg Flag',
        unified: '1F1F1-1F1FA',
        shortName: 'flag-lu'
      },
      {
        name: 'Latvia Flag',
        unified: '1F1F1-1F1FB',
        shortName: 'flag-lv'
      },
      {
        name: 'Libya Flag',
        unified: '1F1F1-1F1FE',
        shortName: 'flag-ly'
      },
      {
        name: 'Morocco Flag',
        unified: '1F1F2-1F1E6',
        shortName: 'flag-ma'
      },
      {
        name: 'Monaco Flag',
        unified: '1F1F2-1F1E8',
        shortName: 'flag-mc'
      },
      {
        name: 'Moldova Flag',
        unified: '1F1F2-1F1E9',
        shortName: 'flag-md'
      },
      {
        name: 'Montenegro Flag',
        unified: '1F1F2-1F1EA',
        shortName: 'flag-me'
      },
      {
        name: 'St. Martin Flag',
        unified: '1F1F2-1F1EB',
        shortName: 'flag-mf'
      },
      {
        name: 'Madagascar Flag',
        unified: '1F1F2-1F1EC',
        shortName: 'flag-mg'
      },
      {
        name: 'Marshall Islands Flag',
        unified: '1F1F2-1F1ED',
        shortName: 'flag-mh'
      },
      {
        name: 'North Macedonia Flag',
        unified: '1F1F2-1F1F0',
        shortName: 'flag-mk'
      },
      {
        name: 'Mali Flag',
        unified: '1F1F2-1F1F1',
        shortName: 'flag-ml'
      },
      {
        name: 'Myanmar (burma) Flag',
        unified: '1F1F2-1F1F2',
        shortName: 'flag-mm'
      },
      {
        name: 'Mongolia Flag',
        unified: '1F1F2-1F1F3',
        shortName: 'flag-mn'
      },
      {
        name: 'Macao Sar China Flag',
        unified: '1F1F2-1F1F4',
        shortName: 'flag-mo'
      },
      {
        name: 'Northern Mariana Islands Flag',
        unified: '1F1F2-1F1F5',
        shortName: 'flag-mp'
      },
      {
        name: 'Martinique Flag',
        unified: '1F1F2-1F1F6',
        shortName: 'flag-mq'
      },
      {
        name: 'Mauritania Flag',
        unified: '1F1F2-1F1F7',
        shortName: 'flag-mr'
      },
      {
        name: 'Montserrat Flag',
        unified: '1F1F2-1F1F8',
        shortName: 'flag-ms'
      },
      {
        name: 'Malta Flag',
        unified: '1F1F2-1F1F9',
        shortName: 'flag-mt'
      },
      {
        name: 'Mauritius Flag',
        unified: '1F1F2-1F1FA',
        shortName: 'flag-mu'
      },
      {
        name: 'Maldives Flag',
        unified: '1F1F2-1F1FB',
        shortName: 'flag-mv'
      },
      {
        name: 'Malawi Flag',
        unified: '1F1F2-1F1FC',
        shortName: 'flag-mw'
      },
      {
        name: 'Mexico Flag',
        unified: '1F1F2-1F1FD',
        shortName: 'flag-mx'
      },
      {
        name: 'Malaysia Flag',
        unified: '1F1F2-1F1FE',
        shortName: 'flag-my'
      },
      {
        name: 'Mozambique Flag',
        unified: '1F1F2-1F1FF',
        shortName: 'flag-mz'
      },
      {
        name: 'Namibia Flag',
        unified: '1F1F3-1F1E6',
        shortName: 'flag-na'
      },
      {
        name: 'New Caledonia Flag',
        unified: '1F1F3-1F1E8',
        shortName: 'flag-nc'
      },
      {
        name: 'Niger Flag',
        unified: '1F1F3-1F1EA',
        shortName: 'flag-ne'
      },
      {
        name: 'Norfolk Island Flag',
        unified: '1F1F3-1F1EB',
        shortName: 'flag-nf'
      },
      {
        name: 'Nigeria Flag',
        unified: '1F1F3-1F1EC',
        shortName: 'flag-ng'
      },
      {
        name: 'Nicaragua Flag',
        unified: '1F1F3-1F1EE',
        shortName: 'flag-ni'
      },
      {
        name: 'Netherlands Flag',
        unified: '1F1F3-1F1F1',
        shortName: 'flag-nl'
      },
      {
        name: 'Norway Flag',
        unified: '1F1F3-1F1F4',
        shortName: 'flag-no'
      },
      {
        name: 'Nepal Flag',
        unified: '1F1F3-1F1F5',
        shortName: 'flag-np'
      },
      {
        name: 'Nauru Flag',
        unified: '1F1F3-1F1F7',
        shortName: 'flag-nr'
      },
      {
        name: 'Niue Flag',
        unified: '1F1F3-1F1FA',
        shortName: 'flag-nu'
      },
      {
        name: 'New Zealand Flag',
        unified: '1F1F3-1F1FF',
        shortName: 'flag-nz'
      },
      {
        name: 'Oman Flag',
        unified: '1F1F4-1F1F2',
        shortName: 'flag-om'
      },
      {
        name: 'Panama Flag',
        unified: '1F1F5-1F1E6',
        shortName: 'flag-pa'
      },
      {
        name: 'Peru Flag',
        unified: '1F1F5-1F1EA',
        shortName: 'flag-pe'
      },
      {
        name: 'French Polynesia Flag',
        unified: '1F1F5-1F1EB',
        shortName: 'flag-pf'
      },
      {
        name: 'Papua New Guinea Flag',
        unified: '1F1F5-1F1EC',
        shortName: 'flag-pg'
      },
      {
        name: 'Philippines Flag',
        unified: '1F1F5-1F1ED',
        shortName: 'flag-ph'
      },
      {
        name: 'Pakistan Flag',
        unified: '1F1F5-1F1F0',
        shortName: 'flag-pk'
      },
      {
        name: 'Poland Flag',
        unified: '1F1F5-1F1F1',
        shortName: 'flag-pl'
      },
      {
        name: 'St. Pierre & Miquelon Flag',
        unified: '1F1F5-1F1F2',
        shortName: 'flag-pm'
      },
      {
        name: 'Pitcairn Islands Flag',
        unified: '1F1F5-1F1F3',
        shortName: 'flag-pn'
      },
      {
        name: 'Puerto Rico Flag',
        unified: '1F1F5-1F1F7',
        shortName: 'flag-pr'
      },
      {
        name: 'Palestinian Territories Flag',
        unified: '1F1F5-1F1F8',
        shortName: 'flag-ps'
      },
      {
        name: 'Portugal Flag',
        unified: '1F1F5-1F1F9',
        shortName: 'flag-pt'
      },
      {
        name: 'Palau Flag',
        unified: '1F1F5-1F1FC',
        shortName: 'flag-pw'
      },
      {
        name: 'Paraguay Flag',
        unified: '1F1F5-1F1FE',
        shortName: 'flag-py'
      },
      {
        name: 'Qatar Flag',
        unified: '1F1F6-1F1E6',
        shortName: 'flag-qa'
      },
      {
        name: 'Réunion Flag',
        unified: '1F1F7-1F1EA',
        shortName: 'flag-re'
      },
      {
        name: 'Romania Flag',
        unified: '1F1F7-1F1F4',
        shortName: 'flag-ro'
      },
      {
        name: 'Serbia Flag',
        unified: '1F1F7-1F1F8',
        shortName: 'flag-rs'
      },
      {
        name: 'Russia Flag',
        unified: '1F1F7-1F1FA',
        keywords: ['russian', 'federation', 'flag', 'nation', 'country', 'banner'],
        shortNames: ['ru', 'flag-ru'],
        shortName: 'ru'
      },
      {
        name: 'Rwanda Flag',
        unified: '1F1F7-1F1FC',
        shortName: 'flag-rw'
      },
      {
        name: 'Saudi Arabia Flag',
        unified: '1F1F8-1F1E6',
        shortName: 'flag-sa'
      },
      {
        name: 'Solomon Islands Flag',
        unified: '1F1F8-1F1E7',
        shortName: 'flag-sb'
      },
      {
        name: 'Seychelles Flag',
        unified: '1F1F8-1F1E8',
        shortName: 'flag-sc'
      },
      {
        name: 'Sudan Flag',
        unified: '1F1F8-1F1E9',
        shortName: 'flag-sd'
      },
      {
        name: 'Sweden Flag',
        unified: '1F1F8-1F1EA',
        shortName: 'flag-se'
      },
      {
        name: 'Singapore Flag',
        unified: '1F1F8-1F1EC',
        shortName: 'flag-sg'
      },
      {
        name: 'St. Helena Flag',
        unified: '1F1F8-1F1ED',
        shortName: 'flag-sh'
      },
      {
        name: 'Slovenia Flag',
        unified: '1F1F8-1F1EE',
        shortName: 'flag-si'
      },
      {
        name: 'Svalbard & Jan Mayen Flag',
        unified: '1F1F8-1F1EF',
        shortName: 'flag-sj'
      },
      {
        name: 'Slovakia Flag',
        unified: '1F1F8-1F1F0',
        shortName: 'flag-sk'
      },
      {
        name: 'Sierra Leone Flag',
        unified: '1F1F8-1F1F1',
        shortName: 'flag-sl'
      },
      {
        name: 'San Marino Flag',
        unified: '1F1F8-1F1F2',
        shortName: 'flag-sm'
      },
      {
        name: 'Senegal Flag',
        unified: '1F1F8-1F1F3',
        shortName: 'flag-sn'
      },
      {
        name: 'Somalia Flag',
        unified: '1F1F8-1F1F4',
        shortName: 'flag-so'
      },
      {
        name: 'Suriname Flag',
        unified: '1F1F8-1F1F7',
        shortName: 'flag-sr'
      },
      {
        name: 'South Sudan Flag',
        unified: '1F1F8-1F1F8',
        shortName: 'flag-ss'
      },
      {
        name: 'São Tomé & Príncipe Flag',
        unified: '1F1F8-1F1F9',
        shortName: 'flag-st'
      },
      {
        name: 'El Salvador Flag',
        unified: '1F1F8-1F1FB',
        shortName: 'flag-sv'
      },
      {
        name: 'Sint Maarten Flag',
        unified: '1F1F8-1F1FD',
        shortName: 'flag-sx'
      },
      {
        name: 'Syria Flag',
        unified: '1F1F8-1F1FE',
        shortName: 'flag-sy'
      },
      {
        name: 'Eswatini Flag',
        unified: '1F1F8-1F1FF',
        shortName: 'flag-sz'
      },
      {
        name: 'Tristan Da Cunha Flag',
        unified: '1F1F9-1F1E6',
        shortName: 'flag-ta'
      },
      {
        name: 'Turks & Caicos Islands Flag',
        unified: '1F1F9-1F1E8',
        shortName: 'flag-tc'
      },
      {
        name: 'Chad Flag',
        unified: '1F1F9-1F1E9',
        shortName: 'flag-td'
      },
      {
        name: 'French Southern Territories Flag',
        unified: '1F1F9-1F1EB',
        shortName: 'flag-tf'
      },
      {
        name: 'Togo Flag',
        unified: '1F1F9-1F1EC',
        shortName: 'flag-tg'
      },
      {
        name: 'Thailand Flag',
        unified: '1F1F9-1F1ED',
        shortName: 'flag-th'
      },
      {
        name: 'Tajikistan Flag',
        unified: '1F1F9-1F1EF',
        shortName: 'flag-tj'
      },
      {
        name: 'Tokelau Flag',
        unified: '1F1F9-1F1F0',
        shortName: 'flag-tk'
      },
      {
        name: 'Timor-Leste Flag',
        unified: '1F1F9-1F1F1',
        shortName: 'flag-tl'
      },
      {
        name: 'Turkmenistan Flag',
        unified: '1F1F9-1F1F2',
        shortName: 'flag-tm'
      },
      {
        name: 'Tunisia Flag',
        unified: '1F1F9-1F1F3',
        shortName: 'flag-tn'
      },
      {
        name: 'Tonga Flag',
        unified: '1F1F9-1F1F4',
        shortName: 'flag-to'
      },
      {
        name: 'Turkey Flag',
        unified: '1F1F9-1F1F7',
        shortName: 'flag-tr'
      },
      {
        name: 'Trinidad & Tobago Flag',
        unified: '1F1F9-1F1F9',
        shortName: 'flag-tt'
      },
      {
        name: 'Tuvalu Flag',
        unified: '1F1F9-1F1FB',
        shortName: 'flag-tv'
      },
      {
        name: 'Taiwan Flag',
        unified: '1F1F9-1F1FC',
        shortName: 'flag-tw'
      },
      {
        name: 'Tanzania Flag',
        unified: '1F1F9-1F1FF',
        shortName: 'flag-tz'
      },
      {
        name: 'Ukraine Flag',
        unified: '1F1FA-1F1E6',
        shortName: 'flag-ua'
      },
      {
        name: 'Uganda Flag',
        unified: '1F1FA-1F1EC',
        shortName: 'flag-ug'
      },
      {
        name: 'U.s. Outlying Islands Flag',
        unified: '1F1FA-1F1F2',
        shortName: 'flag-um'
      },
      {
        name: 'United Nations Flag',
        unified: '1F1FA-1F1F3',
        shortName: 'flag-un'
      },
      {
        name: 'United States Flag',
        unified: '1F1FA-1F1F8',
        keywords: ['united', 'states', 'america', 'flag', 'nation', 'country', 'banner'],
        shortNames: ['us', 'flag-us'],
        shortName: 'us'
      },
      {
        name: 'Uruguay Flag',
        unified: '1F1FA-1F1FE',
        shortName: 'flag-uy'
      },
      {
        name: 'Uzbekistan Flag',
        unified: '1F1FA-1F1FF',
        shortName: 'flag-uz'
      },
      {
        name: 'Vatican City Flag',
        unified: '1F1FB-1F1E6',
        shortName: 'flag-va'
      },
      {
        name: 'St. Vincent & Grenadines Flag',
        unified: '1F1FB-1F1E8',
        shortName: 'flag-vc'
      },
      {
        name: 'Venezuela Flag',
        unified: '1F1FB-1F1EA',
        shortName: 'flag-ve'
      },
      {
        name: 'British Virgin Islands Flag',
        unified: '1F1FB-1F1EC',
        shortName: 'flag-vg'
      },
      {
        name: 'U.s. Virgin Islands Flag',
        unified: '1F1FB-1F1EE',
        shortName: 'flag-vi'
      },
      {
        name: 'Vietnam Flag',
        unified: '1F1FB-1F1F3',
        shortName: 'flag-vn'
      },
      {
        name: 'Vanuatu Flag',
        unified: '1F1FB-1F1FA',
        shortName: 'flag-vu'
      },
      {
        name: 'Wallis & Futuna Flag',
        unified: '1F1FC-1F1EB',
        shortName: 'flag-wf'
      },
      {
        name: 'Samoa Flag',
        unified: '1F1FC-1F1F8',
        shortName: 'flag-ws'
      },
      {
        name: 'Kosovo Flag',
        unified: '1F1FD-1F1F0',
        shortName: 'flag-xk'
      },
      {
        name: 'Yemen Flag',
        unified: '1F1FE-1F1EA',
        shortName: 'flag-ye'
      },
      {
        name: 'Mayotte Flag',
        unified: '1F1FE-1F1F9',
        shortName: 'flag-yt'
      },
      {
        name: 'South Africa Flag',
        unified: '1F1FF-1F1E6',
        shortName: 'flag-za'
      },
      {
        name: 'Zambia Flag',
        unified: '1F1FF-1F1F2',
        shortName: 'flag-zm'
      },
      {
        name: 'Zimbabwe Flag',
        unified: '1F1FF-1F1FC',
        shortName: 'flag-zw'
      },
      {
        name: 'Crossed Flags',
        unified: '1F38C',
        keywords: ['japanese', 'nation', 'country', 'border'],
        shortName: 'crossed_flags'
      },
      {
        name: 'Chequered Flag',
        unified: '1F3C1',
        keywords: ['contest', 'finishline', 'race', 'gokart'],
        shortName: 'checkered_flag'
      },
      {
        name: 'Waving White Flag',
        unified: '1F3F3-FE0F',
        shortName: 'waving_white_flag'
      },
      {
        name: 'Rainbow Flag',
        unified: '1F3F3-FE0F-200D-1F308',
        shortName: 'rainbow-flag'
      },
      {
        name: 'Waving Black Flag',
        unified: '1F3F4',
        shortName: 'waving_black_flag'
      },
      {
        name: 'Pirate Flag',
        unified: '1F3F4-200D-2620-FE0F',
        keywords: ['skull', 'crossbones', 'flag', 'banner'],
        shortName: 'pirate_flag'
      },
      {
        name: 'England Flag',
        unified: '1F3F4-E0067-E0062-E0065-E006E-E0067-E007F',
        shortName: 'flag-england'
      },
      {
        name: 'Scotland Flag',
        unified: '1F3F4-E0067-E0062-E0073-E0063-E0074-E007F',
        shortName: 'flag-scotland'
      },
      {
        name: 'Wales Flag',
        unified: '1F3F4-E0067-E0062-E0077-E006C-E0073-E007F',
        shortName: 'flag-wales'
      },
      {
        name: 'Triangular Flag on Post',
        unified: '1F6A9',
        keywords: ['mark', 'milestone', 'place'],
        shortName: 'triangular_flag_on_post'
      }
    ]
  }
];

// List of emojis that we removed since they are not supported in native versions
// 263A-FE0F
// 1F9D1-200D-1F9B0
// 1F9D1-200D-1F9B1
// 1F9D1-200D-1F9B3
// 1F9D1-200D-1F9B2
// 1F9D1-200D-2695-FE0F
// 1F9D1-200D-1F393
// 1F9D1-200D-1F3EB
// 1F9D1-200D-2696-FE0F
// 1F9D1-200D-1F33E
// 1F9D1-200D-1F373
// 1F9D1-200D-1F527
// 1F9D1-200D-1F3ED
// 1F9D1-200D-1F4BC
// 1F9D1-200D-1F52C
// 1F9D1-200D-1F4BB
// 1F9D1-200D-1F3A4
// 1F9D1-200D-1F3A8
// 1F9D1-200D-2708-FE0F
// 1F9D1-200D-1F680
// 1F9D1-200D-1F692
// 1F9D1-200D-1F9AF
// 1F9D1-200D-1F9BC
// 1F9D1-200D-1F9BD
// 203C-FE0F
// 2049-FE0F
